// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/res/fonts/open-sans/OpenSans-Light-webfont.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/res/fonts/open-sans/OpenSans-Regular-webfont.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/res/fonts/open-sans/OpenSans-Semibold-webfont.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("/res/fonts/open-sans/OpenSans-Bold-webfont.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("/res/fonts/source-sans-pro/SourceSansPro-Light.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("/res/fonts/source-sans-pro/SourceSansPro-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("/res/fonts/source-sans-pro/SourceSansPro-SemiBold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("/res/fonts/source-sans-pro/SourceSansPro-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("/res/fonts/inter/Inter-Thin.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("/res/fonts/inter/Inter-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("/res/fonts/inter/Inter-Black.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("/res/fonts/montserrat/Montserrat-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("/res/fonts/montserrat/Montserrat-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("/res/fonts/montserrat/Montserrat-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("data:image/svg+xml;utf8,<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 40 40\" xml:space=\"preserve\"><path opacity=\"0.3\" fill=\"#fff\" d=\"M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z\"></path><path fill=\"#fff\" d=\"M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0 C22.32,8.481,24.301,9.057,26.013,10.047z\" transform=\"rotate%2839.9786 20 20%29\"><animateTransform attributeType=\"xml\" attributeName=\"transform\" type=\"rotate\" from=\"0 20 20\" to=\"360 20 20\" dur=\"0.7s\" repeatCount=\"indefinite\"></animateTransform></path></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" stroke-width=\"3\" viewBox=\"-1 -1 32 32\"><circle cx=\"15\" cy=\"15\" r=\"14.5\" stroke=\"rgba%28180,180,180,0.5%29\" fill=\"none\" /><line x1=\"5.8\" y1=\"24.2\" x2=\"24.2\" y2=\"5.8\" stroke=\"rgba%28180,180,180,0.5%29\" /></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"-1 -1 32 32\" ><polyline points=\"27.1,11 16,21 4.9,11 \" fill=\"none\" stroke=\"black\" stroke-width=\"3px\" /></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"-1 -1 32 32\" ><polyline points=\"5,20.9 16,11.1 27,20.9 \" fill=\"none\" stroke=\"black\" stroke-width=\"3px\" /></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" stroke-width=\"3\" viewBox=\"-1 -1 32 32\"><circle cx=\"15\" cy=\"15\" r=\"14.5\" stroke=\"rgba%28180,180,180,0.2%29\" fill=\"none\" /><line x1=\"5.8\" y1=\"24.2\" x2=\"24.2\" y2=\"5.8\" stroke=\"rgba%28180,180,180,0.2%29\" /></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path d=\"M19,4H5A3,3,0,0,0,2,7V17a3,3,0,0,0,3,3H19a3,3,0,0,0,3-3V7A3,3,0,0,0,19,4ZM5,18a1,1,0,0,1-1-1V14.58l3.3-3.29a1,1,0,0,1,1.4,0L15.41,18Zm15-1a1,1,0,0,1-1,1h-.77l-3.81-3.83.88-.88a1,1,0,0,1,1.4,0L20,16.58Zm0-3.24-1.88-1.87a3.06,3.06,0,0,0-4.24,0l-.88.88L10.12,9.89a3.06,3.06,0,0,0-4.24,0L4,11.76V7A1,1,0,0,1,5,6H19a1,1,0,0,1,1,1Z\"/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
body {
  --bg_body: rgb(255, 255, 255);
  --bg0: hsl(220, 5%, 95%);
  --bg1: hsl(220, 5%, 100%);
  --bg1_alt: hsl(220, 5%, 97%);
  --bg1_transparent: hsla(220, 5%, 100%, 0.5);
  --bg1_semitransparent: hsla(220, 5%, 100%, 0.85);
  --bg2: hsl(220, 5%, 95%);
  --bg2_transparent: hsla(220, 5%, 95%, 0.5);
  --bg2_semitransparent: hsla(220, 5%, 95%, 0.85);
  --bg3: hsl(220, 5%, 90%);
  --bg3_transparent: hsla(220, 5%, 85%, 0.3);
  --bg3_semitransparent: hsla(220, 5%, 85%, 0.85);
  --bg3_shadow: hsla(220, 5%, 50%, 0.4);
  --fg1: hsl(220, 20%, 5%);
  --fg2-hsl: 220 20% 20%;
  --fg2: hsl(var(--fg2-hsl));
  --fg3: hsl(220, 20%, 50%);
  --bginvalid: hsl(355, 67%, 80%);
  --fginvalid: hsl(355, 67%, 40%);
  --white-hsl: 0 0% 100%;
  --white: hsl(var(--white-hsl));
  --white2-hsl: 0 0% 90%;
  --white2: hsl(var(--white2-hsl));
  --gray-hsl: 0 0% 60%;
  --gray: hsl(var(--gray-hsl));
  --gray_transparent: hsla(var(--gray-hsl) / 80%);
  --black-hsl: 0 0% 0%;
  --black: hsl(var(--black-hsl));
  --blue-hsl: 220 100% 65%;
  --blue: hsl(var(--blue-hsl));
  --blue_transparent: hsla(200, 80%, 45%, 0.5);
  --lightblue-hsl: 186 79% 52%;
  --lightblue: hsl(var(--lightblue-hsl));
  --darkblue-hsl: 220 80% 20%;
  --darkblue: hsl(var(--darkblue-hsl));
  --green-hsl: 100 100% 28%;
  --green: hsl(var(--green-hsl));
  --green_transparent: hsla(var(--green-hsl) / 80%);
  --orange-hsl: 38 100% 44%;
  --orange: hsl(var(--orange-hsl));
  --orange_transparent: hsla(var(--orange-hsl) / 80%);
  --magenta-hsl: 300 67% 40%;
  --magenta: hsl(var(--magenta-hsl));
  --red-hsl: 355 67% 40%;
  --red: hsl(var(--red-hsl));
  --red_transparent: hsla(var(--red-hsl) / 80%);
  --disabled: 0.3;
  --notif: hsl(240, 15%, 20%);
  --input_bg: hsl(230, 100%, 99%);
  --input_border: hsl(226, 100%, 95%);
  --input_focused: hsl(58, 100%, 76%);
  --sidebar_width: 380px;
  --rightbar_width: 480px;
  --map_height: 320px;
  --base_width: 192px;
  --base_width_50: 96px;
  --base_height: 64px;
  --base_height_50: 32px;
  --base_height_25: 16px;
  --base_margin: 6px;
  --large_margin: 12px;
  --small_width: 144px;
  --small_width_50: 72px;
  --large_height: 128px;
  --small_height: 44px;
  --small_height_2: 42px;
  --small_height_50: 22px;
  --small_height_25: 11px;
  --small_margin: 4px;
  --base_shadow: 0px 0px var(--base_margin) var(--base_margin) rgba(128,128,128,0.5);
  --font_light: "opensans_light";
  --font_normal: "opensans_regular";
  --font_bold: "opensans_semibold";
}
body[theme=night] {
  --bg_body: rgb(128, 128, 128);
  --bg0: hsl(0, 0%, 8%);
  --bg1: hsl(0, 0%, 13%);
  --bg1_alt: hsl(0, 0%, 16%);
  --bg1_transparent: hsla(0, 0%, 13%, 0.5);
  --bg1_semitransparent: hsla(0, 0%, 13%, 0.85);
  --bg2: hsl(0, 0%, 18%);
  --bg3: hsl(0, 0%, 28%);
  --lightblue: hsl(186, 96%, 71%);
  --bg3_transparent: hsla(0, 0%, 28%, 0.3);
  --bg3_shadow: hsla(0, 0%, 50%, 0.4);
  --fg1: hsl(0, 0%, 85%);
  --fg2: hsl(0, 0%, 70%);
  --fg3: hsl(0, 0%, 40%);
  --bginvalid: hsl(355, 67%, 20%);
  --fginvalid: hsl(355, 67%, 65%);
  --notif: hsl(240, 15%, 50%);
  --input_bg: hsl(0, 1%, 29%);
  --input_border: hsl(0, 0%, 24%);
  --input_focused: hsl(48, 96%, 33%);
}
body[behavior=dashboard] {
  --font0: 22px;
  --font1: 20px;
  --font2: 16px;
  --font3: 13px;
  --font4: 11px;
  --font5: 9px;
}
body[behavior=tablet] {
  --font0: 20px;
  --font1: 16px;
  --font2: 14px;
  --font3: 12px;
  --font4: 10px;
  --font5: 9px;
}
body[behavior=phone] {
  --small_width: 96px;
  --small_width_50: 48px;
  --font0: 20px;
  --font1: 16px;
  --font2: 14px;
  --font3: 12px;
  --font4: 10px;
  --font5: 9px;
  --font_extrabold: opensans_bold;
}
body[behavior=desktop] {
  --sidebar_width: 360px;
  --rightbar_width: 320px;
  --map_height: 320px;
  --base_width: 128px;
  --base_width_50: 64px;
  --base_height: 36px;
  --base_height_50: 18px;
  --base_height_25: 9px;
  --base_margin: 4px;
  --large_margin: 8px;
  --small_width: 120px;
  --small_width_50: 60px;
  --large_height: 72px;
  --small_height: 30px;
  --small_height_2: 28px;
  --small_height_50: 16px;
  --small_height_25: 8px;
  --small_margin: 2px;
  --font0: 16px;
  --font1: 14px;
  --font2: 12px;
  --font3: 10px;
  --font4: 9px;
  --font5: 9px;
}

[styleset~=new] {
  --sidebar_bg: hsl(227, 17%, 27%);
  --sidebar_selected: hsl(226, 19%, 22%);
  --bg_body: hsl(195, 15%, 95%);
  --bg0: hsl(30, 20%, 95%);
  --bg1: hsl(30, 20%, 100%);
  --bg1_alt: hsl(30, 20%, 97%);
  --bg1_transparent: hsla(30, 20%, 100%, 0.5);
  --bg1_semitransparent: hsla(30, 20%, 100%, 0.85);
  --bg2: hsl(180, 13%, 97%);
  --bg3: hsl(192, 16%, 94%);
  --bg3_alt: hsl(193, 16%, 89%);
  --bg3_transparent: hsla(30, 20%, 85%, 0.3);
  --bg3_shadow: hsla(30, 20%, 50%, 0.4);
  --fg1: hsl(220, 20%, 5%);
  --fg2: hsl(220, 20%, 20%);
  --fg3: hsl(220, 20%, 50%);
  --bginvalid: hsl(355, 67%, 80%);
  --fginvalid: hsl(355, 67%, 40%);
  --disabled: 0.3;
  --notif: hsl(240, 15%, 22%);
  --white-hsl: 0 0% 100%;
  --white: hsl(var(--white-hsl));
  --white2-hsl: 0 0% 90%;
  --white2: hsl(var(--white2-hsl));
  --gray-hsl: 0 0% 60%;
  --gray: hsl(var(--gray-hsl));
  --gray_transparent: hsla(var(--gray-hsl) / 80%);
  --black-hsl: 0 0% 0%;
  --black: hsl(var(--black-hsl));
  --blue-hsl: 220 67% 60%;
  --blue: hsl(var(--blue-hsl));
  --blue_transparent: hsla(220, 67%, 60%, 0.5);
  --lightblue-hsl: 186 79% 52%;
  --lightblue: hsl(var(--lightblue-hsl));
  --darkblue-hsl: 220 80% 20%;
  --darkblue: hsl(var(--darkblue-hsl));
  --green-hsl: 100 100% 28%;
  --green: hsl(var(--green-hsl));
  --green_transparent: hsla(var(--green-hsl) / 80%);
  --orange-hsl: 35 100% 44%;
  --orange: hsl(var(--orange-hsl));
  --orange_transparent: hsla(var(--orange-hsl) / 80%);
  --magenta-hsl: 300 67% 40%;
  --magenta: hsl(var(--magenta-hsl));
  --red-hsl: 355 67% 40%;
  --red: hsl(var(--red-hsl));
  --red_transparent: hsla(var(--red-hsl) / 80%);
  --sidebar_width: 320px;
  --rightbar_width: 480px;
  --map_height: 320px;
  --base_width: 192px;
  --base_width_50: 96px;
  --base_height: 64px;
  --base_height_50: 32px;
  --base_height_25: 16px;
  --base_margin: 6px;
  --large_margin: 12px;
  --small_width: 144px;
  --small_width_50: 72px;
  --large_height: 128px;
  --small_height: 48px;
  --small_height_2: 46px;
  --small_height_50: 24px;
  --small_height_25: 12px;
  --small_margin: 4px;
  --font_light: "sanspro_light";
  --font_normal: "sanspro_regular";
  --font_semibold: "sanspro_semibold";
  --font_bold: "sanspro_bold";
}
[styleset~=new][theme=night] {
  --bg_body: rgb(128, 128, 128);
  --bg0: hsl(20, 10%, 8%);
  --bg1: hsl(20, 10%, 13%);
  --bg1_alt: hsl(20, 10%, 16%);
  --bg1_transparent: hsla(20, 10%, 13%, 0.5);
  --bg1_semitransparent: hsla(20, 10%, 13%, 0.85);
  --bg2: hsl(20, 10%, 18%);
  --bg3: hsl(20, 10%, 28%);
  --bg3_transparent: hsla(20, 10%, 28%, 0.3);
  --bg3_shadow: hsla(20, 10%, 50%, 0.4);
  --fg1: hsl(20, 10%, 85%);
  --fg2: hsl(20, 10%, 70%);
  --fg3: hsl(20, 10%, 40%);
  --bginvalid: hsl(355, 67%, 20%);
  --fginvalid: hsl(355, 67%, 65%);
  --notif: hsl(240, 15%, 50%);
}
[styleset~=new][behavior=dashboard] {
  --font0: 22px;
  --font1: 20px;
  --font2: 16px;
  --font3: 13px;
  --font4: 11px;
  --font5: 9px;
}
[styleset~=new][behavior=tablet] {
  --font0: 20px;
  --font1: 16px;
  --font2: 14px;
  --font3: 12px;
  --font4: 10px;
  --font5: 9px;
}
[styleset~=new][behavior=phone] {
  --small_width: 96px;
  --small_width_50: 48px;
  --font0: 20px;
  --font1: 16px;
  --font2: 14px;
  --font3: 12px;
  --font4: 10px;
  --font5: 9px;
}
[styleset~=new][behavior=desktop] {
  --sidebar_width: 340px;
  --rightbar_width: 320px;
  --map_height: 320px;
  --base_width: 128px;
  --base_width_50: 64px;
  --base_height: 36px;
  --base_height_50: 18px;
  --base_height_25: 9px;
  --base_margin: 2px;
  --large_margin: 8px;
  --small_width: 120px;
  --small_width_50: 60px;
  --large_height: 60px;
  --small_height: 24px;
  --small_height_2: 24px;
  --small_height_50: 12px;
  --small_height_25: 6px;
  --font0: 20px;
  --font1: 18px;
  --font2: 15px;
  --font3: 11px;
  --font4: 8px;
  --font5: 9px;
}

@font-face {
  font-family: "opensans_light";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "opensans_regular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "opensans_semibold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "opensans_bold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "sanspro_light";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("woff");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "sanspro_regular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("woff");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "sanspro_semibold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("woff");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "sanspro_bold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("woff");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "inter_light";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("woff");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "inter_regular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("woff");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "inter_bold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format("woff");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "montserrat_light";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("woff");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "montserrat_regular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format("woff");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "montserrat_bold";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format("woff");
  font-weight: normal;
  font-style: normal;
}
.resetAbsolute {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
}

.noselect {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

module[type=dock] {
  box-shadow: 0px 0px 8px 2px rgba(128, 128, 128, 0.5);
}

module[type=widget] {
  box-shadow: 0px 0px 8px 2px rgba(128, 128, 128, 0.5);
}

module[type=float] {
  box-shadow: 0px 0px 8px 2px rgba(128, 128, 128, 0.5);
}

::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}

.template#icons {
  background: #cde;
}

.template#icons svg {
  width: 128px;
  border: 1px solid #30f;
  margin: 10px;
}

.template#icons svg [stroke=fg] {
  stroke: #000;
}

.template#icons svg [stroke=bg] {
  stroke: #FFF;
}

.template#icons svg [fill=fg] {
  fill: #000;
}

.template#icons svg [fill=bg] {
  fill: #FFF;
}

.on {
  fill: #4faa22;
}

.off {
  fill: #aa222d;
}

.standby {
  fill: var(--fg2);
}

.rounded {
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.8;
}

body:not([print]) {
  position: absolute;
  margin: 0px;
  padding: 0px;
  top: 0px;
  bottom: 0px;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: var(--bg_body);
  color: var(--fg1);
  font-family: var(--font_normal);
  font-size: var(--font0);
}

body[print] > *:not(.print) {
  display: none;
}
body[print] > .print .mele-button[key="print.close"] {
  position: fixed;
  top: 8px;
  left: 8px;
}

@media print {
  body[print] .mele-button[key="print.close"] {
    display: none;
  }

  .mele-button[key=actioncancel] {
    display: none;
  }
}
.modal-preview {
  --max-image-height: 530px;
  background: rgba(0, 0, 0, 0.66) !important;
  padding-bottom: 60px;
}
.modal-preview > mele-wrapper {
  box-shadow: none !important;
  max-height: unset !important;
  min-width: unset !important;
  max-width: unset !important;
  background: none !important;
}
.modal-preview > mele-wrapper mele-body {
  max-width: 870px;
  background: none;
  align-items: center;
  justify-content: center;
}
.modal-preview > mele-wrapper mele-body .preview-vertical {
  width: 100%;
  height: auto;
  filter: drop-shadow(0px 0px 10px black);
  object-fit: contain;
}
.modal-preview > mele-wrapper mele-body .preview {
  filter: drop-shadow(0px 0px 10px black);
  max-width: 100%;
  display: block;
  height: auto;
  max-height: var(--max-image-height, 530px);
}
.modal-preview > mele-wrapper mele-body .loading {
  align-self: center;
  position: absolute;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  width: 40px;
  height: 40px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) !important;
  background-size: 100% !important;
  background-repeat: no-repeat;
}

.modal-preview:not(.arrows) > mele-wrapper > mele-footer-wrapper {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background: var(--gray);
}

.modal-preview.arrows > mele-wrapper > mele-footer-wrapper {
  position: absolute;
  bottom: 30%;
  left: 0;
  right: 0;
  top: 30%;
  width: 100%;
  justify-content: center;
}
.modal-preview.arrows > mele-wrapper > mele-footer-wrapper > mele-footer {
  border-top: none !important;
}
.modal-preview.arrows > mele-wrapper > mele-footer-wrapper > mele-footer .navigation {
  position: absolute;
  width: 100px;
  background: var(--gray);
  height: 100px;
  z-index: 999;
  border-radius: 50%;
}
.modal-preview.arrows > mele-wrapper > mele-footer-wrapper > mele-footer .navigation * {
  stroke: var(--white);
}
.modal-preview.arrows > mele-wrapper > mele-footer-wrapper > mele-footer .navigation.left {
  left: 5%;
}
.modal-preview.arrows > mele-wrapper > mele-footer-wrapper > mele-footer .navigation.right {
  right: 5%;
}

[behavior=desktop] .none.desktop {
  display: none;
}

[behavior=dashboard] .none.dashboard {
  display: none;
}

[behavior=tablet] .none.tablet {
  display: none;
}

[behavior=phone] .none.phone {
  display: none;
}

[hidden] {
  display: none !important;
}

[wait] {
  user-select: none !important;
  pointer-events: none !important;
}
[wait] wait {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: absolute;
  z-index: 9999;
  left: 0px;
  right: 0px;
  top: 0px;
  bottom: 0px;
  user-select: none !important;
  pointer-events: all !important;
  background-color: var(--bg1_transparent);
}
[wait] wait > mele-image {
  width: calc(var(--base_height) * 2);
  height: calc(var(--base_height) * 2);
}
[wait] wait > mele-text {
  font-family: var(--font_bold);
  font-size: var(--font0);
  color: var(--fg1);
}

/* GENERIC STYLING */
mele-text {
  user-select: none;
  font-size: var(--font2);
}

.mele-view[view] > mele-wrapper > mele-body-wrapper > mele-body > mele-text {
  flex-basis: 100%;
  text-align: center;
}

/* SPECIAL TREATMENT OF DIFFERENT TYPES */
mele-text.title {
  width: 100%;
  text-align: center;
  padding: 10px 0;
}

/* COLORING */
/* GENERIC STYLING */
mele-image {
  width: var(--base_height);
  height: var(--base_height);
  box-sizing: border-box;
  padding: var(--base_margin);
  text-align: center;
}
mele-image svg [stroke=fg] {
  stroke: var(--fg2);
}
mele-image svg [stroke=bg] {
  stroke: var(--bg1);
}
mele-image svg [fill=fg] {
  fill: var(--fg2);
}
mele-image svg [fill=bg] {
  fill: var(--bg1);
}
mele-image svg, mele-image img {
  max-width: 100%;
  max-height: 100%;
}

/* SPECIAL TREATMENT OF DIFFERENT TYPES */
mele-image[disabled] {
  opacity: var(--disabled);
}

/* COLORING */
.mele-image[icon] [stroke=fg] {
  stroke: var(--fg2);
}
.mele-image[icon] [fill=fg] {
  fill: var(--fg2);
}
.mele-image[icon] [stroke=bg] {
  stroke: none;
}
.mele-image[icon] [fill=bg] {
  fill: none;
}
.mele-image[icon].color-red {
  background: var(--red);
}
.mele-image[icon].color-green {
  background: var(--green);
}
.mele-image[icon].color-orange {
  background: var(--orange);
}
.mele-image[icon].color-blue {
  background: var(--blue);
}
.mele-image[icon].color-magenta {
  background: var(--magenta);
}
.mele-image[icon].color-gray {
  background: var(--gray);
}
.mele-image[icon].color-semi {
  background: var(--gray_transparent);
}
.mele-image[icon][class*=color-] [stroke=fg] {
  stroke: var(--white);
}
.mele-image[icon][class*=color-] [fill=fg] {
  fill: var(--white);
}
.mele-image[icon].color-inverse {
  background: var(--fg1);
  color: var(--bg1);
}
.mele-image[icon].color-fill {
  background: var(--bg1);
  color: var(--fg1);
}
.mele-image[icon].color-input {
  background: var(--bg2);
}
.mele-image[icon].color-input [stroke=fg] {
  stroke: var(--fg2);
}
.mele-image[icon].color-input [fill=fg] {
  fill: var(--fg2);
}

.button-wrapper {
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  height: var(--base_height);
  min-width: var(--base_height);
  cursor: pointer;
  margin: var(--base_margin);
  position: relative;
  /* COLORING */
  color: var(--fg2);
}
.button-wrapper::before {
  position: absolute;
  left: 0px;
  content: "";
  width: 5px;
  height: 100%;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}
.button-wrapper .button-labels {
  user-select: none;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  order: 20;
  padding: 0px var(--base_margin);
}
.button-wrapper .button-labels .button-label {
  font-size: var(--font2);
  text-transform: uppercase;
}
.button-wrapper .button-labels .button-secondary-label {
  font-size: var(--font3);
}
.button-wrapper .button-icon {
  display: flex;
  width: var(--base_height);
  height: var(--base_height);
  justify-content: center;
  align-items: center;
}
.button-wrapper .button-icon:empty {
  display: none;
}
.button-wrapper .button-icon svg,
.button-wrapper .button-icon img {
  width: var(--base_height_50);
  height: var(--base_height_50);
}
.button-wrapper .button-icon.left {
  order: 10;
}
.button-wrapper .button-icon.right {
  order: 30;
}
.button-wrapper[disabled] {
  opacity: var(--disabled);
  cursor: not-allowed;
}
.button-wrapper[type=none] {
  display: none;
}
.button-wrapper[type=action] {
  width: var(--base_width);
  background: var(--bg3);
  border-radius: 5px;
}
.button-wrapper[type=actionbar], .button-wrapper[type=back] {
  width: var(--small_width);
  height: var(--small_height);
  background: var(--bg3);
  border-radius: 5px;
  margin: 3px 6px;
}
.button-wrapper[type=actionbar] .button-labels .button-label, .button-wrapper[type=back] .button-labels .button-label {
  font-size: var(--font2);
}
.button-wrapper[type=actionbar] .button-labels .button-secondary-label, .button-wrapper[type=back] .button-labels .button-secondary-label {
  font-size: var(--font4);
}
.button-wrapper[type=actionbar] .button-icon, .button-wrapper[type=back] .button-icon {
  width: var(--small_height);
  height: var(--small_height);
}
.button-wrapper[type=actionbar] .button-icon svg,
.button-wrapper[type=actionbar] .button-icon img, .button-wrapper[type=back] .button-icon svg,
.button-wrapper[type=back] .button-icon img {
  width: var(--small_height_50);
  height: var(--small_height_50);
}
.button-wrapper[type=actionbar][selected], .button-wrapper[type=back][selected] {
  background: var(--blue);
  color: var(--white);
}
.button-wrapper[type=actionbar][selected] [stroke=fg], .button-wrapper[type=back][selected] [stroke=fg] {
  stroke: var(--white);
}
.button-wrapper[type=actionbar][selected] [fill=fg], .button-wrapper[type=back][selected] [fill=fg] {
  fill: var(--white);
}
.button-wrapper[type=actionbar][selected] [stroke=bg], .button-wrapper[type=back][selected] [stroke=bg] {
  stroke: none;
}
.button-wrapper[type=actionbar][selected] [fill=bg], .button-wrapper[type=back][selected] [fill=bg] {
  fill: none;
}
.button-wrapper[type=actionbar][selected] .button-secondary-label, .button-wrapper[type=back][selected] .button-secondary-label {
  color: var(--white2);
}
.button-wrapper[type=actionbar][selected]:not([disabled]):hover, .button-wrapper[type=back][selected]:not([disabled]):hover {
  background: var(--blue);
}
.button-wrapper[type=action].color-red, .button-wrapper[type=actionbar].color-red {
  background: hsl(var(--red-hsl)/20%);
}
.button-wrapper[type=action].color-redred, .button-wrapper[type=actionbar].color-redred {
  background: hsl(var(--red-hsl)/90%);
  color: var(--white);
}
.button-wrapper[type=action].color-redred [stroke=fg], .button-wrapper[type=actionbar].color-redred [stroke=fg] {
  stroke: var(--white);
}
.button-wrapper[type=action].color-green, .button-wrapper[type=actionbar].color-green {
  background: hsl(var(--green-hsl)/20%);
}
.button-wrapper[type=action].color-orange, .button-wrapper[type=actionbar].color-orange {
  background: hsl(var(--orange-hsl)/20%);
}
.button-wrapper[type=action].color-blue, .button-wrapper[type=actionbar].color-blue {
  background: hsl(var(--blue-hsl)/20%);
}
.button-wrapper[type=action].color-magenta, .button-wrapper[type=actionbar].color-magenta {
  background: hsl(var(--magenta-hsl)/20%);
}
.button-wrapper[type=action].color-gray, .button-wrapper[type=actionbar].color-gray {
  background: hsl(var(--gray-hsl)/20%);
}
.button-wrapper[type=toolbar] {
  margin: 0px;
}
.button-wrapper[type=toolbar]::before {
  display: none;
}
.button-wrapper[type=toolbar][key=geochange] {
  height: var(--small_height);
}
.button-wrapper[type=toolbar][selected] {
  background: var(--blue);
  color: var(--white);
}
.button-wrapper[type=toolbar][selected] [stroke=fg] {
  stroke: var(--white);
}
.button-wrapper[type=toolbar][selected] [fill=fg] {
  fill: var(--white);
}
.button-wrapper[type=toolbar][selected] [stroke=bg] {
  stroke: none;
}
.button-wrapper[type=toolbar][selected] [fill=bg] {
  fill: none;
}
.button-wrapper[type=toolbar][selected] .button-secondary-label {
  color: var(--white2);
}
.button-wrapper[type=toggle] {
  width: auto;
  height: var(--small_height);
  border: 1px solid var(--input_border);
  border-radius: 5px;
  margin: 3px 6px;
}
.button-wrapper[type=toggle][selected] {
  background: var(--blue);
  color: var(--white);
}
.button-wrapper[type=toggle][selected] [stroke=fg] {
  stroke: var(--white);
}
.button-wrapper[type=toggle][selected] [fill=fg] {
  fill: var(--white);
}
.button-wrapper[type=toggle][selected] [stroke=bg] {
  stroke: none;
}
.button-wrapper[type=toggle][selected] [fill=bg] {
  fill: none;
}
.button-wrapper[type=toggle][selected] .button-secondary-label {
  color: var(--white2);
}
.button-wrapper[type=toggle] .button-labels .button-label {
  font-size: var(--font3);
}
.button-wrapper[type=toggle] .button-labels .button-secondary-label {
  font-size: var(--font4);
}
.button-wrapper[type=icon] {
  width: var(--base_height_50);
  min-width: var(--base_height_50);
  height: var(--base_height_50);
  margin: 0px;
  flex: initial;
}
.button-wrapper[type=icon]::before {
  display: none;
}
.button-wrapper[type=icon] .button-labels {
  display: none;
}
.button-wrapper[type=icon] .button-icon {
  width: var(--base_height_50);
  height: var(--base_height_50);
}
.button-wrapper[type=icon] .button-icon svg,
.button-wrapper[type=icon] .button-icon img {
  width: var(--base_height_50);
  height: var(--base_height_50);
}
.button-wrapper[type=iconmini] {
  width: var(--small_height_2);
  min-width: var(--small_height_2);
  height: var(--small_height_2);
  border-width: 0px;
  margin: 0px;
  flex: initial;
}
.button-wrapper[type=iconmini]::before {
  display: none;
}
.button-wrapper[type=iconmini] .button-labels {
  display: none;
}
.button-wrapper[type=iconmini] .button-icon {
  width: var(--small_height_2);
  height: var(--small_height_2);
}
.button-wrapper[type=iconmini] .button-icon > svg,
.button-wrapper[type=iconmini] .button-icon > img {
  width: var(--base_height_50);
  height: var(--base_height_50);
}
.button-wrapper[type=paging] {
  margin: 0px;
}
.button-wrapper[type=paging][selected] {
  background: var(--blue);
  color: var(--white);
}
.button-wrapper[type=item] {
  margin: 0px;
  padding-left: var(--base_margin);
}
.button-wrapper[type=item] .button-labels {
  align-items: flex-start;
}
.button-wrapper[type=applogo] {
  margin: 0px;
}
.button-wrapper[type=radarhit], .button-wrapper[type=radarhitinprogress] {
  width: 200px;
  height: 64px;
  background: var(--bg1);
  margin: 4px;
  border-radius: 8px;
  border: none;
}
.button-wrapper[type=radarhit] .button-labels, .button-wrapper[type=radarhitinprogress] .button-labels {
  flex-direction: row;
  justify-content: flex-start;
}
.button-wrapper[type=radarhit] .button-labels .button-label, .button-wrapper[type=radarhitinprogress] .button-labels .button-label {
  flex: 0 0 auto;
  display: flex;
  border-radius: 50%;
  border: 5px solid #a00;
  width: 48px;
  height: 48px;
  justify-content: center;
  align-items: center;
  font-family: var(--font_bold);
  font-size: 24px;
  margin: 0px 8px 0px 4px;
}
.button-wrapper[type=radarhit] .button-labels .button-secondary-label, .button-wrapper[type=radarhitinprogress] .button-labels .button-secondary-label {
  font-family: var(--font_bold);
  font-size: 20px;
}
.button-wrapper[type=radarhit] .button-icon, .button-wrapper[type=radarhitinprogress] .button-icon {
  width: 48px;
}
.button-wrapper[type=radarhit] .button-icon [stroke=fg], .button-wrapper[type=radarhitinprogress] .button-icon [stroke=fg] {
  stroke: var(--gray);
}
.button-wrapper[type=radarhitinprogress] {
  opacity: 0.5;
}
.button-wrapper[type=radarhitinprogress] .button-labels .button-secondary-label {
  font-family: Courier;
  font-size: 20px;
  width: 0px;
  overflow: hidden;
  white-space: nowrap;
  animation: ellipsis steps(4, end) 800ms infinite;
}
@keyframes ellipsis {
  to {
    width: 50px;
  }
}
.button-wrapper [stroke=fg] {
  stroke: var(--fg2);
}
.button-wrapper [fill=fg] {
  fill: var(--fg2);
}
.button-wrapper [stroke=bg] {
  stroke: var(--bg1);
}
.button-wrapper [fill=bg] {
  fill: var(--bg1);
}
.button-wrapper .button-secondary-label {
  color: var(--fg3);
}
.button-wrapper:not([type*=applogo]):not([type*=action]):not([type=marker]).color-red {
  background: var(--red);
}
.button-wrapper:not([type*=applogo]):not([type*=action]):not([type=marker]).color-green {
  background: var(--green);
}
.button-wrapper:not([type*=applogo]):not([type*=action]):not([type=marker]).color-orange {
  background: var(--orange);
}
.button-wrapper:not([type*=applogo]):not([type*=action]):not([type=marker]).color-blue {
  background: var(--blue);
}
.button-wrapper:not([type*=applogo]):not([type*=action]):not([type=marker]).color-magenta {
  background: var(--magenta);
}
.button-wrapper:not([type*=applogo]):not([type*=action]):not([type=marker]).color-gray {
  background: var(--gray);
}
.button-wrapper:not([type*=applogo]):not([type*=action]):not([type=marker]).color-semi {
  background: var(--gray_transparent);
}
.button-wrapper:not([type*=applogo]):not([type*=action]):not([type=marker])[class*=color-] {
  color: var(--white);
}
.button-wrapper:not([type*=applogo]):not([type*=action]):not([type=marker])[class*=color-] [stroke=fg] {
  stroke: var(--white);
}
.button-wrapper:not([type*=applogo]):not([type*=action]):not([type=marker])[class*=color-] [fill=fg] {
  fill: var(--white);
}
.button-wrapper:not([type*=applogo]):not([type*=action]):not([type=marker])[class*=color-] [stroke=bg] {
  stroke: none;
}
.button-wrapper:not([type*=applogo]):not([type*=action]):not([type=marker])[class*=color-] [fill=bg] {
  fill: none;
}
.button-wrapper:not([type*=applogo]):not([type*=action]):not([type=marker])[class*=color-] .button-secondary-label {
  color: var(--white2);
}
.button-wrapper:not([type*=applogo]):not([type*=action]):not([type=marker]).color-inverse {
  background: var(--fg1);
  color: var(--bg1);
}
.button-wrapper:not([type*=applogo]):not([type*=action]):not([type=marker]).color-fill {
  background: var(--bg1);
  color: var(--fg1);
}
.button-wrapper:not([type*=applogo]):not([type*=action]):not([type=marker]).color-input {
  background: var(--bg2);
  color: var(--fg2);
}
.button-wrapper:not([type*=applogo]):not([type*=action]):not([type=marker]).color-input [stroke=fg] {
  stroke: var(--fg2);
}
.button-wrapper:not([type*=applogo]):not([type*=action]):not([type=marker]).color-input [fill=fg] {
  fill: var(--fg2);
}
.button-wrapper:not([type*=applogo]):not([type*=action]):not([type=marker]).color-input [stroke=bg] {
  stroke: none;
}
.button-wrapper:not([type*=applogo]):not([type*=action]):not([type=marker]).color-input [fill=bg] {
  fill: none;
}
.button-wrapper:not([type*=applogo]):not([type*=action]):not([type=marker]).color-input .button-secondary-label {
  color: var(--fg2);
}
.button-wrapper[action=submit] {
  border-color: var(--fg1);
  color: var(--fg1);
}
.button-wrapper[action=submit] [stroke=fg] {
  stroke: var(--fg1);
}
.button-wrapper[action=submit] [fill=fg] {
  fill: var(--fg1);
}
.button-wrapper[action=submit] .button-label {
  font-family: var(--font_bold);
}
.button-wrapper.color-red::before {
  background: var(--red);
}
.button-wrapper.color-green::before {
  background: var(--green);
}
.button-wrapper.color-orange::before {
  background: var(--orange);
}
.button-wrapper.color-blue::before {
  background: var(--blue);
}
.button-wrapper.color-magenta::before {
  background: var(--magenta);
}
.button-wrapper.color-gray::before {
  background: var(--gray);
}
.button-wrapper:focus {
  outline: none;
}
.button-wrapper:not([disabled]) {
  background-position: center;
  transition: background 0.5s;
}
.button-wrapper:not([disabled]):not([selected]):hover {
  background: var(--bg3_transparent) radial-gradient(circle, transparent 1%, var(--bg3_transparent) 1%) center/15000%;
}
.button-wrapper:not([disabled]):active {
  background-color: var(--bg3);
  background-size: 100%;
  transition: background 0s;
}
.button-wrapper svg text {
  user-select: none;
}

.item-wrapper {
  display: flex;
  margin: 0;
  height: auto;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  position: relative;
  cursor: pointer;
  /* SPECIAL TREATMENT OF DIFFERENT TYPES */
}
.item-wrapper::before {
  position: absolute;
  left: 0px;
  content: "";
  width: 5px;
  height: 100%;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}
.item-wrapper .item-labels {
  flex: 1;
  order: 20;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px var(--base_margin);
  user-select: none;
}
.item-wrapper .item-labels .item-label {
  order: 100;
  display: flex;
  align-items: center;
  flex: 1;
  text-align: left;
  font-size: var(--font2);
  color: var(--fg1);
  text-transform: uppercase;
}
.item-wrapper .item-labels .item-secondary-label {
  order: 101;
  display: flex;
  flex: 1;
  text-align: left;
  font-size: var(--font3);
  color: var(--fg2);
}
.item-wrapper .item-value {
  order: 25;
  font-size: var(--font2);
  padding: 0px 8px;
}
.item-wrapper .item-value:empty {
  display: none;
}
.item-wrapper .item-icon {
  display: flex;
  width: var(--base_height);
  height: var(--base_height);
  justify-content: center;
  align-items: center;
}
.item-wrapper .item-icon:empty {
  display: none;
}
.item-wrapper .item-icon svg, .item-wrapper .item-icon img {
  width: var(--base_height_50);
  height: var(--base_height_50);
}
.item-wrapper .item-icon.left {
  order: 10;
}
.item-wrapper .item-icon.right {
  order: 30;
}
.item-wrapper .item-icon.remove {
  display: none;
}
.item-wrapper .item-icon.collapse {
  order: 40;
}
.item-wrapper[indent="1"] > .item-labels * {
  padding-left: 4%;
}
.item-wrapper[indent="2"] > .item-labels * {
  padding-left: 8%;
}
.item-wrapper[indent="3"] > .item-labels * {
  padding-left: 12%;
}
.item-wrapper[indent="4"] > .item-labels * {
  padding-left: 16%;
}
.item-wrapper [stroke=fg] {
  stroke: var(--fg2);
}
.item-wrapper [fill=fg] {
  fill: var(--fg2);
}
.item-wrapper [stroke=bg] {
  stroke: var(--bg1);
}
.item-wrapper [fill=bg] {
  fill: var(--bg1);
}
.item-wrapper.color-red::before {
  background: var(--red);
}
.item-wrapper.color-green::before {
  background: var(--green);
}
.item-wrapper.color-orange::before {
  background: var(--orange);
}
.item-wrapper.color-blue::before {
  background: var(--blue);
}
.item-wrapper.color-magenta::before {
  background: var(--magenta);
}
.item-wrapper.color-gray::before {
  background: var(--gray);
}

.input-wrapper {
  --small-height: var(--small_height);
  --input-bg: var(--input_bg);
  --input-bg-focused: var(--input_focused);
  --input-border: 1px solid var(--input_border);
  --label-color: var(--blue);
  --value-color: var(--fg1);
  --input-min-w: 100px;
  --before-after-w: minmax(var(--base_height_50), var(--small-height));
  --image-height: 200px;
  --input-padding: 10px;
  --input-width: 100%;
  --image-clear-display: block;
  display: grid;
  grid-auto-columns: minmax(var(--input-min-w), 1fr);
  width: 100%;
  padding: var(--input-padding);
  grid-template-areas: "value";
  grid-row-gap: 2px;
  touch-action: manipulation;
}
.input-wrapper .input-labels {
  user-select: none;
  display: grid;
  grid-area: labels;
  font-size: var(--font3);
  letter-spacing: 1px;
  font-family: var(--font_bold);
  color: var(--label-color);
  text-transform: uppercase;
  align-content: start;
}
.input-wrapper .input-value {
  grid-area: value;
  display: grid;
  width: var(--input-width);
  grid-template-areas: "wrapper";
}
.input-wrapper mele-value-wrapper {
  grid-area: wrapper;
  display: grid;
  width: var(--input-width);
  grid-template-areas: "content";
  grid-template-columns: 1fr;
}
.input-wrapper[after]:not([after=""]) mele-value-wrapper {
  grid-template-areas: "content after";
  grid-template-columns: 1fr var(--before-after-w);
  align-items: baseline;
}
.input-wrapper[after][readonly] mele-value-wrapper {
  display: flex;
}
.input-wrapper[before]:not([before=""]) mele-value-wrapper {
  grid-template-areas: "before content";
  grid-template-columns: var(--before-after-w) 1fr;
  align-items: baseline;
}
.input-wrapper[before]:not([before=""]) [after]:not([after=""]) mele-value-wrapper {
  grid-template-areas: "before content after";
  grid-template-columns: var(--before-after-w) 1fr var(--before-after-w);
}
.input-wrapper:not([rows]) mele-value-content textarea {
  min-height: var(--large_height);
}
.input-wrapper:not([rows]).small-height textarea {
  min-height: var(--small-height);
}
.input-wrapper[readonly]:not(.equalize) mele-value-content {
  padding: 0;
  min-height: calc(var(--small-height) / 2);
}
.input-wrapper[readonly]:not(.equalize) mele-value-content mele-item {
  min-height: calc(var(--small-height) / 2) !important;
}
.input-wrapper[readonly] mele-value-wrapper mele-value-content, .input-wrapper:not([label]):not([value]) {
  border: none;
}
.input-wrapper[readonly] .input-value > mele-value-wrapper > mele-value-content {
  width: auto;
  word-break: break-word;
}
.input-wrapper[readonly] .input-upload {
  display: none;
}
.input-wrapper[disabled] {
  cursor: not-allowed !important;
  pointer-events: none !important;
}
.input-wrapper[disabled] .input-value {
  opacity: var(--disabled);
}
.input-wrapper[disabled] mele-value-error,
.input-wrapper[disabled] mele-value-conflict {
  display: none;
}
.input-wrapper[focused] .editfield {
  color: var(--value-color);
  border-radius: 4px;
  border: 1px solid var(--bg3);
  resize: none;
  outline: none;
  transition: all 0.1s ease;
  box-shadow: 0 0 4px var(--blue);
  border-color: var(--blue);
}
.input-wrapper[invalid]:not([readonly]) .editfield {
  background: var(--bginvalid) !important;
  border-color: var(--red) !important;
  color: var(--fginvalid);
}
.input-wrapper[invalid]:not([readonly]) .editfield:focus {
  transition: all 0.1s ease;
  box-shadow: 0 0 5px var(--red);
  border-color: var(--red);
}
.input-wrapper:not([value]) .button-wrapper[key=clear], .input-wrapper[disabled] .button-wrapper[key=clear] {
  display: none;
}
.input-wrapper:not([value]) svg.image-clear, .input-wrapper[disabled] svg.image-clear {
  display: none;
}
.input-wrapper[readonly] .image-clear {
  display: none;
}
.input-wrapper[label] {
  grid-template-areas: "labels" "value";
}
.input-wrapper[help] .input-value {
  grid-template-areas: "wrapper" "help";
}
.input-wrapper[invalid][formaterror] .input-value {
  grid-template-areas: "wrapper" "error";
}
.input-wrapper[invalid][help][formaterror] .input-value {
  grid-template-areas: "wrapper" "help" "error";
}
.input-wrapper[type=users] .mele-list, .input-wrapper[type=sdropdown] .mele-dropdown, .input-wrapper[type=slookup] .mele-dropdown {
  background: var(--input-bg);
  border: var(--input-border);
  border-radius: 4px;
}
.input-wrapper[type=users][invalid] .mele-list, .input-wrapper[type=sdropdown][invalid] .mele-dropdown, .input-wrapper[type=slookup][invalid] .mele-dropdown {
  background: var(--bginvalid);
  border: var(--fginvalid);
}
.input-wrapper.small {
  grid-auto-columns: 1fr;
  --input-padding: 0;
}
.input-wrapper.small mele-value-content > span {
  justify-content: center;
  min-height: var(--small_height_50);
  display: flex;
}
.input-wrapper.small .check {
  width: var(--small_height_50);
  height: var(--small_height_50);
  padding: 0px;
  flex: 1;
}
.input-wrapper .check {
  width: var(--small_height);
  height: var(--small_height);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0px;
}
.input-wrapper .check svg, .input-wrapper .check img {
  width: var(--small_height);
  height: var(--small_height);
}
.input-wrapper[type=dropdown][readonly] .list-view .item-wrapper {
  height: calc(var(--small-height) / 2) !important;
  height: calc(var(--small-height) / 2) !important;
}
.input-wrapper[type=dropdown][readonly] .list-view .item-wrapper .input-labels {
  align-items: flex-start !important;
}
.input-wrapper[type=image] input {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}
.input-wrapper[split] {
  --input-min-w: auto;
  grid-column-gap: 2px;
}
.input-wrapper[split] .input-labels > *,
.input-wrapper[split] .input-value > * {
  word-wrap: break-word;
}
.input-wrapper[split] .input-labels > * {
  letter-spacing: 0;
}
.input-wrapper[split="0:1"] {
  grid-template-areas: "value";
}
.input-wrapper[split="0:1"] .input-labels {
  display: none;
}
.input-wrapper[split="1:0"] {
  grid-template-areas: "labels";
}
.input-wrapper[split="1:0"] .input-value {
  display: none;
}
.input-wrapper[split="1:1"] {
  grid-template-areas: "labels value";
}
.input-wrapper[split="1:2"] {
  grid-template-areas: "labels value value";
}
.input-wrapper[split="2:1"] {
  grid-template-areas: "labels labels value";
}
.input-wrapper[split="1:3"] {
  grid-template-areas: "labels value value value";
}
.input-wrapper[split="1:4"] {
  grid-template-areas: "labels value value value value";
}
.input-wrapper[split="1:5"] {
  grid-template-areas: "labels value value value value value";
}
.input-wrapper[split="3:1"] {
  grid-template-areas: "labels labels labels value";
}
.input-wrapper[split=none] {
  grid-template-areas: "labels" "value";
}
.input-wrapper[type=group] {
  width: auto !important;
}
.input-wrapper[type=rotary] mele-value-content {
  align-items: center;
}
.input-wrapper[type=image]:not([value]) img {
  display: var(--image-clear-display);
  min-height: var(--image-height);
  background-color: transparent;
  background-repeat: no-repeat;
  background-position: center;
  background-size: calc(var(--image-height) * 0.9);
  background-image: var(url(${___CSS_LOADER_URL_REPLACEMENT_15___}));
}
.input-wrapper[type=image] mele-value-content {
  grid-template-rows: 1fr;
  color: var(--input_bg);
}
.input-wrapper[type=geoshape] mele-value-content > mele-map {
  min-height: 300px;
  z-index: 10;
}
.input-wrapper[type=geoshape] mele-value-content > mele-text {
  text-align: center;
  position: absolute;
  top: 0px;
  left: 5px;
  right: 5px;
  z-index: 20;
  background: var(--bg1_semitransparent);
  margin: var(--base_margin) var(--base_height);
  padding: var(--base_margin);
  border-radius: var(--base_margin);
}
.input-wrapper[type=geoshape] mele-value-content > mele-text:empty {
  display: none;
}
.input-wrapper[type=yesno] .list-view .item-wrapper {
  flex: 1;
  height: var(--small-height) !important;
}
.input-wrapper[type=yesno] .list-view .item-wrapper:first-child {
  border-radius: 4px 0 0 4px !important;
}
.input-wrapper[type=yesno] .list-view .item-wrapper:last-of-type {
  border-radius: 0 4px 4px 0 !important;
}
.input-wrapper[type=check] mele-value-content {
  border: none;
}
.input-wrapper[type=checkmark] {
  width: var(--small_height_2);
  min-width: var(--small_height_2);
  height: var(--small_height_2);
  border-width: 0px;
  margin: 0px;
  flex: initial;
}
.input-wrapper[type=checkmark]::before {
  display: none;
}
.input-wrapper[type=checkmark] .input-labels {
  display: none;
}
.input-wrapper[type=checkmark] .input-image {
  width: var(--small_height_2);
  height: var(--small_height_2);
}
.input-wrapper[type=checkmark] .input-image svg,
.input-wrapper[type=checkmark] .input-image img {
  width: var(--base_height_50);
  height: var(--base_height_50);
}
.input-wrapper[type=empty] {
  display: none;
}
.input-wrapper[type=invisible] {
  visibility: hidden !important;
}
.input-wrapper[type=grid] mele-value-wrapper, .input-wrapper[type=grid] mele-value-content {
  border: none;
}
.input-wrapper[type=buttonrange] mele-value-wrapper {
  border: none;
}
.input-wrapper[type=buttonrange] mele-value-content {
  grid-template-columns: repeat(5, var(--base_height));
  grid-column-gap: 10px;
}
.input-wrapper[type=buttonrange] mele-value-content .button-wrapper {
  width: var(--base_height);
  margin: 0;
}
.input-wrapper[type=buttonrange] mele-range {
  display: flex;
  justify-content: center;
  align-items: center;
}
.input-wrapper[readonly][type=text] > mele-value > mele-value-wrapper > mele-value-content > span, .input-wrapper[readonly][type=richtext] > mele-value > mele-value-wrapper > mele-value-content > span {
  white-space: pre-wrap;
}
.input-wrapper[type=grid]:not([readonly]) mele-value-content .list-view .item-wrapper {
  flex: 1;
  min-height: var(--small-height) !important;
  border: var(--input-border) !important;
  padding: 0 !important;
}
.input-wrapper[type=grid]:not([readonly]) mele-value-content .list-view .item-wrapper:last-of-type {
  border-bottom-right-radius: var(--base_margin);
  border-top-right-radius: var(--base_margin);
  border-right: var(--input-border) !important;
}
.input-wrapper[type=grid]:not([readonly]) mele-value-content .list-view .item-wrapper:first-of-type {
  border-bottom-left-radius: var(--base_margin);
  border-top-left-radius: var(--base_margin);
}
.input-wrapper[type=grid]:not([readonly]) mele-value-content .list-view .item-wrapper[selected] {
  border: 1px solid var(--blue) !important;
}
.input-wrapper[type=slider] .input-value {
  overflow: hidden;
}
.input-wrapper[type=slider] mele-value-content {
  max-width: 100%;
  overflow-x: scroll;
  display: block;
  padding-left: 50%;
  padding-right: 50%;
  background: var(--input-bg);
}
.input-wrapper[type=slider] .mele-list {
  pointer-events: none;
  width: auto !important;
  display: inline-flex;
  vertical-align: middle;
  margin-left: calc(var(--small_width_50) * -1);
}
.input-wrapper[type=slider] .mele-list .list-view > mele-body-wrapper mele-body {
  flex-wrap: nowrap;
}
.input-wrapper[type=slider] .mele-list .list-view > mele-body-wrapper mele-body .input-wrapper {
  width: var(--small_width) !important;
  height: var(--small_height) !important;
  margin: 0px !important;
  padding: 0px !important;
  white-space: nowrap !important;
}
.input-wrapper[type=slider] .mele-list .list-view > mele-body-wrapper mele-body .input-wrapper[selected] {
  background: none !important;
}
.input-wrapper[type=slider] .mele-list .list-view > mele-body-wrapper mele-body .input-wrapper[selected] .input-labels .input-label,
.input-wrapper[type=slider] .mele-list .list-view > mele-body-wrapper mele-body .input-wrapper[selected] .input-labels .input-secondary-label {
  color: var(--value-color) !important;
  font-family: var(--font_bold);
}
.input-wrapper[type=slist] sep::before {
  content: ", ";
}
.input-wrapper[type=images] mele-uploader {
  --uploader-body-height: auto;
}
.input-wrapper[type=images] mele-uploader mele-file-info {
  display: none;
}
.input-wrapper[type=files][auto] mele-uploader .button-wrapper[key=upload] {
  max-width: 64px;
}
.input-wrapper[type=files][auto] mele-uploader mele-wrapper > mele-body-wrapper {
  display: none !important;
}
.input-wrapper[type=file]:not([readonly]) .files-wrapper {
  border: 1px solid var(--bg3);
  background: var(--bg2);
}
.input-wrapper[type=file]:not([readonly]) .files-wrapper:empty:before {
  line-height: var(--small_height);
  content: attr(label);
  display: flex;
  justify-content: center;
}
.input-wrapper[type=file] input {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}
.input-wrapper[type=file] .files-wrapper {
  display: flex;
  flex-direction: column;
  margin: 3px 6px;
  border-radius: 5px;
  list-style: none;
  min-height: var(--small_height);
  padding: 0 0 0 5px;
  justify-content: center;
}
.input-wrapper[type=file] .files-wrapper .input-file {
  position: relative;
  display: flex;
  line-height: calc( var(--font3) * 2);
}
.input-wrapper[type=file] .files-wrapper .input-file a.file {
  flex: 1;
  display: flex;
  align-self: center;
  font-size: var(--font3);
}
.input-wrapper[type=file] .files-wrapper .input-file a.file strong {
  padding-left: 3px;
}
.input-wrapper[type=file] .files-wrapper .input-file .remove-file {
  display: flex;
  justify-content: center;
  align-self: center;
  border-radius: 50%;
  margin: 2px;
  font-size: calc(var(--font0) / 2);
  width: var(--font0);
  height: var(--font0);
  line-height: var(--font0);
  background: var(--fg1);
  color: var(--bg1);
  cursor: pointer;
  text-transform: uppercase;
  font-weight: 700;
}
.input-wrapper[type=signature] mele-value-content {
  height: auto;
  justify-content: center;
}
.input-wrapper[type=signature] img {
  width: fit-content;
  min-height: 100%;
}
.input-wrapper.shake {
  animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
  transform: translate3d(0, 0, 0);
  backface-visibility: hidden;
  perspective: 1000px;
}
.input-wrapper mele-value-before {
  user-select: none;
  grid-area: before;
}
.input-wrapper mele-value-after {
  user-select: none;
  grid-area: after;
}
.input-wrapper mele-value-before:empty,
.input-wrapper mele-value-after:empty {
  display: none;
}
.input-wrapper mele-value-before,
.input-wrapper mele-value-after {
  display: flex;
  align-items: center;
  padding: 0px var(--base_margin);
  min-width: fit-content;
  text-align: center;
  font-family: var(--font_normal);
  font-size: var(--font1);
  border: 1px solid var(--bg3);
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  height: calc(100% - 2px);
}
.input-wrapper mele-value-content {
  grid-area: content;
  position: relative;
  display: grid;
  min-height: var(--small-height);
  width: var(--input-width);
  color: var(--value-color);
  border: var(--input-border);
  border-radius: 4px;
}
.input-wrapper mele-value-content *,
.input-wrapper mele-value-content dropdown-item dropdown-label,
.input-wrapper mele-value-content mele-item mele-labels mele-label {
  font-family: var(--font_normal);
  font-size: var(--font1);
  text-transform: none;
}
.input-wrapper mele-value-content input,
.input-wrapper mele-value-content textarea,
.input-wrapper mele-value-content div,
.input-wrapper mele-value-content span.editfield {
  padding: 4px 10px;
  min-height: var(--small-height);
  box-sizing: border-box;
  margin: 0;
}
.input-wrapper mele-value-content img {
  width: var(--input-width);
  object-fit: contain;
  text-indent: -10000px;
}
.input-wrapper mele-value-content .editfield {
  background: var(--input-bg);
  color: var(--value-color);
  border-radius: 4px;
  border: transparent;
  resize: none;
}
.input-wrapper mele-value-content .editfield::placeholder {
  font-size: var(--font3);
  font-family: var(--font_normal);
}
.input-wrapper mele-value-content input {
  padding-right: calc(var(--small-height) + 8px);
}
.input-wrapper mele-value-content .editfield:focus {
  outline: none;
  transition: all 0.1s ease;
  box-shadow: 0 0 4px var(--blue);
  border-color: var(--blue);
}
.input-wrapper mele-value-content .button-wrapper[key=clear] {
  position: absolute;
  right: 0px;
  top: 0px;
  width: var(--small-height);
  height: var(--small-height);
}
.input-wrapper mele-value-content .button-wrapper[key=clear] [stroke=fg] {
  stroke: var(--bg2);
}
.input-wrapper mele-value-content .button-wrapper[key=clear] [stroke=bg] {
  stroke: var(--fg2);
}
.input-wrapper mele-value-content .button-wrapper[key=clear] [fill=fg] {
  fill: var(--bg2);
}
.input-wrapper mele-value-content .button-wrapper[key=clear] [fill=bg] {
  fill: var(--fg2);
}
.input-wrapper mele-value-content .button-wrapper[key=clear].double-icons {
  right: var(--small-height);
}
.input-wrapper mele-value-content .button-wrapper[key=edit] {
  position: absolute;
  top: 0px;
  height: 100%;
  right: 0px;
  z-index: 20;
}
.input-wrapper mele-value-content svg.image-clear {
  position: absolute;
  right: 0px;
  top: 0px;
  width: var(--small-height);
  height: var(--small-height);
  box-sizing: border-box;
  border: 4px solid transparent;
  opacity: 0.6;
  align-self: anchor-center;
}
.input-wrapper mele-value-content svg.image-clear [stroke=fg] {
  stroke: var(--bg2);
}
.input-wrapper mele-value-content svg.image-clear [stroke=bg] {
  stroke: var(--fg2);
}
.input-wrapper mele-value-content svg.image-clear [fill=fg] {
  fill: var(--bg2);
}
.input-wrapper mele-value-content svg.image-clear [fill=bg] {
  fill: var(--fg2);
}
.input-wrapper mele-value-content svg.image-clear.double-icons {
  right: var(--small-height);
}
.input-wrapper mele-value-content .button-wrapper[key=clear] mele-icon {
  width: var(--small-height);
  height: var(--small-height);
  box-sizing: border-box;
  opacity: 0.6;
  border: 4px solid transparent;
}

.mele-input[before]:not([before=""]) mele-value-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}
.mele-input[before]:not([before=""]) mele-value-before {
  display: flex;
  height: calc(100% - 2px);
  border: 1px solid var(--bg3);
  border-radius: 4px 0 0 4px;
  justify-content: center;
  align-items: center;
}
.mele-input[before]:not([before=""]) mele-value-content {
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
}

mele-value-help {
  grid-area: help;
  font-size: var(--font4);
  display: flex;
}

mele-value-error,
mele-value-conflict {
  grid-area: error;
  font-size: var(--font4);
  color: var(--fginvalid);
}

mele-window:not([behavior=phone]) .input-wrapper {
  --space: 20px;
}
mele-window:not([behavior=phone]) .input-wrapper [width="1/2"] {
  width: calc(50% - var(--space));
}
mele-window:not([behavior=phone]) .input-wrapper [width="1/3"] {
  width: calc(33.333333% - var(--space));
}
mele-window:not([behavior=phone]) .input-wrapper [width="1/4"] {
  width: calc(25% - var(--space));
}
mele-window:not([behavior=phone]) .input-wrapper [width="2/3"] {
  width: calc(66.6666% - var(--space));
}
mele-window:not([behavior=phone]) .input-wrapper [width="3/4"] {
  width: calc(75% - var(--space));
}
mele-window:not([behavior=phone]) .input-wrapper [width="1/5"] {
  width: calc(20% - var(--space));
}
mele-window:not([behavior=phone]) .input-wrapper [width="2/5"] {
  width: calc(40% - var(--space));
}
mele-window:not([behavior=phone]) .input-wrapper [width="3/5"] {
  width: calc(60% - var(--space));
}
mele-window:not([behavior=phone]) .input-wrapper [width="4/5"] {
  width: calc(80% - var(--space));
}

.width-half {
  --space: 20px;
  width: calc(50% - var(--space));
}

.width-third {
  --space: 20px;
  width: calc(33.3333% - var(--space));
}

.upload-button {
  position: relative;
  height: var(--small_height);
  background: var(--blue);
  border-top: var(--input-border);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  text-transform: uppercase;
  width: var(--small_width);
  margin: 0 auto;
}

[readonly] .upload-button {
  display: none;
}

.image-clear {
  position: absolute;
  right: 0;
}

[view]:not([behavior=phone]) mele-input[type=grid] mele-value-content .mele-list mele-item {
  border-right: none;
  width: auto;
  margin: 0 !important;
}
[view]:not([behavior=phone]) mele-input[type=grid] mele-value-content .mele-list mele-item:last-of-type {
  border-bottom-right-radius: var(--base_margin);
  border-top-right-radius: var(--base_margin);
  border-right: var(--input-border);
}
[view]:not([behavior=phone]) mele-input[type=grid] mele-value-content .mele-list mele-item:first-of-type {
  border-bottom-left-radius: var(--base_margin);
  border-top-left-radius: var(--base_margin);
}

@keyframes shake {
  10%, 90% {
    transform: translate3d(-1px, 0, 0);
  }
  20%, 80% {
    transform: translate3d(2px, 0, 0);
  }
  30%, 50%, 70% {
    transform: translate3d(-4px, 0, 0);
  }
  40%, 60% {
    transform: translate3d(4px, 0, 0);
  }
}
mele-modal[key=":dropdown"] dropdown-item dropdown-label,
mele-modal[key=":dropdown"] mele-item mele-labels mele-label {
  font-size: var(--font1);
  font-family: var(--font_normal);
  text-transform: none;
}

mele-modal[key^=modal_rotary] {
  background: none;
  display: block;
  background: var(--bg3_transparent);
}
mele-modal[key^=modal_rotary] > mele-wrapper {
  background: none;
}
mele-modal[key^=modal_rotary] rotary {
  display: block;
  position: absolute;
  width: calc(30vmin + 5 * var(--font0));
  min-width: calc(250px + 5 * var(--font0));
  max-width: calc(100vw - 20px);
  height: calc(30vmin + var(--base_height));
  min-height: calc(250px + var(--base_height));
  box-shadow: 0px 0px var(--large_margin) var(--large_margin) rgba(128, 128, 128, 0.5);
}
mele-modal[key^=modal_rotary] rotary header {
  display: flex;
  width: 100%;
  height: var(--base_height);
  justify-content: center;
  align-items: center;
  font-size: calc(var(--base_height) - 2px);
  background: var(--bg1);
  color: var(--fg1);
}
mele-modal[key^=modal_rotary] rotary action {
  position: relative;
  display: flex;
  width: 100%;
  height: 30vmin;
  min-height: 250px;
}
mele-modal[key^=modal_rotary] rotary action mele-text {
  display: inline-flex;
  width: 50%;
  height: 100%;
  box-sizing: border-box;
  font-size: var(--font0);
  font-family: var(--font_bold);
  text-transform: uppercase;
  opacity: 0.6;
  padding: 1vmin 2vmin;
  align-items: flex-start;
  color: black;
}
mele-modal[key^=modal_rotary] rotary action mele-text.hover {
  opacity: 1;
  color: white;
}
mele-modal[key^=modal_rotary] rotary action mele-text[label="form.clear"] {
  justify-content: flex-start;
  background: var(--red_transparent);
}
mele-modal[key^=modal_rotary] rotary action mele-text[label="form.cancel"] {
  justify-content: flex-end;
  background: var(--gray_transparent);
}
mele-modal[key^=modal_rotary] rotary action val {
  position: absolute;
  z-index: 10;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  height: 100%;
  aspect-ratio: 1/1;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background: var(--bg1);
  border: 1vmin solid var(--fg1);
  color: var(--fg1);
  font-size: 10vmin;
  box-sizing: border-box;
}
mele-modal[key^=modal_rotary] rotary action svg {
  position: absolute;
  z-index: 20;
  top: 50%;
  left: 50%;
  height: 100%;
  aspect-ratio: 1/1;
}
mele-modal[key^=modal_rotary] rotary action svg.pointer {
  z-index: 30;
}

.input_style_left_right mele-input {
  display: flex !important;
  flex-direction: row-reverse;
  align-items: center;
}
.input_style_left_right mele-input > mele-labels {
  flex: 1;
}
.input_style_left_right mele-input > mele-value {
  flex: 1;
  padding: 0 var(--large_margin);
}
.input_style_left_right mele-input > mele-value mele-item {
  min-width: initial !important;
}
.input_style_left_right mele-input > mele-value > mele-value-wrapper {
  border: none;
  align-items: baseline;
}
.input_style_left_right mele-input > mele-value > mele-value-wrapper > mele-value-content > span {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.input_style_left_right mele-input > mele-value > mele-value-wrapper > mele-value-content > .editfield {
  background: var(--bg2);
  color: var(--value-color);
  border-radius: 4px;
  border: 1px solid var(--bg3);
  resize: none;
}
.input_style_left_right mele-input > mele-value > mele-value-wrapper > mele-value-content > .editfield:focus {
  outline: none;
  transition: all 0.1s ease;
  box-shadow: 0 0 4px var(--blue);
  border-color: var(--blue);
}
.input_style_left_right mele-input > mele-value > mele-value-wrapper > mele-value-before,
.input_style_left_right mele-input > mele-value > mele-value-wrapper > mele-value-after {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.input_style_left_right mele-input[split="0:1"] > mele-labels {
  display: none;
}
.input_style_left_right mele-input[split="1:0"] > mele-value {
  display: none;
}
.input_style_left_right mele-input[split="1:2"] > mele-labels {
  flex: 1;
}
.input_style_left_right mele-input[split="1:2"] > mele-value {
  flex: 2;
  max-width: 66%;
}
.input_style_left_right mele-input[split="2:1"] > mele-labels {
  flex: 2;
}
.input_style_left_right mele-input[split="2:1"] > mele-value {
  flex: 1;
  max-width: 33%;
}
.input_style_left_right mele-input[split="1:3"] > mele-labels {
  flex: 1;
}
.input_style_left_right mele-input[split="1:3"] > mele-value {
  flex: 3;
  max-width: 75%;
}
.input_style_left_right mele-input[split="1:4"] > mele-labels {
  flex: 1;
}
.input_style_left_right mele-input[split="1:4"] > mele-value {
  flex: 4;
  max-width: 80%;
  padding-left: 0px;
}
.input_style_left_right mele-input[split="1:5"] > mele-labels {
  flex: 1;
}
.input_style_left_right mele-input[split="1:5"] > mele-value {
  flex: 5;
  max-width: 85.8%;
  padding-left: 0px;
}
.input_style_left_right mele-input[split="3:1"] > mele-labels {
  flex: 3;
}
.input_style_left_right mele-input[split="3:1"] > mele-value {
  flex: 1;
  max-width: 25%;
}
.input_style_left_right mele-input[split=none] > mele-labels {
  flex: initial;
}
.input_style_left_right mele-input[split=none] > mele-value {
  flex: initial;
}

/* GENERIC STYLING */
.mele-window {
  display: block;
  position: absolute;
  overflow: hidden;
  background: var(--bg1);
}
.mele-window[width="0"], .mele-window[height="0"] {
  display: none !important;
}
.mele-window > mele-button[key=viewback] {
  position: absolute;
  z-index: 20;
  left: 0px;
  top: 0px;
  bottom: 0px;
  background: linear-gradient(to bottom, var(--bg1) 10%, var(--bg2) 70%);
}
.mele-window > mele-body {
  position: absolute;
  z-index: 10;
  left: 0px;
  right: 0px;
  top: 0px;
  bottom: 0px;
  display: flex;
  flex-direction: row;
}
.mele-window > mele-body [view] {
  overflow: hidden;
  display: none;
  background: var(--bg1);
  color: var(--fg1);
}
.mele-window.rowresize {
  cursor: row-resize !important;
}
.mele-window.rowresize * {
  pointer-events: none !important;
  user-select: none !important;
  cursor: row-resize !important;
}

.mele-window[layout=sidesplit][active="2"].maximized > mele-body > .mele-view[role~=bottom] {
  width: 100% !important;
  height: 100% !important;
  margin-left: 0 !important;
}
.mele-window[layout=sidesplit][active="2"].maximized > mele-body > .mele-view[role~=bottom] mele-button[key=MAXIMIZE] {
  display: none !important;
}
.mele-window[layout=sidesplit][active="2"].maximized > mele-body > .mele-view:not([role~=bottom]) {
  display: none !important;
}

.mele-window[layout=sidesplit][active="2"]:not(.maximized) > mele-body > .mele-view[role~=bottom] mele-button[key=NORMALIZE] {
  display: none !important;
}

.mele-window > mele-body [view][role~=single] {
  display: flex;
  flex: 1;
}

.mele-window[layout=split] > mele-body [view][role~=left] {
  display: flex;
  order: 1;
  flex: initial;
  width: var(--sidebar_width);
}
.mele-window[layout=split] > mele-body [view][role~=right] {
  display: flex;
  order: 2;
  flex: 1;
  border-left: 1px solid var(--bg3);
}

.mele-window[layout=triplet] [view][role~=left] {
  display: flex;
  order: 1;
  flex: initial;
  width: var(--sidebar_width);
}
.mele-window[layout=triplet] [view][role~=center] {
  display: flex;
  order: 2;
  flex: 1;
  border-left: 1px solid var(--gray);
}
.mele-window[layout=triplet] [view][role~=right] {
  display: flex;
  order: 3;
  flex: initial;
  width: var(--rightbar_width);
  border-left: 1px solid var(--gray);
}

.mele-window[layout=sidesplit] > mele-body {
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  height: inherit;
}
.mele-window[layout=sidesplit] > mele-body > [view][role~=left] {
  display: flex;
  order: 1;
  position: absolute;
  left: 0px;
  top: 0px;
  width: var(--sidebar_width);
  height: 100%;
}
.mele-window[layout=sidesplit] > mele-body > [view][role~=top] {
  margin-left: var(--sidebar_width);
  display: flex;
  order: 2;
  border-left: 1px solid var(--bg3);
  height: initial;
  width: initial;
  flex: 1;
  order: 10;
}
.mele-window[layout=sidesplit] > mele-body > [view][role~=bottom] {
  margin-left: var(--sidebar_width);
  display: flex;
  order: 3;
  border-left: 1px solid var(--bg3);
  border-top: 1px solid var(--bg3);
  height: 50%;
  width: initial;
  order: 20;
}
.mele-window[layout=sidesplit] > mele-body > [view][role~=bottom] > mele-wrapper > mele-header-wrapper {
  user-select: none !important;
  cursor: row-resize !important;
}

/* SPECIAL TREATMENT OF DIFFERENT TYPES */
.mele-window[behavior=desktop] {
  background: var(--bg3);
}
.mele-window[behavior=desktop] > mele-body {
  margin: 16px;
}
.mele-window[behavior=desktop][layout=split] [role~=left] {
  background: var(--bg1);
  border-right: none;
  border-radius: 6px 0px 0px 6px;
}
.mele-window[behavior=desktop][layout=split] [role~=right] {
  background: var(--bg1);
  border-left: 1px solid var(--fg3);
  border-radius: 0px 6px 6px 0px;
}
.mele-window[behavior=desktop][layout=sidesplit] > mele-body {
  height: calc(100% - 32px);
  width: calc(100% - 32px);
}
.mele-window[behavior=desktop] > mele-button[key=viewback] {
  left: 16px;
  top: 16px;
}

mele-text[key=print_header] {
  display: none;
}

mele-text[key=print_footer] {
  display: none;
}

@media print {
  body {
    position: static !important;
    background: none !important;
    margin: 0px;
    padding: 0px;
    top: initial;
    bottom: initial;
    width: initial;
    height: initial;
    overflow: auto;
  }
  body * {
    background: none !important;
    color: black !important;
    box-shadow: none !important;
  }

  mele-text[key=print_header] {
    display: block;
    position: fixed;
    top: 4px;
    left: 4px;
  }

  .mele-window:not([focused]) {
    display: none !important;
    content-visibility: auto;
    contain-intrinsic-size: 100vw 100vh;
  }

  .mele-window[focused] {
    position: static !important;
    left: initial !important;
    top: initial !important;
    width: initial !important;
    height: initial !important;
  }
  .mele-window[focused] > mele-body {
    margin: 0px !important;
    position: static !important;
    left: initial !important;
    right: initial !important;
    top: initial !important;
    bottom: initial !important;
    display: flex !important;
  }
  .mele-window[focused] > mele-body [view] {
    border: none !important;
  }
  .mele-window[focused] > mele-body .mele-input mele-value-content mele-button {
    visibility: hidden;
  }
}
/* GENERIC STYLING */
.mele-view {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.mele-view[role~=narrow] > mele-wrapper > mele-header-wrapper > mele-header > div > span:not(:first-of-type), .mele-view.mele-modal[behavior=phone] > mele-wrapper > mele-header-wrapper > mele-header > div > span:not(:first-of-type) {
  display: none;
}
.mele-view[role~=narrow] > mele-wrapper > mele-header-wrapper > mele-header > mele-header-texts, .mele-view.mele-modal[behavior=phone] > mele-wrapper > mele-header-wrapper > mele-header > mele-header-texts {
  flex-direction: column;
}
.mele-view[role~=narrow] > mele-wrapper > mele-header-wrapper > mele-header > mele-header-texts > mele-header-text:nth-of-type(2), .mele-view.mele-modal[behavior=phone] > mele-wrapper > mele-header-wrapper > mele-header > mele-header-texts > mele-header-text:nth-of-type(2) {
  font-size: var(--font3);
}
.mele-view[role~=narrow] > mele-wrapper > mele-header-wrapper > mele-header > mele-header-texts > mele-header-text:nth-of-type(2):before, .mele-view.mele-modal[behavior=phone] > mele-wrapper > mele-header-wrapper > mele-header > mele-header-texts > mele-header-text:nth-of-type(2):before {
  display: none;
}
.mele-view[role~=narrow] > mele-wrapper > mele-header-wrapper > mele-header > mele-header-texts > mele-header-text:nth-of-type(2):after, .mele-view.mele-modal[behavior=phone] > mele-wrapper > mele-header-wrapper > mele-header > mele-header-texts > mele-header-text:nth-of-type(2):after {
  display: none;
}
.mele-view[role~=narrow][role~=single]:not([key=appwall]) > mele-wrapper > mele-header-wrapper > mele-header*:not(:empty):not(.empty) {
  padding-right: var(--base_height);
}
.mele-view[role~=narrow][role~=single]:not([key=appwall]) > mele-wrapper > mele-header-wrapper > mele-header*:not(:empty):not(.empty):after {
  padding-right: var(--base_height);
}
.mele-view[role~=narrow][role~=single]:not([key=appwall]) > mele-wrapper > mele-header-wrapper > mele-header*:not(:empty):not(.empty) ~ *:not(:empty):not(.empty) {
  padding-right: 0px;
}
.mele-view[role~=narrow][role~=single]:not([key=appwall]) > mele-wrapper > mele-header-wrapper > mele-header*:not(:empty):not(.empty) ~ *:not(:empty):not(.empty):after {
  padding-right: 0px;
}
.mele-view[role~=back] > mele-wrapper > mele-header-wrapper > mele-header*:not(:empty):not(.empty) {
  padding-left: var(--base_height);
}
.mele-view[role~=back] > mele-wrapper > mele-header-wrapper > mele-header*:not(:empty):not(.empty) ~ *:not(:empty):not(.empty) {
  padding-left: 0px;
}
.mele-view:not([role~=narrow]) > mele-wrapper > mele-header-wrapper > mele-header[key=core_header] {
  flex-direction: row-reverse;
}
.mele-view > mele-wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
}
.mele-view > mele-wrapper > mele-header-wrapper {
  display: flex;
  flex-direction: column;
  flex: 0 0 auto;
  z-index: 1;
}
.mele-view > mele-wrapper > mele-header-wrapper > * {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-basis: auto;
}
.mele-view > mele-wrapper > mele-header-wrapper > * > *:empty, .mele-view > mele-wrapper > mele-header-wrapper > * > *.empty {
  display: none !important;
}
.mele-view > mele-wrapper > mele-header-wrapper > * > mele-header-texts {
  flex-basis: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  white-space: nowrap;
}
.mele-view > mele-wrapper > mele-header-wrapper > * > mele-header-texts > mele-header-text {
  user-select: none;
  margin: 0px 4px;
  text-align: center;
  max-width: 100%;
}
.mele-view > mele-wrapper > mele-header-wrapper > * > mele-header-texts > mele-header-text:nth-of-type(2) {
  color: var(--fg2);
  font-family: var(--font_light);
}
.mele-view > mele-wrapper > mele-header-wrapper > * > mele-header-texts > mele-header-text:nth-of-type(2):empty {
  display: none;
}
.mele-view > mele-wrapper > mele-header-wrapper > * > mele-header-texts > mele-header-text:nth-of-type(2):before {
  content: "(";
}
.mele-view > mele-wrapper > mele-header-wrapper > * > mele-header-texts > mele-header-text:nth-of-type(2):after {
  content: ")";
}
.mele-view > mele-wrapper > mele-header-wrapper > *:empty, .mele-view > mele-wrapper > mele-header-wrapper > *.empty {
  display: none !important;
}
.mele-view > mele-wrapper > mele-header-wrapper > *:not(:empty):not(.empty) {
  min-height: var(--base_height);
  background: var(--bg2);
  box-shadow: 0px 0px 10px 1px rgba(128, 128, 128, 0.5);
}
.mele-view > mele-wrapper > mele-header-wrapper > *[key=search] {
  min-height: var(--base_height) !important;
}
.mele-view > mele-wrapper > mele-header-wrapper > *:not(:empty):not(.empty) ~ *:not(:empty):not(.empty) {
  min-height: auto;
  box-shadow: none;
  overflow: hidden;
  border-bottom: 1px solid var(--bg3);
  background: none;
}
.mele-view > mele-wrapper > mele-footer-wrapper {
  display: flex;
  flex-direction: column-reverse;
  flex: 0 0 auto;
  max-width: 100vw;
}
.mele-view > mele-wrapper > mele-footer-wrapper > * {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-basis: auto;
}
.mele-view > mele-wrapper > mele-footer-wrapper > * > *:empty, .mele-view > mele-wrapper > mele-footer-wrapper > * > *.empty {
  display: none !important;
}
.mele-view > mele-wrapper > mele-footer-wrapper > * > mele-footer-texts {
  flex-basis: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  white-space: nowrap;
}
.mele-view > mele-wrapper > mele-footer-wrapper > * > mele-footer-texts > mele-footer-text {
  margin: 0px 4px;
  text-align: center;
  max-width: 100%;
}
.mele-view > mele-wrapper > mele-footer-wrapper > * > mele-footer-texts > mele-footer-text:nth-of-type(2) {
  color: var(--fg2);
  font-family: var(--font_light);
}
.mele-view > mele-wrapper > mele-footer-wrapper > * > mele-footer-texts > mele-footer-text:nth-of-type(2):empty {
  display: none;
}
.mele-view > mele-wrapper > mele-footer-wrapper > * > mele-footer-texts > mele-footer-text:nth-of-type(2):before {
  content: "(";
}
.mele-view > mele-wrapper > mele-footer-wrapper > * > mele-footer-texts > mele-footer-text:nth-of-type(2):after {
  content: ")";
}
.mele-view > mele-wrapper > mele-footer-wrapper > *:empty, .mele-view > mele-wrapper > mele-footer-wrapper > *.empty {
  display: none !important;
}
.mele-view > mele-wrapper > mele-footer-wrapper > *:not(:empty):not(.empty) {
  min-height: var(--base_height);
  border-top: 1px solid var(--bg3);
}
.mele-view > mele-wrapper > mele-footer-wrapper > *:not(:empty):not(.empty) ~ *:not(:empty):not(.empty) {
  min-height: auto;
  box-shadow: none;
  overflow: hidden;
}
.mele-view > mele-wrapper > mele-footer-wrapper > [key=paging_footer] {
  flex-direction: column;
}
.mele-view > mele-wrapper > mele-footer-wrapper > [key=paging_footer] > [key=paging_summary] {
  padding: var(--base_margin);
  background: var(--bg3);
  width: 100%;
  text-align: center;
}
.mele-view > mele-wrapper > mele-footer-wrapper > [key=paging_footer] > [key=paging_buttons] {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  width: 100%;
}
.mele-view > mele-wrapper > mele-footer-wrapper > [key=paging_footer] > [key=paging_buttons] > [key=paging_pages] {
  overflow: hidden;
  max-width: 50%;
  display: flex;
  justify-content: center;
}
.mele-view > mele-wrapper > mele-body-wrapper {
  display: flex;
  flex: 1 1 auto;
  position: relative;
  overflow-y: auto;
  overflow-x: hidden;
}
.mele-view > mele-wrapper > mele-body-wrapper > mele-body {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  align-content: flex-start;
  width: 100%;
}
.mele-view > mele-text[key=blocked] {
  display: none;
}
.mele-view[collapsible] > mele-wrapper > mele-header-wrapper {
  cursor: pointer;
}
.mele-view[collapsible][collapsed] > mele-wrapper > mele-body-wrapper, .mele-view[collapsible][collapsed] > mele-wrapper > mele-footer-wrapper {
  display: none;
}
.mele-view[collapsible][collapsed] > mele-wrapper > mele-header-wrapper > mele-header {
  position: relative;
}
.mele-view[collapsible][collapsed] > mele-wrapper > mele-header-wrapper > mele-header:not(:empty)::after {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  width: 20px;
  display: block;
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translate(0, -50%);
}
.mele-view[collapsible]:not([collapsed]) > mele-wrapper > mele-header-wrapper > mele-header {
  position: relative;
}
.mele-view[collapsible]:not([collapsed]) > mele-wrapper > mele-header-wrapper > mele-header:not(:empty)::after {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
  width: 20px;
  display: block;
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translate(0, -50%);
}

.mele-view[unavailable] > mele-wrapper > mele-body-wrapper > mele-body {
  display: none !important;
}
.mele-view[unavailable] > mele-wrapper > mele-body-wrapper > mele-text[key=unavailable] {
  display: block;
  flex: 1;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 40%;
}
.mele-view[unavailable] > mele-wrapper > mele-footer-wrapper {
  display: none;
}

.mele-view[blocked] > mele-wrapper div.blocked {
  position: absolute;
  z-index: 100;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: var(--bg1_semitransparent);
  color: var(--fg1);
  font-size: var(--base_height_50);
}

.mele-view[view] > mele-wrapper > mele-body-wrapper {
  flex: 1 1 auto;
}

.mele-view.centered > mele-wrapper > mele-body-wrapper > mele-body {
  align-content: center;
  align-items: center;
}

.mele-view[view] > mele-wrapper > mele-body-wrapper > mele-body {
  justify-content: center;
}

.mele-view[horizontal]:not([role=none]) {
  flex-direction: row;
}
.mele-view[horizontal]:not([role=none]) > mele-wrapper {
  flex-direction: row;
  width: 100%;
}
.mele-view[horizontal]:not([role=none]) > mele-wrapper > mele-header-wrapper {
  flex-direction: row;
}
.mele-view[horizontal]:not([role=none]) > mele-wrapper > mele-header-wrapper > * {
  flex-direction: row;
}
.mele-view[horizontal]:not([role=none]) > mele-wrapper > mele-header-wrapper > * > div, .mele-view[horizontal]:not([role=none]) > mele-wrapper > mele-header-wrapper > * > mele-header-text {
  flex-direction: row;
}
.mele-view[horizontal]:not([role=none]) > mele-wrapper > mele-header-wrapper > *:not(:empty):not(.empty) {
  border-right: 1px solid var(--bg3);
}
.mele-view[horizontal]:not([role=none]) > mele-wrapper > mele-footer-wrapper {
  flex-direction: row-reverse;
}
.mele-view[horizontal]:not([role=none]) > mele-wrapper > mele-footer-wrapper > * {
  flex-direction: row;
}
.mele-view[horizontal]:not([role=none]) > mele-wrapper > mele-footer-wrapper > * > div, .mele-view[horizontal]:not([role=none]) > mele-wrapper > mele-footer-wrapper > * > mele-header-text {
  flex-direction: row;
}
.mele-view[horizontal]:not([role=none]) > mele-wrapper > mele-footer-wrapper > *:not(:empty):not(.empty) {
  border-left: 1px solid var(--bg3);
}
.mele-view[horizontal]:not([role=none]) > mele-wrapper > mele-body-wrapper {
  flex-direction: row;
  overflow-y: hidden;
  overflow-x: auto;
}
.mele-view[horizontal]:not([role=none]) > mele-wrapper > mele-body-wrapper > mele-body {
  flex-direction: row;
}

.mele-view[readonly] mele-button:not(.noreadonly) {
  display: none !important;
}

.mele-view.fill > mele-wrapper > mele-body-wrapper > mele-body {
  flex-direction: column;
}
.mele-view.fill > mele-wrapper > mele-body-wrapper > mele-body > * {
  flex: 1;
  width: 100%;
}

.mele-view mele-header-icon {
  display: flex;
  align-items: center;
  width: var(--base_height);
  height: var(--base_height);
  order: 1;
}
.mele-view mele-header-icon > mele-image {
  width: calc(var(--base_height) * 0.8);
  height: calc(var(--base_height) * 0.8);
  margin-left: calc(var(--base_height) * 0.1);
}

.mele-view[key=filter] .mele-input[key=sort1] {
  border-top: 1px solid var(--bg3);
  margin-top: var(--base_margin);
  padding-top: calc(var(--base_margin) * 2);
}

/* GENERIC STYLING */
.mele-modal {
  position: absolute;
  z-index: 100000;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  background: rgba(128, 128, 128, 0.7);
}
.mele-modal > mele-wrapper {
  background: var(--bg1);
  flex: initial;
  box-sizing: border-box;
}
.mele-modal > mele-wrapper > mele-header-wrapper > mele-header mele-button[action=modalclose][iconleft="sys.close"] {
  position: absolute;
  right: 0;
}
.mele-modal > mele-wrapper > mele-body-wrapper {
  display: flex;
  flex: 1 1 auto;
}
.mele-modal > mele-wrapper > mele-body-wrapper > mele-body > mele-text {
  text-align: center;
  flex-basis: 100%;
}
.mele-modal[outclick=none] {
  pointer-events: none;
}
.mele-modal[outclick=none] > mele-wrapper {
  pointer-events: all;
}

/* SPECIAL TREATMENT OF DIFFERENT TYPES */
.mele-modal[position=center]:not([behavior=phone]) {
  align-items: center;
  justify-content: center;
}
.mele-modal[position=center]:not([behavior=phone]) > mele-wrapper {
  box-shadow: var(--base_shadow);
  max-height: 70%;
  min-width: 50%;
  max-width: 60%;
  border-radius: 4px;
}
.mele-modal[position=center]:not([behavior=phone]) > mele-wrapper > mele-body-wrapper {
  min-height: 96px;
}

.mele-modal[position=full]:not([behavior=phone]) {
  background: rgba(128, 128, 128, 0.5);
}
.mele-modal[position=full]:not([behavior=phone]) > mele-wrapper {
  margin: var(--small_height);
  box-shadow: var(--base_shadow);
}
.mele-modal[position=full]:not([behavior=phone]) > mele-wrapper > mele-body-wrapper {
  flex: 1 1 auto;
}

.mele-modal[position=full][behavior=phone] > mele-wrapper {
  width: 100% !important;
  min-width: 100% !important;
  max-width: 100% !important;
  height: 100% !important;
  min-height: 100% !important;
  max-height: 100% !important;
  margin-top: 0px !important;
  margin-right: 0px !important;
}
.mele-modal[position=full][behavior=phone] > mele-wrapper > mele-body-wrapper {
  flex: 1 1 auto;
}

.mele-modal[position=left] {
  align-items: flex-start;
}
.mele-modal[position=left] > mele-wrapper {
  box-shadow: var(--base_shadow);
  min-width: 280px;
  max-width: 280px;
  height: 100% !important;
}
.mele-modal[position=left] > mele-wrapper > mele-body-wrapper {
  flex: 1 1 auto;
}

.mele-modal[position=right] {
  align-items: flex-end;
}
.mele-modal[position=right] > mele-wrapper {
  box-shadow: var(--base_shadow);
  min-width: 280px;
  max-width: 280px;
  height: 100% !important;
}
.mele-modal[position=right] > mele-wrapper > mele-body-wrapper {
  flex: 1 1 auto;
}

.mele-modal[position=top] {
  justify-content: flex-start;
}
.mele-modal[position=top] > mele-wrapper {
  box-shadow: var(--base_shadow);
  max-height: 320px;
}
.mele-modal[position=top] > mele-wrapper > mele-body-wrapper {
  min-height: 96px;
}

.mele-modal[position=bottom] {
  justify-content: flex-end;
}
.mele-modal[position=bottom] > mele-wrapper {
  box-shadow: var(--base_shadow);
  max-height: 320px;
}
.mele-modal[position=bottom] > mele-wrapper > mele-body-wrapper {
  min-height: 96px;
}

.mele-modal[position=over]:not([behavior=phone]) {
  align-items: flex-end;
  background: none;
}
.mele-modal[position=over]:not([behavior=phone]) > mele-wrapper {
  flex: initial;
  border: 1px solid var(--bg3);
  background: var(--bg1);
  box-sizing: border-box;
  border-radius: 4px;
}

.mele-modal[position=below]:not([behavior=phone]) {
  align-items: flex-end;
  background: none;
}
.mele-modal[position=below]:not([behavior=phone]) > mele-wrapper {
  flex: initial;
  border: 1px solid var(--bg3);
  box-sizing: border-box;
  border-radius: 4px;
}

.mele-modal[position=leftto]:not([behavior=phone]), .mele-modal[position=rightto]:not([behavior=phone]) {
  align-items: flex-end;
  background: none;
  pointer-events: none;
}
.mele-modal[position=leftto]:not([behavior=phone]) > mele-wrapper, .mele-modal[position=rightto]:not([behavior=phone]) > mele-wrapper {
  pointer-events: all;
  flex: initial;
  border: none;
  box-sizing: border-box;
}
.mele-modal[position=leftto]:not([behavior=phone]) > mele-wrapper > mele-body-wrapper > mele-body, .mele-modal[position=rightto]:not([behavior=phone]) > mele-wrapper > mele-body-wrapper > mele-body {
  align-items: center;
}

.mele-modal[behavior=phone][position=center] > mele-wrapper, .mele-modal[behavior=phone][position=over] > mele-wrapper, .mele-modal[behavior=phone][position=below] > mele-wrapper {
  top: 0px !important;
  bottom: 0px !important;
  left: 0px !important;
  right: 0px !important;
  width: 100% !important;
  min-width: 100% !important;
  max-width: 100% !important;
  height: 100% !important;
  min-height: 100% !important;
  max-height: 100% !important;
}
.mele-modal[behavior=phone][position=center] > mele-wrapper > mele-header-wrapper > mele-header:not(:empty):not(.empty):after, .mele-modal[behavior=phone][position=over] > mele-wrapper > mele-header-wrapper > mele-header:not(:empty):not(.empty):after, .mele-modal[behavior=phone][position=below] > mele-wrapper > mele-header-wrapper > mele-header:not(:empty):not(.empty):after, .mele-modal[behavior=phone][position=full] > mele-wrapper > mele-header-wrapper > mele-header:not(:empty):not(.empty):after {
  padding-right: var(--base_height);
}

/* SPECIAL TREATMENT OF PREDEFINED MODALS */
.mele-modal.modaldialog > mele-wrapper > mele-header-wrapper > mele-header {
  border-radius: 4px;
}
.mele-modal.modaldialog > mele-wrapper > mele-body-wrapper > mele-body {
  align-content: center;
  justify-content: center;
  align-items: center;
  padding: 20px;
}
.mele-modal.modaldialog > mele-wrapper > mele-body-wrapper > mele-body mele-image[icon="sys.wait"] {
  margin: 10px 0px 0px 0px;
  padding: 0px;
}

.mele-modal.error[position=center]:not([behavior=phone]) > mele-wrapper {
  box-shadow: 0px 0px var(--base_margin) var(--base_margin) var(--red);
}

.mele-modal.error > mele-wrapper > mele-header-wrapper > mele-header[key=core_header] {
  color: var(--fginvalid);
}

.mele-modal.modaldialog.wf > mele-wrapper {
  max-height: 90%;
  max-width: 1024px;
  margin-left: 5%;
  margin-right: 5%;
}
.mele-modal.modaldialog.wf > mele-wrapper > mele-body-wrapper > mele-body {
  align-content: flex-start;
}

.mele-modal.modaldialog.wf[behavior=phone] > mele-wrapper {
  min-height: 100%;
  max-height: 100%;
  min-width: 100%;
  max-width: 100%;
  margin-left: 0px;
  margin-right: 0px;
}
.mele-modal.modaldialog.wf[behavior=phone] > mele-wrapper > mele-body-wrapper > mele-body {
  align-content: flex-start;
}

/* COLORING */
.mele-modal.modal-preview:not([behavior=phone]) > mele-wrapper {
  border: 4px solid #d8d8d8;
}

.mele-modal.modal-preview {
  background: rgba(0, 0, 0, 0.8) !important;
}
.mele-modal mele-button[key=prev_image],
.mele-modal mele-button[key=next_image] {
  padding: 0;
  width: auto;
  min-width: 160px;
  height: var(--small_height);
  background: var(--bg2);
  border-radius: 5px;
  margin: 0;
}
.mele-modal mele-button[key=prev_image] mele-labels,
.mele-modal mele-button[key=next_image] mele-labels {
  align-items: center;
}
.mele-modal mele-button[key=prev_image] mele-labels mele-label,
.mele-modal mele-button[key=next_image] mele-labels mele-label {
  font-size: var(--font3);
}
.mele-modal mele-button[key=prev_image] mele-labels mele-label2,
.mele-modal mele-button[key=next_image] mele-labels mele-label2 {
  font-size: var(--font4);
}
.mele-modal mele-button[key=prev_image] mele-icon,
.mele-modal mele-button[key=next_image] mele-icon {
  width: var(--small_height);
  height: var(--small_height);
}
.mele-modal mele-button[key=prev_image] mele-icon [stroke=fg],
.mele-modal mele-button[key=next_image] mele-icon [stroke=fg] {
  stroke: var(--blue);
}
.mele-modal mele-button[key=prev_image] mele-icon > svg, .mele-modal mele-button[key=prev_image] mele-icon > img,
.mele-modal mele-button[key=next_image] mele-icon > svg,
.mele-modal mele-button[key=next_image] mele-icon > img {
  width: var(--small_height_50);
  height: var(--small_height_50);
}
.mele-modal mele-button[key=prev_image] {
  padding-right: 20px;
  position: absolute;
  margin-left: 10px;
  left: 0px;
}
.mele-modal mele-button[key=prev_image]:not([iconleft]) {
  padding-left: 20px;
}
.mele-modal mele-button[key=next_image] {
  padding-left: 20px;
  position: absolute;
  margin-right: 10px;
  right: 0px;
}
.mele-modal mele-button[key=next_image]:not([iconright]) {
  padding-right: 20px;
}

/* LIST DIRECTION */
.mele-list:not([direction=row]) > mele-wrapper > mele-body-wrapper {
  display: flex;
  flex-direction: column;
}
.mele-list:not([direction=row]) > mele-wrapper > mele-body-wrapper > mele-body {
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: initial;
  justify-content: flex-start;
}
.mele-list:not([direction=row]) > mele-wrapper > mele-body-wrapper > mele-body > .mele-item {
  flex-basis: initial;
  min-height: var(--base_height);
  min-width: var(--base_width);
  padding: 0px var(--base_margin);
}
.mele-list:not([direction=row]) > mele-wrapper > mele-body-wrapper > mele-body > .mele-item:not([label]):not([label2]) > mele-labels {
  display: initial;
}
.mele-list:not([direction=row]) > mele-wrapper > mele-body-wrapper > mele-body > .mele-item > mele-value {
  text-align: right;
}
.mele-list:not([direction=row]) > mele-wrapper > mele-body-wrapper > mele-button {
  margin: 0px;
}
.mele-list:not([direction=row]) > mele-wrapper > mele-body-wrapper > mele-button:not([key]) {
  display: none;
}

mele-list:not([direction=row]) > mele-wrapper > mele-body-wrapper > mele-body {
  display: flex;
  height: 100%;
  gap: var(--small_margin);
}

.mele-list:not([direction=row])[show=selected]:not([multi]) > mele-wrapper > mele-header-wrapper > mele-header[key=search] {
  display: none;
}

.mele-list:not([direction=row])[show=selected]:not([multi]) > mele-wrapper > mele-body-wrapper {
  flex-direction: row;
  border: 1px solid var(--input-border);
  background: var(--input_bg);
  border-radius: 4px;
}
.mele-list:not([direction=row])[show=selected]:not([multi]) > mele-wrapper > mele-body-wrapper > mele-body > mele-item {
  min-height: var(--small_height_2);
  overflow: hidden;
}
.mele-list:not([direction=row])[show=selected]:not([multi]) > mele-wrapper > mele-body-wrapper > mele-button {
  height: var(--small_height_2);
  width: var(--small_height_2);
}
.mele-list:not([direction=row])[show=selected]:not([multi]) > mele-wrapper > mele-body-wrapper > mele-button > mele-icon {
  height: var(--small_height_2);
  width: var(--small_height_2);
  border: 4px solid transparent;
  box-sizing: border-box;
}

.mele-list[readonly]:not([direction=row])[show=selected]:not([multi]) > mele-wrapper > mele-body-wrapper {
  background: none;
  border: none;
}
.mele-list[readonly]:not([direction=row])[show=selected]:not([multi]) > mele-wrapper > mele-body-wrapper > mele-body > .mele-item {
  padding: 0px;
}
.mele-list[readonly]:not([direction=row])[show=selected]:not([multi]) > mele-wrapper > mele-body-wrapper > mele-body > .mele-item > mele-labels {
  padding: 0px;
}

.mele-list:not([direction=row]).dropdown > mele-wrapper > mele-body-wrapper > mele-body {
  min-height: var(--small_height_2);
}
.mele-list:not([direction=row]).dropdown > mele-wrapper > mele-body-wrapper > mele-body > mele-item {
  min-height: var(--small_height_2);
}

.mele-modal:not([behavior=phone]).dropdown > mele-wrapper > mele-header-wrapper > mele-header {
  display: none;
}

.mele-modal:not([behavior=phone]).dropdown > mele-wrapper > mele-body-wrapper > mele-body > mele-list {
  max-height: 100%;
}

.mele-list[direction=row]:not([horizontal]) > mele-wrapper > mele-body-wrapper, .mele-list:not([direction=row])[readonly]:not([horizontal]) > mele-wrapper > mele-body-wrapper {
  display: flex;
  flex-direction: row;
}
.mele-list[direction=row]:not([horizontal]) > mele-wrapper > mele-body-wrapper > mele-body, .mele-list:not([direction=row])[readonly]:not([horizontal]) > mele-wrapper > mele-body-wrapper > mele-body {
  flex-direction: row;
  justify-content: flex-start;
}
.mele-list[direction=row]:not([horizontal]) > mele-wrapper > mele-body-wrapper > mele-body > .mele-item, .mele-list:not([direction=row])[readonly]:not([horizontal]) > mele-wrapper > mele-body-wrapper > mele-body > .mele-item {
  flex-basis: auto;
  min-height: var(--base_height_50);
  height: initial;
  padding: 0px var(--base_margin);
  box-sizing: content-box;
}
.mele-list[direction=row]:not([horizontal]) > mele-wrapper > mele-body-wrapper > mele-body > .mele-item mele-labels, .mele-list:not([direction=row])[readonly]:not([horizontal]) > mele-wrapper > mele-body-wrapper > mele-body > .mele-item mele-labels {
  align-items: center;
}
.mele-list[direction=row]:not([horizontal]) > mele-wrapper > mele-body-wrapper > mele-body > .mele-item mele-icon, .mele-list:not([direction=row])[readonly]:not([horizontal]) > mele-wrapper > mele-body-wrapper > mele-body > .mele-item mele-icon {
  width: var(--base_height_50);
  height: var(--base_height_50);
}
.mele-list[direction=row]:not([horizontal]) > mele-wrapper > mele-body-wrapper > mele-body > .mele-item mele-icon > svg, .mele-list[direction=row]:not([horizontal]) > mele-wrapper > mele-body-wrapper > mele-body > .mele-item mele-icon > img, .mele-list:not([direction=row])[readonly]:not([horizontal]) > mele-wrapper > mele-body-wrapper > mele-body > .mele-item mele-icon > svg, .mele-list:not([direction=row])[readonly]:not([horizontal]) > mele-wrapper > mele-body-wrapper > mele-body > .mele-item mele-icon > img {
  width: var(--base_height_50);
  height: var(--base_height_50);
}
.mele-list[direction=row]:not([horizontal]) > mele-wrapper > mele-body-wrapper > mele-button, .mele-list:not([direction=row])[readonly]:not([horizontal]) > mele-wrapper > mele-body-wrapper > mele-button {
  height: var(--base_height_50);
  min-width: var(--base_height_50);
  width: var(--base_height_50);
}
.mele-list[direction=row]:not([horizontal]) > mele-wrapper > mele-body-wrapper > mele-button:not([key]), .mele-list:not([direction=row])[readonly]:not([horizontal]) > mele-wrapper > mele-body-wrapper > mele-button:not([key]) {
  display: none;
}

.mele-list[direction=row][horizontal] > mele-wrapper > mele-body-wrapper, .mele-list:not([direction=row])[readonly][horizontal] > mele-wrapper > mele-body-wrapper {
  display: flex;
  flex-direction: row;
}
.mele-list[direction=row][horizontal] > mele-wrapper > mele-body-wrapper > mele-body, .mele-list:not([direction=row])[readonly][horizontal] > mele-wrapper > mele-body-wrapper > mele-body {
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: initial;
  justify-content: flex-start;
}
.mele-list[direction=row][horizontal] > mele-wrapper > mele-body-wrapper > mele-body > .mele-item, .mele-list:not([direction=row])[readonly][horizontal] > mele-wrapper > mele-body-wrapper > mele-body > .mele-item {
  min-height: var(--base_height);
  padding: 0px var(--base_margin);
  margin: 0px;
}
.mele-list[direction=row][horizontal] > mele-wrapper > mele-body-wrapper > mele-button, .mele-list:not([direction=row])[readonly][horizontal] > mele-wrapper > mele-body-wrapper > mele-button {
  margin: 0px;
}
.mele-list[direction=row][horizontal] > mele-wrapper > mele-body-wrapper > mele-button:not([key]), .mele-list:not([direction=row])[readonly][horizontal] > mele-wrapper > mele-body-wrapper > mele-button:not([key]) {
  display: none;
}

/* COMBER - TEXTUAL INPUT */
.mele-list > mele-wrapper > mele-body-wrapper > mele-body > [key=":comber"] {
  display: none;
}

.mele-list[direction=row][show=selected][editable] > mele-wrapper > mele-body-wrapper > mele-body > [key=":comber"] {
  display: flex;
}

.mele-list > mele-wrapper > mele-body-wrapper > mele-body > [key=":comber"] {
  background: none;
  min-height: var(--base_height);
  min-width: var(--base_width);
  line-height: var(--base_height);
  font-family: var(--font_normal);
  font-size: var(--font0);
}
.mele-list > mele-wrapper > mele-body-wrapper > mele-body > [key=":comber"]:before, .mele-list > mele-wrapper > mele-body-wrapper > mele-body > [key=":comber"]:after {
  display: none;
}
.mele-list > mele-wrapper > mele-body-wrapper > mele-body > [key=":comber"]:focus {
  outline: none;
}

.mele-list:not([editable]) > mele-wrapper > mele-header-wrapper > mele-header[key=search] > mele-button {
  display: none;
}

.mele-list[multi][show=selected]:not([readonly]) > mele-wrapper > mele-body-wrapper > mele-body {
  display: inline-flex;
}

/* HIDE REMOVE ICON UNLESS MULTI VALUED DISPLAYING ONLY SELECTED ITEMS */
.mele-list[multi][show=selected]:not([readonly]) {
  background: var(--bg2);
  border-radius: 4px;
  border: 1px solid #edf1f2;
}
.mele-list[multi][show=selected]:not([readonly]) > mele-wrapper > mele-body-wrapper {
  flex-direction: row;
  align-items: center;
}
.mele-list[multi][show=selected]:not([readonly]) > mele-wrapper > mele-body-wrapper > mele-body {
  display: flex;
  flex-direction: row;
  gap: 1rem;
}
.mele-list[multi][show=selected]:not([readonly]) > mele-wrapper > mele-body-wrapper > mele-body > .mele-item {
  min-height: unset !important;
  background: var(--bg1);
  margin: 1px;
  border: 1px solid var(--bg3);
  border-radius: 12px;
}
.mele-list[multi][show=selected]:not([readonly]) > mele-wrapper > mele-body-wrapper > mele-body > .mele-item > mele-labels {
  order: 1;
}
.mele-list[multi][show=selected]:not([readonly]) > mele-wrapper > mele-body-wrapper > mele-body > .mele-item > mele-icon.remove {
  display: flex;
  order: 2;
  height: 16px;
}

/* HIGHLIGHT SELECTED ITEMS UNLESS ONLY SELECTED ARE DISPLAYED */
.mele-list:not([show=selected]):not([readonly]):not(.noselect) > mele-wrapper > mele-body-wrapper > mele-body > .mele-item:hover {
  background: var(--bg3_transparent);
}
.mele-list:not([show=selected]):not([readonly]):not(.noselect) > mele-wrapper > mele-body-wrapper > mele-body > .mele-item[selected] {
  background: var(--blue);
  color: var(--white);
}
.mele-list:not([show=selected]):not([readonly]):not(.noselect) > mele-wrapper > mele-body-wrapper > mele-body > .mele-item[selected] mele-labels > mele-label {
  color: var(--white);
}
.mele-list:not([show=selected]):not([readonly]):not(.noselect) > mele-wrapper > mele-body-wrapper > mele-body > .mele-item[selected] mele-labels > mele-label2 {
  color: var(--white);
  opacity: 0.7;
}
.mele-list:not([show=selected]):not([readonly]):not(.noselect) > mele-wrapper > mele-body-wrapper > mele-body > .mele-item[selected] [stroke=fg] {
  stroke: var(--white);
}
.mele-list:not([show=selected]):not([readonly]):not(.noselect) > mele-wrapper > mele-body-wrapper > mele-body > .mele-item[selected] [fill=fg] {
  fill: var(--white);
}
.mele-list:not([show=selected]):not([readonly]):not(.noselect) > mele-wrapper > mele-body-wrapper > mele-body > .mele-item[selected] [stroke=bg] {
  stroke: none;
}
.mele-list:not([show=selected]):not([readonly]):not(.noselect) > mele-wrapper > mele-body-wrapper > mele-body > .mele-item[selected] [fill=bg] {
  fill: none;
}
.mele-list:not([show=selected]):not([readonly]):not(.noselect) > mele-wrapper > mele-body-wrapper > mele-body > .mele-item[selected] > mele-label2 {
  color: var(--white2);
}
.mele-list:not([show=selected]):not([readonly]):not(.noselect) > mele-wrapper > mele-body-wrapper > mele-body > .mele-item[preselected] {
  background: var(--lightblue);
}

/* READONLY; don't display label2, value and toggle indicator */
.mele-list[readonly] > mele-wrapper > mele-body-wrapper > mele-button {
  display: none;
}
.mele-list[readonly] > mele-wrapper > mele-body-wrapper > mele-body > .mele-item {
  cursor: default;
  min-width: auto;
}
.mele-list[readonly] > mele-wrapper > mele-body-wrapper > mele-body > .mele-item::before {
  display: none;
}
.mele-list[readonly] > mele-wrapper > mele-body-wrapper > mele-body > .mele-item > mele-icon.remove {
  display: none;
}
.mele-list[readonly] > mele-wrapper > mele-body-wrapper > mele-body > .mele-item > mele-labels > mele-label2 {
  display: none;
}
.mele-list[readonly] > mele-wrapper > mele-body-wrapper > mele-body > .mele-item > mele-value {
  display: none;
}

/* DISABLED */
.mele-list[disabled] {
  opacity: var(--disabled);
  cursor: not-allowed;
}
.mele-list[disabled] .mele-item {
  cursor: not-allowed;
}

/* DISABLE COLLPASE ICON */
.mele-list[noncollapsible] > mele-wrapper > mele-body-wrapper > mele-body > .mele-item > mele-icon.collapse,
.mele-list > mele-wrapper > mele-body-wrapper > mele-body > .mele-item[disabled] > mele-icon.collapse {
  display: none;
}

/* ITEM DESIGNS */
.mele-list:not([design]) > mele-wrapper > mele-body-wrapper > mele-body > .mele-item, .mele-list[design=none] > mele-wrapper > mele-body-wrapper > mele-body > .mele-item {
  border: none;
}

.mele-list[design=group] > mele-wrapper > mele-body-wrapper > mele-body > .mele-item {
  border: 1px solid var(--bg3);
}
.mele-list[design=group] > mele-wrapper > mele-body-wrapper > mele-body > .mele-item::before {
  border-radius: 50%;
  width: var(--base_margin);
  height: var(--base_height_25);
  border: 1px solid transparent;
}

.mele-list[design=group]:not([show=selected]) > mele-wrapper > mele-body-wrapper > mele-body .mele-item[selected] {
  border-color: transparent;
}
.mele-list[design=group]:not([show=selected]) > mele-wrapper > mele-body-wrapper > mele-body .mele-item:nth-child(1) {
  border-radius: var(--base_margin) var(--base_margin) 0px 0px;
}
.mele-list[design=group]:not([show=selected]) > mele-wrapper > mele-body-wrapper > mele-body .mele-item:last-child {
  border-radius: 0px 0px var(--base_margin) var(--base_margin);
}

.mele-list[design=group][direction=row]:not([show=selected]) > mele-wrapper > mele-body-wrapper > mele-body > .mele-item:nth-child(1) {
  border-radius: var(--base_margin) 0px 0px var(--base_margin);
}
.mele-list[design=group][direction=row]:not([show=selected]) > mele-wrapper > mele-body-wrapper > mele-body > .mele-item:last-child {
  border-radius: 0px var(--base_margin) var(--base_margin) 0px;
}

.mele-list[design=oval] > mele-wrapper > mele-body-wrapper > mele-body > .mele-item {
  border: 1px solid var(--bg3);
  border-radius: var(--base_height_50);
  margin: var(--small_margin) var(--base_margin);
}
.mele-list[design=oval] > mele-wrapper > mele-body-wrapper > mele-body > .mele-item::before {
  border-radius: 50%;
  width: var(--base_margin);
  height: var(--base_height_25);
  border: 1px solid transparent;
}

.mele-list[design=toolbar] > mele-wrapper > mele-body-wrapper > mele-body {
  flex: none;
}
.mele-list[design=toolbar] > mele-wrapper > mele-body-wrapper > mele-body > .mele-item {
  border: none;
  padding: 0px;
  min-height: var(--base_height);
  max-height: var(--base_height);
  height: var(--base_height);
}
.mele-list[design=toolbar] > mele-wrapper > mele-body-wrapper > mele-body > .mele-item > mele-icon {
  width: var(--base_height);
  height: var(--base_height);
}
.mele-list[design=toolbar] > mele-wrapper > mele-body-wrapper > mele-body > .mele-item > mele-icon > svg, .mele-list[design=toolbar] > mele-wrapper > mele-body-wrapper > mele-body > .mele-item > mele-icon > img {
  width: var(--base_height_50);
  height: var(--base_height_50);
}

.mele-list[design=block] > mele-wrapper > mele-body-wrapper > mele-body > .mele-item {
  border: 1px solid var(--bg3);
  margin: var(--small_margin) var(--base_margin);
}

.mele-list[design=grid] > mele-wrapper > mele-body-wrapper > mele-body > .mele-item {
  border: 1px solid var(--bg3);
  width: var(--base_width);
  margin: var(--small_margin) var(--base_margin);
}
.mele-list[design=grid] > mele-wrapper > mele-body-wrapper > mele-body > .mele-item > mele-labels {
  align-items: center;
}
.mele-list[design=grid] > mele-wrapper > mele-body-wrapper > mele-body > .mele-item > mele-labels > * {
  align-items: center;
  text-align: center;
}

.mele-list[design=tag] > mele-wrapper > mele-body-wrapper > mele-body > .mele-item {
  background: var(--bg3);
  border-radius: 0px var(--base_height_50) var(--base_height_50) 0px;
  margin: var(--small_margin) var(--base_margin);
  padding-right: var(--base_margin);
}
.mele-list[design=tag] > mele-wrapper > mele-body-wrapper > mele-body > .mele-item::after {
  background: var(--bg1);
  border-radius: 50%;
  box-shadow: inset 0 1px rgba(0, 0, 0, 0.25);
  content: "";
  height: var(--base_height_25);
  width: var(--base_height_25);
}

.mele-list[design=tag][direction=row] > mele-wrapper > mele-body-wrapper > mele-body > .mele-item::after {
  height: var(--base_height_25);
  width: var(--base_height_25);
}

.mele-list[design=user] > mele-wrapper > mele-body-wrapper > mele-body > .mele-item {
  background: var(--bg3);
  border-radius: 0px var(--base_height_50) var(--base_height_50) 0px;
  margin: var(--small_margin) var(--base_margin);
  padding: var(--base_margin);
}
.mele-list[design=user] > mele-wrapper > mele-body-wrapper > mele-body > .mele-item > mele-labels {
  margin: 4px;
}
.mele-list[design=user] > mele-wrapper > mele-body-wrapper > mele-body > .mele-item > mele-icon {
  order: 90;
  margin: 4px;
}
.mele-list[design=user] > mele-wrapper > mele-body-wrapper > mele-button[key=listright] {
  margin: 4px 8px;
}

.mele-list[design=appwall] > mele-wrapper > mele-body-wrapper > mele-body {
  display: grid !important;
  grid-template-columns: repeat(3, 1fr);
}
.mele-list[design=appwall] > mele-wrapper > mele-body-wrapper > mele-body > .mele-item {
  height: var(--base_height) !important;
  border-bottom: 1px solid var(--bg3) !important;
  margin: 0px !important;
  flex-basis: 33% !important;
  box-sizing: border-box !important;
}
.mele-list[design=appwall] > mele-wrapper > mele-body-wrapper > mele-body > .mele-item:nth-of-type(3n+1), .mele-list[design=appwall] > mele-wrapper > mele-body-wrapper > mele-body > .mele-item:nth-of-type(3n+2) {
  border-right: 1px solid var(--bg3) !important;
}
.mele-list[design=appwall] > mele-wrapper > mele-body-wrapper > mele-body > .mele-item:not([key]) {
  grid-column: span 3 !important;
  flex-basis: 100% !important;
  color: var(--white);
  background: var(--bg3);
  min-height: auto;
  height: 18px !important;
}

.mele-list[design=datetime] > mele-wrapper > mele-body-wrapper > mele-body > .mele-item {
  margin: 0;
  padding: 0 !important;
}

/* DON'T DISPLAY SEARCHBAR IN LOOKUP-LIKE VIEW, ONLY WHEN CLICKED ON ADD ICON */
.mele-list[direction=row][show=selected] > mele-wrapper > mele-header-wrapper > mele-header[key=search] {
  display: none;
}

/* DON'T SHOW BORDER AROUND SELECTED ITEM */
.mele-list:not([show=selected]) > mele-wrapper > mele-body-wrapper > mele-body > .mele-item[selected] {
  border-color: transparent;
}

/* STYLING OF WAIT ICON */
.mele-list > mele-wrapper > mele-header-wrapper > mele-header > mele-image[icon="sys.wait"] {
  position: absolute;
  right: 8px;
  top: 8px;
  bottom: 8px;
  z-index: 50;
  padding: 0px;
  height: auto;
}

mele-list[sortable] mele-item.dragover {
  margin-top: var(--base_height);
}
mele-list[sortable] mele-item.dragover::after {
  position: absolute;
  background: var(--bg3_transparent);
  content: " ";
  height: var(--base_height);
  width: 100%;
  bottom: var(--base_height);
}

.mele-list[autoselectable] > mele-wrapper > mele-header-wrapper > mele-button[key=autoselectable] {
  position: absolute;
  right: 0;
}
.mele-list[autoselectable] > mele-wrapper > mele-header-wrapper > mele-button[key=autoselectable][selected] {
  background: var(--blue) !important;
}

.mele-view[key=filter] .input-wrapper {
  display: flex;
  align-items: center;
  padding: 4px;
}
.mele-view[key=filter] .input-wrapper .input-labels {
  display: flex;
  flex-direction: column;
  flex: 1;
  order: 10;
}
.mele-view[key=filter] .input-wrapper .input-value {
  display: flex;
  flex: 1;
  order: 25;
  font-size: var(--font2);
  padding: 0px 8px;
}

/* GENERIC STYLING */
.mele-map {
  display: flex;
  flex-direction: row;
  /* unavailable pane */
  /* search bar / search list */
  /* layer button and layer list */
  /* list of drawing shapes */
  /* GPS button */
}
.mele-map .leaflet-mosy-pane {
  z-index: 400;
}
.mele-map .leaflet-mosy-search-pane {
  z-index: 500;
}
.mele-map .leaflet-mosy-draw-pane {
  z-index: 600;
}
.mele-map > mele-wrapper > mele-body-wrapper > mele-body {
  min-height: 240px;
  z-index: 10;
}
.mele-map mele-text[key=unavailable] {
  display: flex;
  height: inherit;
  width: 100%;
  background: var(--bg3);
  text-align: center;
  justify-content: center;
  flex-direction: column;
  z-index: 200;
}
.mele-map:not([unavailable]) mele-text[key=unavailable] {
  display: none;
}
.mele-map[role~=narrow] mele-search {
  max-height: 35%;
  padding: 0px;
  padding-top: var(--base_margin);
}
.mele-map mele-search {
  position: absolute;
  z-index: 120;
  left: 0px;
  top: 0px;
  width: var(--sidebar_width);
  max-height: 80%;
  padding: var(--base_margin);
  box-sizing: border-box;
}
.mele-map mele-search > mele-wrapper > mele-header-wrapper > mele-header[key=search] {
  min-height: inherit !important;
}
.mele-map mele-search > mele-wrapper > mele-header-wrapper > mele-header[key=search] > mele-input {
  padding: 0px;
}
.mele-map mele-search > mele-wrapper > mele-header-wrapper > mele-header[key=search] > mele-input > mele-value {
  padding: 0px;
}
.mele-map mele-search > mele-wrapper > mele-header-wrapper > mele-header[key=search] > mele-input > mele-value mele-value-wrapper {
  border: none;
}
.mele-map mele-search > mele-wrapper > mele-header-wrapper > mele-header[key=search] > mele-input > mele-value input {
  border: none;
}
.mele-map mele-search > mele-icon.left {
  position: absolute;
  left: 0px;
  opacity: 0.5;
  z-index: 100;
}
.mele-map mele-search > mele-icon.left svg {
  width: 16px;
}
.mele-map mele-button[key=layerbutton] {
  position: absolute;
  z-index: 110;
  right: var(--base_margin);
  top: var(--base_margin);
  height: var(--small_height);
  width: var(--small_height);
  min-width: var(--small_height);
  opacity: 0.5;
}
.mele-map mele-button[key=layerbutton]:hover {
  opacity: 1;
}
.mele-map mele-list[key=layerlist] {
  position: absolute;
  z-index: 110;
  right: var(--base_margin);
  top: var(--base_margin);
  margin-right: var(--small_height);
  width: auto;
  background: var(--bg1);
}
.mele-map mele-list[key=layerlist] mele-item:not([key]) {
  display: none;
}
.mele-map mele-list[key=layerlist] mele-item {
  padding: 0px !important;
  width: var(--small_height) !important;
  min-width: var(--small_height) !important;
  height: var(--small_height) !important;
  min-height: var(--small_height) !important;
}
.mele-map:not([layerbutton]) mele-button[key=layerbutton] {
  display: none;
}
.mele-map:not([layerlist]) mele-list[key=layerlist] {
  display: none;
}
.mele-map[layerlist] mele-button[key=layerbutton] {
  opacity: 1;
}
.mele-map mele-list[key=shapelist] {
  position: absolute;
  z-index: 110;
  right: var(--base_margin);
  top: var(--small_height);
  margin-top: var(--base_margin);
  width: auto;
}
.mele-map mele-list[key=shapelist] mele-item {
  padding: 0px !important;
  width: var(--small_height) !important;
  min-width: var(--small_height) !important;
  height: var(--small_height) !important;
  min-height: var(--small_height) !important;
}
.mele-map:not([layerlist]):not([layerbutton]) mele-list[key=shapelist] {
  top: 0px;
}
.mele-map:not([shapebutton]) mele-list[key=shapelist] {
  display: none;
}
.mele-map:not([shapelist]) mele-list[key=shapelist] mele-item:not([selected]) {
  display: none;
}
.mele-map:not([shapelist]) mele-item:not([key]) {
  background: var(--bg1) !important;
  opacity: 0.7 !important;
}
.mele-map:not([shapelist]) mele-item:not([key]):hover {
  opacity: 1 !important;
}
.mele-map:not([shapelist]) mele-item:not([key]) [stroke=fg] {
  stroke: var(--fg1) !important;
}
.mele-map:not([shapelist]) mele-item:not([key]) [fill=bg] {
  fill: var(--bg1) !important;
}
.mele-map:not([shapelist]) mele-item:not([key]) > mele-icon.left {
  opacity: 0.5 !important;
}
.mele-map:not([shapelist]) mele-item:not([key]) > mele-icon.left:hover {
  opacity: 1 !important;
}
.mele-map[shapelist] mele-list[key=shapelist] {
  background: var(--bg1);
}
.mele-map mele-button[key=gpsbutton] {
  position: absolute;
  z-index: 100;
  right: var(--base_margin);
  bottom: var(--base_margin);
  height: var(--small_height);
  width: var(--small_height);
  min-width: var(--small_height);
  opacity: 0.5;
}
.mele-map mele-button[key=gpsbutton]:hover {
  opacity: 1;
}
.mele-map:not([gpsbutton]) mele-button[key=gpsbutton] {
  display: none;
}

.mele-map[disabled] mele-search {
  display: none;
}

.mele-map .leaflet-mosy-search-pane div[marker]:not(.selected) mele-labels {
  display: none;
}
.mele-map .leaflet-mosy-search-pane mele-marker:not([selected]) {
  background: none;
  border: none;
  box-shadow: none;
  width: 0px;
  min-width: 0px;
  padding: 0px;
}
.mele-map .leaflet-mosy-search-pane mele-marker:not([selected]) > * {
  display: none;
}
.mele-map .leaflet-mosy-search-pane mele-marker:not([selected]) > mele-icon.right {
  display: flex;
}

[behavior=phone] .mele-map mele-search {
  width: 100%;
}
[behavior=phone] .mele-map mele-search input:hover, [behavior=phone] .mele-map mele-search input:focus {
  width: initial;
}
[behavior=phone] .mele-map mele-search > mele-wrapper > mele-header-wrapper > mele-header[key=search] mele-input input {
  background-color: transparent;
}
[behavior=phone] .mele-map mele-search > mele-wrapper > mele-header-wrapper > mele-header[key=search] mele-input input:focus {
  background: var(--bg1);
}
[behavior=phone] .mele-map[search] mele-search > mele-wrapper > mele-header-wrapper > mele-header[key=search] mele-input input {
  background-color: var(--bg1);
}
[behavior=phone] .mele-map[searchlist] mele-search input, [behavior=phone] .mele-map[search] mele-search input {
  width: initial;
}
[behavior=phone] .mele-map mele-list[key=layerlist] {
  margin-right: 0px;
  margin-left: var(--small_height);
  right: initial;
  top: unset;
  left: 0px;
  bottom: 4px;
}
[behavior=phone] .mele-map mele-button[key=layerbutton] {
  right: initial;
  top: unset;
  left: 0px;
  bottom: 4px;
}
[behavior=phone] .mele-map mele-list[key=shapelist] {
  margin-right: 0px;
  margin-top: 0px;
  right: initial;
  top: initial !important;
  bottom: 0px;
  left: 0px;
}
[behavior=phone] .mele-map[shapelist] mele-list[key=shapelist] {
  right: 0px;
}
[behavior=phone] .mele-map mele-button[key=gpsbutton] {
  right: 0px;
  bottom: 0px;
}

.mele-view[readonly] .mele-map .leaflet-marker-icon > mele-button {
  display: block !important;
}

.mele-map[shape] mele-body.leaflet-container:not(.leaflet-drag-target) {
  cursor: crosshair;
}

.mele-modal .mele-map {
  height: 100%;
}

.mele-modal.editgeo mele-marker mele-icon {
  box-shadow: none !important;
  border: none !important;
}

.mele-map {
  /* STYLING SHAPES */
  /* STYLING MARKERS */
}
.mele-map path[marker] {
  stroke: var(--fg1);
  fill-opacity: 0.5;
}
.mele-map path[marker]:not([fill=none]) {
  fill: var(--gray);
}
.mele-map path[marker][marker=marker], .mele-map path[marker][marker=address] {
  z-index: 1100;
  stroke: var(--black);
}
.mele-map path[marker][marker=marker]:not([fill=none]), .mele-map path[marker][marker=address]:not([fill=none]) {
  fill: var(--gray);
}
.mele-map path[marker][marker=sign] {
  z-index: 1200;
  stroke: violet;
}
.mele-map path[marker][marker=sign]:not([fill=none]) {
  fill: violet;
}
.mele-map path[marker][marker=instruction] {
  z-index: 1300;
  stroke: var(--blue);
}
.mele-map path[marker][marker=instruction]:not([fill=none]) {
  fill: var(--blue);
}
.mele-map path[marker][marker=incident] {
  z-index: 1400;
  stroke: var(--red);
}
.mele-map path[marker][marker=incident]:not([fill=none]) {
  fill: var(--red);
}
.mele-map path[marker][marker=unit] {
  z-index: 1500;
  stroke: transparent;
  fill: transparent;
}
.mele-map path[marker][marker=drawing] {
  z-index: 1600;
  stroke: coral;
}
.mele-map path[marker][marker=drawing]:not([fill=none]) {
  fill: coral;
}
.mele-map path[marker][marker=guide] {
  z-index: 1700;
  stroke: coral;
  stroke-width: 1px;
}
.mele-map path[marker][marker=guide]:not([fill=none]) {
  fill: coral;
}
.mele-map path[marker][marker=accident] {
  z-index: 1800;
  stroke: coral;
  stroke-width: 1px;
}
.mele-map path[marker][marker=accident]:not([fill=none]) {
  fill: coral;
}
.mele-map div[marker] > mele-button {
  margin-top: var(--base_height_50);
  margin-left: var(--base_height_25);
  width: 32px;
  height: 32px;
  min-width: 32px;
  background: none;
  margin: 0px;
  border: none;
  display: flex;
  overflow: visible;
}
.mele-map div[marker] > mele-button::before {
  display: none;
}
.mele-map div[marker] > mele-button mele-icon {
  width: 32px;
  height: 32px;
}
.mele-map div[marker] > mele-button mele-icon > svg, .mele-map div[marker] > mele-button mele-icon > img {
  width: 32px;
  height: 32px;
}
.mele-map div[marker] > mele-button mele-labels {
  position: absolute;
  bottom: 32px;
  align-items: center;
  padding: 4px;
}
.mele-map div[marker] > mele-button mele-labels > * {
  white-space: nowrap;
  max-width: var(--base_width);
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
}
.mele-map div[marker] > mele-button mele-labels mele-label {
  font-family: var(--font_bold);
}
.mele-map div[marker] {
  z-index: 1100 !important;
}
.mele-map div[marker=sign] {
  z-index: 1200 !important;
}
.mele-map div[marker=instruction] {
  z-index: 1300 !important;
}
.mele-map div[marker=incident] {
  z-index: 1400 !important;
}
.mele-map div[marker=unit] {
  z-index: 1500 !important;
}
.mele-map div[marker=gps] {
  z-index: 1600 !important;
}
.mele-map div[marker=accident] {
  z-index: 1800 !important;
}
.mele-map div.selected[marker] {
  z-index: 2100 !important;
}
.mele-map div.selected[marker=sign] {
  z-index: 2200 !important;
}
.mele-map div.selected[marker=instruction] {
  z-index: 2300 !important;
}
.mele-map div.selected[marker=incident] {
  z-index: 2400 !important;
}
.mele-map div.selected[marker=unit] {
  z-index: 2500 !important;
}
.mele-map div.selected[marker=gps] {
  z-index: 2600 !important;
}
.mele-map div.selected[marker=accident] {
  z-index: 2800 !important;
}
.mele-map div[marker] {
  outline: none;
}
.mele-map div[marker].selected > mele-button > mele-labels {
  box-shadow: 0px 0px 4px 2px var(--blue);
  border: 1px solid var(--bg1);
}
.mele-map div[marker=marker] > mele-button > mele-labels, .mele-map div[marker=address] > mele-button > mele-labels {
  background: var(--bg1_semitransparent);
  padding: 0px 8px;
  margin-bottom: -4px;
  border-radius: 4px;
}
.mele-map div[marker=drawing] > mele-button > mele-icon [fill=bg] {
  fill: white;
  fill-opacity: 0.5;
}
.mele-map div[marker=drawing] > mele-button > mele-icon [stroke=fg] {
  stroke: coral;
}
.mele-map div[marker=sign] > mele-button > mele-labels {
  background: var(--bg1);
  padding: 0px 8px;
  margin-bottom: -4px;
}
.mele-map div[marker=gps] > mele-button [fill=bg] {
  fill: gold;
}
.mele-map div[marker=gps] > mele-button [stroke=fg] {
  stroke: var(--fg1);
}
.mele-map div[marker=gps].selected > mele-button > mele-icon {
  box-shadow: 0px 0px 4px 2px var(--blue);
  border: 1px solid var(--bg1);
  border-radius: 50%;
}
.mele-map div[marker=instruction] > mele-button {
  color: var(--white);
}
.mele-map div[marker=instruction] > mele-button [stroke=fg] {
  stroke: var(--blue);
}
.mele-map div[marker=instruction] > mele-button [fill=bg] {
  fill: var(--white);
}
.mele-map div[marker=instruction] > mele-button > mele-labels {
  background: var(--blue);
  padding: 2px 8px;
}
.mele-map div[marker=instruction] > mele-button > mele-labels mele-label {
  color: var(--white);
  font-size: var(--font3);
}
.mele-map div[marker=instruction] > mele-button > mele-labels mele-label2 {
  color: var(--white);
  text-transform: uppercase;
  font-size: var(--font3);
  max-width: calc(var(--base_width) * 1.5);
}
.mele-map div[marker=incident] > mele-button > mele-labels {
  background: var(--blue);
  bottom: initial;
  padding: 2px 8px;
}
.mele-map div[marker=incident] > mele-button > mele-labels mele-label {
  color: var(--white);
  font-size: var(--font5);
}
.mele-map div[marker=incident] > mele-button > mele-labels mele-label2 {
  color: var(--white);
  text-transform: uppercase;
  font-size: var(--font5);
}
.mele-map div[marker=incident][color] > mele-button {
  color: var(--white);
}
.mele-map div[marker=incident][color] > mele-button > mele-labels {
  background: var(--gray_transparent);
}
.mele-map div[marker=incident][color] > mele-button [fill=bg] {
  fill: var(--gray);
}
.mele-map div[marker=incident][color=green] > mele-button > mele-labels {
  background: var(--green_transparent);
}
.mele-map div[marker=incident][color=green] > mele-button [fill=bg] {
  fill: var(--green);
}
.mele-map div[marker=incident][color=orange] > mele-button > mele-labels {
  background: var(--orange_transparent);
}
.mele-map div[marker=incident][color=orange] > mele-button [fill=bg] {
  fill: var(--orange);
}
.mele-map div[marker=incident][color=red] > mele-button > mele-labels {
  background: var(--red_transparent);
}
.mele-map div[marker=incident][color=red] > mele-button [fill=bg] {
  fill: var(--red);
}
.mele-map div[marker=accident] > mele-button > mele-labels {
  background: var(--blue);
  bottom: initial;
  padding: 2px 8px;
}
.mele-map div[marker=accident] > mele-button > mele-labels mele-label {
  color: var(--white);
  font-size: var(--font5);
}
.mele-map div[marker=accident] > mele-button > mele-labels mele-label2 {
  color: var(--white);
  text-transform: uppercase;
  font-size: var(--font5);
}
.mele-map div[marker=accident][color] > mele-button {
  color: var(--white);
}
.mele-map div[marker=accident][color] > mele-button > mele-labels {
  background: var(--gray_transparent);
}
.mele-map div[marker=accident][color] > mele-button [fill=bg] {
  fill: var(--gray);
}
.mele-map div[marker=accident][color=green] > mele-button > mele-labels {
  background: var(--green_transparent);
}
.mele-map div[marker=accident][color=green] > mele-button [fill=bg] {
  fill: var(--green);
}
.mele-map div[marker=accident][color=orange] > mele-button > mele-labels {
  background: var(--orange_transparent);
}
.mele-map div[marker=accident][color=orange] > mele-button [fill=bg] {
  fill: var(--orange);
}
.mele-map div[marker=accident][color=red] > mele-button > mele-labels {
  background: var(--red_transparent);
}
.mele-map div[marker=accident][color=red] > mele-button [fill=bg] {
  fill: var(--red);
}
.mele-map div[marker=unit] > mele-button > mele-labels {
  padding: 0px 8px;
  margin-bottom: -5px;
  border-radius: 4px;
}
.mele-map div[marker=unit] > mele-button > mele-labels mele-label {
  font-size: var(--font4);
  text-align: center;
  margin: 0 auto;
}
.mele-map div[marker=unit][color] > mele-button {
  color: var(--white);
}
.mele-map div[marker=unit][color] > mele-button > mele-labels {
  background: var(--gray_transparent);
}
.mele-map div[marker=unit][color] > mele-button [fill=bg] {
  fill: var(--gray);
}
.mele-map div[marker=unit][color=green] > mele-button > mele-labels {
  background: var(--green_transparent);
}
.mele-map div[marker=unit][color=green] > mele-button [fill=bg] {
  fill: var(--green);
}
.mele-map div[marker=unit][color=orange] > mele-button > mele-labels {
  background: var(--orange_transparent);
}
.mele-map div[marker=unit][color=orange] > mele-button [fill=bg] {
  fill: var(--orange);
}
.mele-map div[marker=unit][color=red] > mele-button > mele-labels {
  background: var(--red_transparent);
}
.mele-map div[marker=unit][color=red] > mele-button [fill=bg] {
  fill: var(--red);
}

.mele-map:not([layers~=place]) .leaflet-mosy-pane path[marker=address]:not(.selected) {
  display: none;
}
.mele-map:not([layers~=place]) .leaflet-mosy-pane div[marker=address]:not(.selected) {
  display: none;
}

.mele-map:not([layers~=sign]) .leaflet-mosy-pane path[marker=sign]:not(.selected) {
  display: none;
}
.mele-map:not([layers~=sign]) .leaflet-mosy-pane div[marker=sign]:not(.selected) {
  display: none;
}

.mele-map:not([layers~=instruction]) .leaflet-mosy-pane path[marker=instruction]:not(.selected) {
  display: none;
}
.mele-map:not([layers~=instruction]) .leaflet-mosy-pane div[marker=instruction]:not(.selected) {
  display: none;
}

.mele-map:not([layers~=incident]) .leaflet-mosy-pane path[marker=incident]:not(.selected) {
  display: none;
}
.mele-map:not([layers~=incident]) .leaflet-mosy-pane div[marker=incident]:not(.selected) {
  display: none;
}

.mele-map:not([layers~=accident]) .leaflet-mosy-pane path[marker=accident]:not(.selected) {
  display: none;
}
.mele-map:not([layers~=accident]) .leaflet-mosy-pane div[marker=accident]:not(.selected) {
  display: none;
}

.mele-map:not([layers~=unit]) .leaflet-mosy-pane path[marker=unit]:not(.selected) {
  display: none;
}
.mele-map:not([layers~=unit]) .leaflet-mosy-pane div[marker=unit]:not(.selected) {
  display: none;
}

.leaflet-pane,
.leaflet-tile,
.leaflet-marker-icon,
.leaflet-marker-shadow,
.leaflet-tile-container,
.leaflet-pane > svg,
.leaflet-pane > canvas,
.leaflet-zoom-box,
.leaflet-image-layer,
.leaflet-layer {
  position: absolute;
  left: 0;
  top: 0;
}

.leaflet-container {
  overflow: hidden;
}

.leaflet-tile,
.leaflet-marker-icon,
.leaflet-marker-shadow {
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
}

/* Safari renders non-retina tile on retina better with this, but Chrome is worse */
.leaflet-safari .leaflet-tile {
  image-rendering: -webkit-optimize-contrast;
}

/* hack that prevents hw layers "stretching" when loading new tiles */
.leaflet-safari .leaflet-tile-container {
  width: 1600px;
  height: 1600px;
  -webkit-transform-origin: 0 0;
}

.leaflet-marker-icon,
.leaflet-marker-shadow {
  display: block;
}

/* .leaflet-container svg: reset svg max-width decleration shipped in Joomla! (joomla.org) 3.x */
/* .leaflet-container img: map is broken in FF if you have max-width: 100% on tiles */
.leaflet-container .leaflet-overlay-pane svg,
.leaflet-container .leaflet-marker-pane img,
.leaflet-container .leaflet-shadow-pane img,
.leaflet-container .leaflet-tile-pane img,
.leaflet-container img.leaflet-image-layer {
  max-width: none !important;
}

.leaflet-container.leaflet-touch-zoom {
  -ms-touch-action: pan-x pan-y;
  touch-action: pan-x pan-y;
}

.leaflet-container.leaflet-touch-drag {
  -ms-touch-action: pinch-zoom;
}

.leaflet-container.leaflet-touch-drag.leaflet-touch-zoom {
  -ms-touch-action: none;
  touch-action: none;
}

.leaflet-tile {
  filter: inherit;
  visibility: hidden;
}

.leaflet-tile-loaded {
  visibility: inherit;
}

.leaflet-zoom-box {
  width: 0;
  height: 0;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  z-index: 800;
}

/* workaround for https://bugzilla.mozilla.org/show_bug.cgi?id=888319 */
.leaflet-overlay-pane svg {
  -moz-user-select: none;
}

.leaflet-pane {
  z-index: 400;
}

.leaflet-tile-pane {
  z-index: 200;
}

.leaflet-overlay-pane {
  z-index: 400;
}

.leaflet-shadow-pane {
  z-index: 500;
}

.leaflet-marker-pane {
  z-index: 600;
}

.leaflet-tooltip-pane {
  z-index: 650;
}

.leaflet-popup-pane {
  z-index: 700;
}

.leaflet-map-pane canvas {
  z-index: 100;
}

.leaflet-map-pane svg {
  z-index: 200;
}

.leaflet-vml-shape {
  width: 1px;
  height: 1px;
}

.lvml {
  behavior: url(#default#VML);
  display: inline-block;
  position: absolute;
}

/* control positioning */
.leaflet-control {
  position: relative;
  z-index: 800;
  pointer-events: visiblePainted;
  /* IE 9-10 doesn't have auto */
  pointer-events: auto;
}

.leaflet-top,
.leaflet-bottom {
  position: absolute;
  z-index: 1000;
  pointer-events: none;
}

.leaflet-top {
  top: 0;
}

.leaflet-right {
  right: 0;
}

.leaflet-bottom {
  bottom: 0;
}

.leaflet-left {
  left: 0;
}

.leaflet-control {
  float: left;
  clear: both;
}

.leaflet-right .leaflet-control {
  float: right;
}

.leaflet-top .leaflet-control {
  margin-top: 10px;
}

.leaflet-bottom .leaflet-control {
  margin-bottom: 10px;
}

.leaflet-left .leaflet-control {
  margin-left: 10px;
}

.leaflet-right .leaflet-control {
  margin-right: 10px;
}

/* zoom and fade animations */
.leaflet-fade-anim .leaflet-tile {
  will-change: opacity;
}

.leaflet-fade-anim .leaflet-popup {
  opacity: 0;
  -webkit-transition: opacity 0.2s linear;
  -moz-transition: opacity 0.2s linear;
  -o-transition: opacity 0.2s linear;
  transition: opacity 0.2s linear;
}

.leaflet-fade-anim .leaflet-map-pane .leaflet-popup {
  opacity: 1;
}

.leaflet-zoom-animated {
  -webkit-transform-origin: 0 0;
  -ms-transform-origin: 0 0;
  transform-origin: 0 0;
}

.leaflet-zoom-anim .leaflet-zoom-animated {
  will-change: transform;
}

.leaflet-zoom-anim .leaflet-zoom-animated {
  -webkit-transition: -webkit-transform 0.25s cubic-bezier(0, 0, 0.25, 1);
  -moz-transition: -moz-transform 0.25s cubic-bezier(0, 0, 0.25, 1);
  -o-transition: -o-transform 0.25s cubic-bezier(0, 0, 0.25, 1);
  transition: transform 0.25s cubic-bezier(0, 0, 0.25, 1);
}

.leaflet-zoom-anim .leaflet-tile,
.leaflet-pan-anim .leaflet-tile {
  -webkit-transition: none;
  -moz-transition: none;
  -o-transition: none;
  transition: none;
}

.leaflet-zoom-anim .leaflet-zoom-hide {
  visibility: hidden;
}

/* cursors */
.leaflet-interactive {
  cursor: pointer;
}

.leaflet-grab {
  cursor: -webkit-grab;
  cursor: -moz-grab;
}

.leaflet-crosshair,
.leaflet-crosshair .leaflet-interactive {
  cursor: crosshair;
}

.leaflet-popup-pane,
.leaflet-control {
  cursor: auto;
}

.leaflet-dragging .leaflet-grab,
.leaflet-dragging .leaflet-grab .leaflet-interactive,
.leaflet-dragging .leaflet-marker-draggable {
  cursor: move;
  cursor: -webkit-grabbing;
  cursor: -moz-grabbing;
}

.leaflet-marker-icon {
  padding: 0 !important;
}

/* marker & overlays interactivity */
.leaflet-marker-icon,
.leaflet-marker-shadow,
.leaflet-image-layer,
.leaflet-pane > svg path,
.leaflet-tile-container {
  pointer-events: none;
}

.leaflet-marker-icon.leaflet-interactive,
.leaflet-image-layer.leaflet-interactive,
.leaflet-pane > svg path.leaflet-interactive {
  pointer-events: visiblePainted;
  /* IE 9-10 doesn't have auto */
  pointer-events: auto;
}

/* visual tweaks */
.leaflet-container {
  background: #ddd;
  outline: 0;
}

.leaflet-container a {
  color: #0078A8;
}

.leaflet-container a.leaflet-active {
  outline: 2px solid orange;
}

.leaflet-zoom-box {
  border: 2px dotted #38f;
  background: rgba(255, 255, 255, 0.5);
}

/* general typography */
.leaflet-container {
  font: 12px/1.5 "Helvetica Neue", Arial, Helvetica, sans-serif;
}

/* general toolbar styles */
.leaflet-bar {
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.65);
  border-radius: 4px;
}

.leaflet-bar a,
.leaflet-bar a:hover {
  background-color: #fff;
  border-bottom: 1px solid #ccc;
  width: 26px;
  height: 26px;
  line-height: 26px;
  display: block;
  text-align: center;
  text-decoration: none;
  color: black;
}

.leaflet-bar a,
.leaflet-control-layers-toggle {
  background-position: 50% 50%;
  background-repeat: no-repeat;
  display: block;
}

.leaflet-bar a:hover {
  background-color: #f4f4f4;
}

.leaflet-bar a:first-child {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}

.leaflet-bar a:last-child {
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  border-bottom: none;
}

.leaflet-bar a.leaflet-disabled {
  cursor: default;
  background-color: #f4f4f4;
  color: #bbb;
}

.leaflet-touch .leaflet-bar a {
  width: 30px;
  height: 30px;
  line-height: 30px;
}

/* zoom control */
.leaflet-control-zoom-in,
.leaflet-control-zoom-out {
  font: bold 18px "Lucida Console", Monaco, monospace;
  text-indent: 1px;
}

.leaflet-control-zoom-out {
  font-size: 20px;
}

.leaflet-touch .leaflet-control-zoom-in {
  font-size: 22px;
}

.leaflet-touch .leaflet-control-zoom-out {
  font-size: 24px;
}

/* layers control */
.leaflet-control-layers {
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.4);
  background: #fff;
  border-radius: 5px;
}

.leaflet-control-layers-toggle {
  width: 36px;
  height: 36px;
}

.leaflet-retina .leaflet-control-layers-toggle {
  background-size: 26px 26px;
}

.leaflet-touch .leaflet-control-layers-toggle {
  width: 44px;
  height: 44px;
}

.leaflet-control-layers .leaflet-control-layers-list,
.leaflet-control-layers-expanded .leaflet-control-layers-toggle {
  display: none;
}

.leaflet-control-layers-expanded .leaflet-control-layers-list {
  display: block;
  position: relative;
}

.leaflet-control-layers-expanded {
  padding: 6px 10px 6px 6px;
  color: #333;
  background: #fff;
}

.leaflet-control-layers-scrollbar {
  overflow-y: scroll;
  padding-right: 5px;
}

.leaflet-control-layers-selector {
  margin-top: 2px;
  position: relative;
  top: 1px;
}

.leaflet-control-layers label {
  display: block;
}

.leaflet-control-layers-separator {
  height: 0;
  border-top: 1px solid #ddd;
  margin: 5px -10px 5px -6px;
}

/* Default icon URLs */
/* attribution and scale controls */
.leaflet-container .leaflet-control-attribution {
  background: #fff;
  background: rgba(255, 255, 255, 0.7);
  margin: 0;
}

.leaflet-control-attribution,
.leaflet-control-scale-line {
  padding: 0 5px;
  color: #333;
}

.leaflet-control-attribution a {
  text-decoration: none;
}

.leaflet-control-attribution a:hover {
  text-decoration: underline;
}

.leaflet-container .leaflet-control-attribution,
.leaflet-container .leaflet-control-scale {
  font-size: 11px;
}

.leaflet-left .leaflet-control-scale {
  margin-left: 5px;
}

.leaflet-bottom .leaflet-control-scale {
  margin-bottom: 5px;
}

.leaflet-control-scale-line {
  border: 2px solid #777;
  border-top: none;
  line-height: 1.1;
  padding: 2px 5px 1px;
  font-size: 11px;
  white-space: nowrap;
  overflow: hidden;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  background: #fff;
  background: rgba(255, 255, 255, 0.5);
}

.leaflet-control-scale-line:not(:first-child) {
  border-top: 2px solid #777;
  border-bottom: none;
  margin-top: -2px;
}

.leaflet-control-scale-line:not(:first-child):not(:last-child) {
  border-bottom: 2px solid #777;
}

.leaflet-touch .leaflet-control-attribution,
.leaflet-touch .leaflet-control-layers,
.leaflet-touch .leaflet-bar {
  box-shadow: none;
}

.leaflet-touch .leaflet-control-layers,
.leaflet-touch .leaflet-bar {
  border: 2px solid rgba(0, 0, 0, 0.2);
  background-clip: padding-box;
}

/* popup */
.leaflet-popup {
  position: absolute;
  text-align: center;
  margin-bottom: 20px;
}

.leaflet-popup-content-wrapper {
  padding: 1px;
  text-align: left;
  border-radius: 12px;
}

.leaflet-popup-content {
  margin: 13px 19px;
  line-height: 1.4;
}

.leaflet-popup-content p {
  margin: 18px 0;
}

.leaflet-popup-tip-container {
  width: 40px;
  height: 20px;
  position: absolute;
  left: 50%;
  margin-left: -20px;
  overflow: hidden;
  pointer-events: none;
}

.leaflet-popup-tip {
  width: 17px;
  height: 17px;
  padding: 1px;
  margin: -10px auto 0;
  -webkit-transform: rotate(45deg);
  -moz-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  -o-transform: rotate(45deg);
  transform: rotate(45deg);
}

.leaflet-popup-content-wrapper,
.leaflet-popup-tip {
  background: white;
  color: #333;
  box-shadow: 0 3px 14px rgba(0, 0, 0, 0.4);
}

.leaflet-container a.leaflet-popup-close-button {
  position: absolute;
  top: 0;
  right: 0;
  padding: 4px 4px 0 0;
  border: none;
  text-align: center;
  width: 18px;
  height: 14px;
  font: 16px/14px Tahoma, Verdana, sans-serif;
  color: #c3c3c3;
  text-decoration: none;
  font-weight: bold;
  background: transparent;
}

.leaflet-container a.leaflet-popup-close-button:hover {
  color: #999;
}

.leaflet-popup-scrolled {
  overflow: auto;
  border-bottom: 1px solid #ddd;
  border-top: 1px solid #ddd;
}

.leaflet-oldie .leaflet-popup-content-wrapper {
  zoom: 1;
}

.leaflet-oldie .leaflet-popup-tip {
  width: 24px;
  margin: 0 auto;
  -ms-filter: "progid:DXImageTransform.Microsoft.Matrix(M11=0.70710678, M12=0.70710678, M21=-0.70710678, M22=0.70710678)";
  filter: progid:DXImageTransform.Microsoft.Matrix(M11=0.70710678, M12=0.70710678, M21=-0.70710678, M22=0.70710678);
}

.leaflet-oldie .leaflet-popup-tip-container {
  margin-top: -1px;
}

.leaflet-oldie .leaflet-control-zoom,
.leaflet-oldie .leaflet-control-layers,
.leaflet-oldie .leaflet-popup-content-wrapper,
.leaflet-oldie .leaflet-popup-tip {
  border: 1px solid #999;
}

/* Tooltip */
/* Base styles for the element that has a tooltip */
.leaflet-tooltip {
  position: absolute;
  padding: 6px;
  background-color: #fff;
  border: 1px solid #fff;
  border-radius: 3px;
  color: #222;
  white-space: nowrap;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  pointer-events: none;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
}

.leaflet-tooltip.leaflet-clickable {
  cursor: pointer;
  pointer-events: auto;
}

.leaflet-tooltip-top:before,
.leaflet-tooltip-bottom:before,
.leaflet-tooltip-left:before,
.leaflet-tooltip-right:before {
  position: absolute;
  pointer-events: none;
  border: 6px solid transparent;
  background: transparent;
  content: "";
}

/* Directions */
.leaflet-tooltip-bottom {
  margin-top: 6px;
}

.leaflet-tooltip-top {
  margin-top: -6px;
}

.leaflet-tooltip-bottom:before,
.leaflet-tooltip-top:before {
  left: 50%;
  margin-left: -6px;
}

.leaflet-tooltip-top:before {
  bottom: 0;
  margin-bottom: -12px;
  border-top-color: #fff;
}

.leaflet-tooltip-bottom:before {
  top: 0;
  margin-top: -12px;
  margin-left: -6px;
  border-bottom-color: #fff;
}

.leaflet-tooltip-left {
  margin-left: -6px;
}

.leaflet-tooltip-right {
  margin-left: 6px;
}

.leaflet-tooltip-left:before,
.leaflet-tooltip-right:before {
  top: 50%;
  margin-top: -6px;
}

.leaflet-tooltip-left:before {
  right: 0;
  margin-right: -12px;
  border-left-color: #fff;
}

.leaflet-tooltip-right:before {
  left: 0;
  margin-left: -12px;
  border-right-color: #fff;
}

/* GENERIC STYLING */
.marker-wrapper {
  --marker-background: transparent;
  --marker-heading: 0deg;
  --gps-rotate: 0deg;
  display: grid;
  grid-template-areas: "icon" "labels";
  width: var(--base_height);
  grid-template-rows: auto 1fr;
  position: relative;
  transform: translate(-50%, -40%);
}
.marker-wrapper .marker-actions,
.marker-wrapper > mele-labels > mele-label2 {
  display: none;
}
.marker-wrapper .marker-actions {
  grid-area: actions;
}
.marker-wrapper .marker-icon {
  grid-area: icon;
  display: flex;
  justify-content: center;
  align-items: center;
  width: var(--icon-size);
  height: var(--icon-size);
}
.marker-wrapper .marker-icon [fill=bg] {
  fill: var(--marker-background);
}
.marker-wrapper .marker-icon svg * {
  stroke: var(--fg2);
}
.marker-wrapper .marker-icon .heading {
  transform: rotate(var(--marker-heading));
}
.marker-wrapper > mele-labels {
  grid-area: labels;
  background: var(--marker-background);
  color: var(--white);
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  border-radius: 4px;
}

body[apptype=mOffice] .mele-marker[type=marker] {
  --base_height_50: var(--base_height);
}

.mele-marker[type=marker] {
  transform: translate(-50%, -100%);
}

.mele-marker[type=unit][selected] > mele-actions {
  position: absolute;
  flex-direction: column;
  background: var(--marker-background);
  color: var(--white);
  left: 0;
  transform: translateX(-33%);
  padding: 10px;
}
.mele-marker[type=unit][selected] > mele-actions > mele-button {
  height: var(--small_height);
  color: var(--black);
  background: var(--white);
}
.mele-marker[type=unit][selected] > mele-actions > mele-button > mele-labels > mele-label {
  font-size: var(--font4);
}

.mele-marker[type=gps] {
  width: 44px;
  height: 44px;
  z-index: 99999;
}
.mele-marker[type=gps] mele-icon.right {
  transform: rotate(var(--gps-rotate));
  border-radius: 50%;
  bottom: calc(var(--base_height) * 1.5 * -1);
  box-shadow: none !important;
  border: none !important;
}
.mele-marker[type=gps] mele-icon.right [fill=bg] {
  fill: gold;
}
.mele-marker[type=gps] mele-icon.right [stroke=fg] {
  stroke: var(--fg1);
}

.mele-marker[type=incident],
.mele-marker[type=instruction] {
  width: 50px !important;
  height: 50px !important;
  transform: translate(-27px, -20px);
}
.mele-marker[type=incident] mele-icon.right path[stroke=fg],
.mele-marker[type=instruction] mele-icon.right path[stroke=fg] {
  stroke: var(--font4);
}
.mele-marker[type=incident] mele-icon.right line[stroke=fg],
.mele-marker[type=incident] mele-icon.right circle[stroke=fg],
.mele-marker[type=instruction] mele-icon.right line[stroke=fg],
.mele-marker[type=instruction] mele-icon.right circle[stroke=fg] {
  stroke: var(--white);
}
.mele-marker[type=incident] mele-labels > mele-label,
.mele-marker[type=instruction] mele-labels > mele-label {
  text-align: center;
  margin: 4px;
}
.mele-marker[type=incident] .marker-description,
.mele-marker[type=incident] mele-value,
.mele-marker[type=instruction] .marker-description,
.mele-marker[type=instruction] mele-value {
  display: none;
}

.mele-marker[color=blue] {
  --marker-background: var(--blue) ;
}

.mele-marker[color=black] {
  --marker-background: var(--gray) ;
}

.mele-marker[color=lightblue] {
  --marker-background: var(--lightblue) ;
}

.mele-marker[color=green] {
  --marker-background: var(--green) ;
}

.mele-marker[color=orange] {
  --marker-background: var(--orange) ;
}

.mele-marker[color=red] {
  --marker-background: var(--red) ;
}

:root {
  --space: 20px;
}

/* CONTAINER ITEMS */
body:not([behavior=phone]) .mele-view:not([role~=narrow])[inputwidth="1/1"] > mele-wrapper > mele-body-wrapper > mele-body > mele-input:not([width]), body:not([behavior=phone]) .mele-view:not([role~=narrow]) .mele-container[inputwidth="1/1"] > mele-wrapper > mele-body-wrapper > mele-body > mele-input:not([width]) {
  width: calc( 100% - var(--space));
}
body:not([behavior=phone]) .mele-view:not([role~=narrow])[inputwidth="1/2"] > mele-wrapper > mele-body-wrapper > mele-body > mele-input:not([width]), body:not([behavior=phone]) .mele-view:not([role~=narrow]) .mele-container[inputwidth="1/2"] > mele-wrapper > mele-body-wrapper > mele-body > mele-input:not([width]) {
  width: calc( 50% - var(--space));
}
body:not([behavior=phone]) .mele-view:not([role~=narrow])[inputwidth="1/3"] > mele-wrapper > mele-body-wrapper > mele-body > mele-input:not([width]), body:not([behavior=phone]) .mele-view:not([role~=narrow]) .mele-container[inputwidth="1/3"] > mele-wrapper > mele-body-wrapper > mele-body > mele-input:not([width]) {
  width: calc( 33.333333% - var(--space));
}
body:not([behavior=phone]) .mele-view:not([role~=narrow])[inputwidth="2/3"] > mele-wrapper > mele-body-wrapper > mele-body > mele-input:not([width]), body:not([behavior=phone]) .mele-view:not([role~=narrow]) .mele-container[inputwidth="2/3"] > mele-wrapper > mele-body-wrapper > mele-body > mele-input:not([width]) {
  width: calc( 66.666666% - var(--space));
}
body:not([behavior=phone]) .mele-view:not([role~=narrow])[inputwidth="1/4"] > mele-wrapper > mele-body-wrapper > mele-body > mele-input:not([width]), body:not([behavior=phone]) .mele-view:not([role~=narrow]) .mele-container[inputwidth="1/4"] > mele-wrapper > mele-body-wrapper > mele-body > mele-input:not([width]) {
  width: calc( 25% - var(--space));
}
body:not([behavior=phone]) .mele-view:not([role~=narrow])[inputwidth="3/4"] > mele-wrapper > mele-body-wrapper > mele-body > mele-input:not([width]), body:not([behavior=phone]) .mele-view:not([role~=narrow]) .mele-container[inputwidth="3/4"] > mele-wrapper > mele-body-wrapper > mele-body > mele-input:not([width]) {
  width: calc( 75% - var(--space));
}
body:not([behavior=phone]) .mele-view:not([role~=narrow]) [width="1/1"], body:not([behavior=phone]) .mele-view:not([role~=narrow]) .mele-container [width="1/1"] {
  width: calc(100% - var(--space));
}
body:not([behavior=phone]) .mele-view:not([role~=narrow]) [width="1/2"], body:not([behavior=phone]) .mele-view:not([role~=narrow]) .mele-container [width="1/2"] {
  width: calc(50% - var(--space));
}
body:not([behavior=phone]) .mele-view:not([role~=narrow]) [width="1/3"], body:not([behavior=phone]) .mele-view:not([role~=narrow]) .mele-container [width="1/3"] {
  width: calc(33.333333% - var(--space));
}
body:not([behavior=phone]) .mele-view:not([role~=narrow]) [width="2/3"], body:not([behavior=phone]) .mele-view:not([role~=narrow]) .mele-container [width="2/3"] {
  width: calc(66.666666% - var(--space));
}
body:not([behavior=phone]) .mele-view:not([role~=narrow]) [width="1/4"], body:not([behavior=phone]) .mele-view:not([role~=narrow]) .mele-container [width="1/4"] {
  width: calc(25% - var(--space));
}
body:not([behavior=phone]) .mele-view:not([role~=narrow]) [width="3/4"], body:not([behavior=phone]) .mele-view:not([role~=narrow]) .mele-container [width="3/4"] {
  width: calc(75% - var(--space));
}
body:not([behavior=phone]) .mele-view:not([role~=narrow]) [width="1/5"], body:not([behavior=phone]) .mele-view:not([role~=narrow]) .mele-container [width="1/5"] {
  width: calc(20% - var(--space));
}
body:not([behavior=phone]) .mele-view:not([role~=narrow]) [width="2/5"], body:not([behavior=phone]) .mele-view:not([role~=narrow]) .mele-container [width="2/5"] {
  width: calc(40% - var(--space));
}
body:not([behavior=phone]) .mele-view:not([role~=narrow]) [width="3/5"], body:not([behavior=phone]) .mele-view:not([role~=narrow]) .mele-container [width="3/5"] {
  width: calc(60% - var(--space));
}
body:not([behavior=phone]) .mele-view:not([role~=narrow]) [width="4/5"], body:not([behavior=phone]) .mele-view:not([role~=narrow]) .mele-container [width="4/5"] {
  width: calc(80% - var(--space));
}

/* GENERIC STYLING */
.mele-datalist > mele-wrapper > mele-body-wrapper > mele-body > .mele-item.color-enabled-0 {
  opacity: 0.5;
}

/* GENERIC STYLING */
.mele-window.mele-modalwindow {
  top: 0px !important;
  bottom: 0px !important;
  left: 0px !important;
  right: 0px !important;
  z-index: 100;
  background: rgba(128, 128, 128, 0.5);
}
.mele-window.mele-modalwindow > mele-button[key=close] {
  position: absolute;
  z-index: 15;
  top: 0px;
  left: 0px;
  background: linear-gradient(to bottom, var(--bg1) 10%, var(--bg2) 70%);
}
.mele-window.mele-modalwindow:not([close]) > mele-button[key=close] {
  display: none;
}
.mele-window.mele-modalwindow[close] > mele-body > [view][role~=single] > mele-wrapper > mele-header-wrapper > mele-header[key=core_header] {
  padding-left: var(--base_height);
}
.mele-window.mele-modalwindow:not([behavior=phone]) > mele-button {
  top: var(--small_height);
  left: var(--small_height);
}
.mele-window.mele-modalwindow:not([behavior=phone]) > mele-body {
  margin: var(--small_height);
  box-shadow: var(--base_shadow);
  border-radius: 4px;
}

/* GENERIC STYLING */
.mele-popup {
  position: absolute;
  z-index: 100000;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  background: rgba(128, 128, 128, 0.7);
}
.mele-popup > mele-wrapper {
  background: var(--bg1);
  flex: initial;
}
.mele-popup > mele-wrapper > mele-header-wrapper > mele-header mele-button[action=modalclose][iconleft="sys.close"] {
  position: absolute;
  right: 0;
}
.mele-popup > mele-wrapper > mele-body-wrapper {
  display: flex;
  min-height: var(--base_height);
  flex: 1 1 auto;
}
.mele-popup > mele-wrapper > mele-body-wrapper > mele-body > mele-text {
  text-align: center;
  flex-basis: 100%;
}
.mele-popup[outclick=none] {
  pointer-events: none;
}
.mele-popup[outclick=none] > mele-wrapper {
  pointer-events: all;
}

.mele-popup.single > mele-wrapper {
  max-width: 600px !important;
  min-width: 600px !important;
}

/* SPECIAL TREATMENT OF DIFFERENT TYPES */
.mele-popup[position=center]:not([behavior=phone]) {
  align-items: center;
  justify-content: center;
}
.mele-popup[position=center]:not([behavior=phone]) > mele-wrapper {
  box-shadow: var(--base_shadow);
  max-height: 70%;
  min-width: 50%;
  max-width: 60%;
  border-radius: 4px;
}
.mele-popup[position=center]:not([behavior=phone]) > mele-wrapper > mele-body-wrapper {
  min-height: 96px;
}

.mele-popup[position=full]:not([behavior=phone]) {
  background: rgba(128, 128, 128, 0.5);
}
.mele-popup[position=full]:not([behavior=phone]) > mele-wrapper {
  margin: var(--small_height);
  box-shadow: var(--base_shadow);
}
.mele-popup[position=full]:not([behavior=phone]) > mele-wrapper > mele-body-wrapper {
  flex: 1 1 auto;
}

.mele-popup[position=full][behavior=phone] > mele-wrapper {
  width: 100% !important;
  min-width: 100% !important;
  max-width: 100% !important;
  height: 100% !important;
  min-height: 100% !important;
  max-height: 100% !important;
  margin-top: 0px !important;
  margin-right: 0px !important;
}
.mele-popup[position=full][behavior=phone] > mele-wrapper > mele-body-wrapper {
  flex: 1 1 auto;
}

.mele-popup[position=left] {
  align-items: flex-start;
}
.mele-popup[position=left] > mele-wrapper {
  box-shadow: var(--base_shadow);
  min-width: 280px;
  max-width: 280px;
  height: 100% !important;
}
.mele-popup[position=left] > mele-wrapper > mele-body-wrapper {
  flex: 1 1 auto;
}

.mele-popup[position=right] {
  align-items: flex-end;
}
.mele-popup[position=right] > mele-wrapper {
  box-shadow: var(--base_shadow);
  min-width: 280px;
  max-width: 280px;
  height: 100% !important;
}
.mele-popup[position=right] > mele-wrapper > mele-body-wrapper {
  flex: 1 1 auto;
}

.mele-popup[position=top] {
  justify-content: flex-start;
}
.mele-popup[position=top] > mele-wrapper {
  box-shadow: var(--base_shadow);
  max-height: 320px;
}
.mele-popup[position=top] > mele-wrapper > mele-body-wrapper {
  min-height: 96px;
}

.mele-popup[position=bottom] {
  justify-content: flex-end;
}
.mele-popup[position=bottom] > mele-wrapper {
  box-shadow: var(--base_shadow);
  max-height: 320px;
}
.mele-popup[position=bottom] > mele-wrapper > mele-body-wrapper {
  min-height: 96px;
}

.mele-popup[position=over]:not([behavior=phone]) {
  align-items: flex-end;
  background: none;
}
.mele-popup[position=over]:not([behavior=phone]) > mele-wrapper {
  flex: initial;
  border: 1px solid var(--bg3);
  background: var(--bg1);
  box-sizing: border-box;
  border-radius: 4px;
}

.mele-popup[position=below]:not([behavior=phone]) {
  align-items: flex-end;
  background: none;
}
.mele-popup[position=below]:not([behavior=phone]) > mele-wrapper {
  flex: initial;
  border: 1px solid var(--bg3);
  box-sizing: border-box;
  border-radius: 4px;
}

.mele-popup[position=leftto]:not([behavior=phone]) {
  align-items: flex-end;
  background: none;
  pointer-events: none;
}
.mele-popup[position=leftto]:not([behavior=phone]) > mele-wrapper {
  pointer-events: all;
  flex: initial;
  border: none;
  box-sizing: border-box;
}
.mele-popup[position=leftto]:not([behavior=phone]) > mele-wrapper > mele-body-wrapper > mele-body {
  align-items: center;
}

.mele-popup[behavior=phone][position=center] > mele-wrapper, .mele-popup[behavior=phone][position=over] > mele-wrapper, .mele-popup[behavior=phone][position=below] > mele-wrapper {
  top: 0px !important;
  bottom: 0px !important;
  left: 0px !important;
  right: 0px !important;
  width: 100% !important;
  min-width: 100% !important;
  max-width: 100% !important;
  height: 100% !important;
  min-height: 100% !important;
  max-height: 100% !important;
}
.mele-popup[behavior=phone][position=center] > mele-wrapper > mele-header-wrapper > mele-header:not(:empty):not(.empty):after, .mele-popup[behavior=phone][position=over] > mele-wrapper > mele-header-wrapper > mele-header:not(:empty):not(.empty):after, .mele-popup[behavior=phone][position=below] > mele-wrapper > mele-header-wrapper > mele-header:not(:empty):not(.empty):after, .mele-popup[behavior=phone][position=full] > mele-wrapper > mele-header-wrapper > mele-header:not(:empty):not(.empty):after {
  padding-right: var(--base_height);
}

/* SPECIAL TREATMENT OF PREDEFINED POPUPS */
.mele-popup.popupdialog > mele-wrapper > mele-header-wrapper > mele-header {
  border-radius: 4px;
}
.mele-popup.popupdialog > mele-wrapper > mele-body-wrapper > mele-body {
  align-content: center;
  justify-content: center;
  align-items: center;
  padding: 20px;
  height: fit-content;
}
.mele-popup.popupdialog > mele-wrapper > mele-body-wrapper > mele-body mele-image[icon="sys.wait"] {
  margin: 10px 0px 0px 0px;
  padding: 0px;
}

.mele-popup.error[position=center]:not([behavior=phone]) > mele-wrapper {
  box-shadow: 0px 0px var(--base_margin) var(--base_margin) var(--red);
}

.mele-popup.error > mele-wrapper > mele-header-wrapper > mele-header[key=core_header] {
  color: var(--fginvalid);
}

.mele-popup.popupdialog.wf > mele-wrapper {
  max-height: 90%;
  max-width: 1024px;
  margin-left: 5%;
  margin-right: 5%;
}
.mele-popup.popupdialog.wf > mele-wrapper > mele-body-wrapper > mele-body {
  align-content: flex-start;
}
.mele-popup.popupdialog.wf > mele-wrapper > mele-body-wrapper > mele-body > * {
  align-self: flex-start;
}

.mele-popup.popupdialog.wf[behavior=phone] > mele-wrapper {
  min-height: 100%;
  max-height: 100%;
  min-width: 100%;
  max-width: 100%;
  margin-left: 0px;
  margin-right: 0px;
}
.mele-popup.popupdialog.wf[behavior=phone] > mele-wrapper > mele-body-wrapper > mele-body {
  align-content: flex-start;
}

/* COLORING */
.mele-popup.popup-preview {
  background: rgba(0, 0, 0, 0.8) !important;
}
.mele-popup.popup-preview > mele-wrapper {
  border: 4px solid #d8d8d8;
}
.mele-popup mele-button[key=prev_image],
.mele-popup mele-button[key=next_image] {
  padding: 0;
  width: auto;
  min-width: 160px;
  height: var(--small_height);
  background: var(--bg2);
  border-radius: 5px;
  margin: 0;
}
.mele-popup mele-button[key=prev_image] mele-labels,
.mele-popup mele-button[key=next_image] mele-labels {
  align-items: center;
}
.mele-popup mele-button[key=prev_image] mele-labels mele-label,
.mele-popup mele-button[key=next_image] mele-labels mele-label {
  font-size: var(--font3);
}
.mele-popup mele-button[key=prev_image] mele-labels mele-label2,
.mele-popup mele-button[key=next_image] mele-labels mele-label2 {
  font-size: var(--font4);
}
.mele-popup mele-button[key=prev_image] mele-icon,
.mele-popup mele-button[key=next_image] mele-icon {
  width: var(--small_height);
  height: var(--small_height);
}
.mele-popup mele-button[key=prev_image] mele-icon [stroke=fg],
.mele-popup mele-button[key=next_image] mele-icon [stroke=fg] {
  stroke: var(--blue);
}
.mele-popup mele-button[key=prev_image] mele-icon > svg, .mele-popup mele-button[key=prev_image] mele-icon > img,
.mele-popup mele-button[key=next_image] mele-icon > svg,
.mele-popup mele-button[key=next_image] mele-icon > img {
  width: var(--small_height_50);
  height: var(--small_height_50);
}
.mele-popup mele-button[key=prev_image] {
  padding-right: 20px;
  position: absolute;
  margin-left: 10px;
  left: 0px;
}
.mele-popup mele-button[key=prev_image]:not([iconleft]) {
  padding-left: 20px;
}
.mele-popup mele-button[key=next_image] {
  padding-left: 20px;
  position: absolute;
  margin-right: 10px;
  right: 0px;
}
.mele-popup mele-button[key=next_image]:not([iconright]) {
  padding-right: 20px;
}

/* GENERIC STYLING */
.mele-search > mele-wrapper > mele-header-wrapper > mele-header[key=search] {
  background: none !important;
  border-bottom: none !important;
}
.mele-search > mele-wrapper > mele-header-wrapper > mele-header[key=search] mele-labels {
  min-width: initial;
}
.mele-search > mele-wrapper > mele-header-wrapper > mele-header[key=search] mele-input {
  z-index: 20;
}
.mele-search > mele-wrapper > mele-header-wrapper > mele-header[key=search] mele-input input {
  padding: 0px var(--base_margin) 0px var(--base_height);
  background: var(--bg1);
}
.mele-search > mele-wrapper > mele-header-wrapper > mele-header[key=search] mele-input input:hover {
  opacity: 1;
}
.mele-search > mele-wrapper > mele-header-wrapper > mele-header[key=search] mele-image[key=searchicon] {
  position: absolute;
  z-index: 30;
  left: 0px;
  top: 0px;
  opacity: 0.8;
  width: var(--small_height);
  height: var(--small_height);
  box-sizing: border-box;
}
.mele-search > mele-wrapper > mele-header-wrapper > mele-header[key=tabs] {
  background-color: var(--bg2) !important;
}
.mele-search > mele-wrapper > mele-header-wrapper > mele-header[key=tabs] mele-item {
  min-width: initial;
  flex: 1;
  padding: 2px var(--base_margin) !important;
}
.mele-search > mele-wrapper > mele-header-wrapper > mele-header[key=tabs] mele-item > mele-icon {
  width: 26px !important;
  height: 26px !important;
}
.mele-search > mele-wrapper > mele-body-wrapper {
  background-color: var(--bg1);
}
.mele-search:not([search]):not([searchfocused]) > mele-wrapper > mele-header-wrapper > mele-header[key=search] mele-input input {
  opacity: 0.7;
}
.mele-search:not([search]):not([searchfocused]) > mele-wrapper > mele-header-wrapper > mele-header[key=tabs] {
  opacity: 0.7;
}
.mele-search:not([search])[count="0"] > mele-wrapper > mele-header-wrapper > mele-header[key=tabs] {
  display: none;
}
.mele-search:not([search])[count="0"] > mele-wrapper > mele-body-wrapper > mele-body, .mele-search:not([search]):not([searchfocused]) > mele-wrapper > mele-body-wrapper > mele-body {
  display: none;
}

/* SPECIAL TREATMENT OF DIFFERENT TYPES */
/* COLORING */
.notif-wrapper {
  display: flex;
  height: var(--small_height);
  min-height: var(--base_height) !important;
  color: var(--bg1);
  border-bottom: 1px solid var(--bg3) !important;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
}
.notif-wrapper .notif-labels {
  display: flex;
  flex: 1;
  order: 20;
  justify-content: center;
}
.notif-wrapper .notif-labels .notif-label, .notif-wrapper .notif-labels .notif-secondary-label {
  font-size: var(--font2);
  line-height: 22px;
  text-align: center;
}
.notif-wrapper .notif-labels .notif-label > span:nth-of-type(2)::before {
  content: " (";
}
.notif-wrapper .notif-labels .notif-label > span:nth-of-type(2)::after {
  content: ") ";
}
.notif-wrapper .notif-value {
  order: 25;
  width: var(--base_height);
  font-size: var(--font5);
  text-align: center;
  padding: 0;
}
.notif-wrapper .notif-icon {
  display: flex;
  width: var(--base_height);
  height: var(--base_height);
  justify-content: center;
  align-items: center;
}
.notif-wrapper .notif-icon:empty {
  display: none;
}
.notif-wrapper .notif-icon svg, .notif-wrapper .notif-icon img {
  width: var(--base_height_50);
  height: var(--base_height_50);
}
.notif-wrapper .notif-icon.left {
  order: 10;
}
.notif-wrapper .notif-icon.right {
  order: 30;
}
.notif-wrapper .notif-icon.remove {
  display: none;
}
.notif-wrapper .notif-icon.collapse {
  order: 40;
}
.notif-wrapper .notif-icon [stroke=fg] {
  stroke: white !important;
}
.notif-wrapper .notif-icon [stroke=bg] {
  stroke: var(--notif) !important;
}
.notif-wrapper .notif-icon [fill=fg] {
  fill: white !important;
}
.notif-wrapper .notif-icon [fill=bg] {
  fill: var(--notif) !important;
}
.notif-wrapper .notif-actions:not(.empty) {
  display: flex;
  justify-content: center;
  height: var(--small_height);
}
.notif-wrapper .notif-actions:not(.empty).right {
  order: 40;
  flex-basis: auto;
}
.notif-wrapper .notif-actions:not(.empty).center {
  padding: 8px 0;
  order: 40;
  flex-basis: 100%;
}
.notif-wrapper .notif-actions:not(.empty).left {
  order: 0;
  flex-basis: auto;
}
.notif-wrapper .notif-actions:not(.empty) .notif-button[type=notify] {
  text-align: center;
  height: auto;
  margin: 5px 10px;
  background: white;
}
.notif-wrapper .notif-actions:not(.empty) .notif-button[type=notify] .notif-labels {
  align-items: center;
}
.notif-wrapper .notif-actions:not(.empty) .notif-button[type=notify] .notif-labels .notif-label {
  text-transform: uppercase;
  color: var(--black) !important;
}
.notif-wrapper:not([selected]) .notif-actions {
  display: none;
}
.notif-wrapper[selected] {
  height: auto;
  flex-wrap: wrap;
}

.mele-notif.high {
  background: var(--red);
  color: var(--white);
}

.mele-notif.medium {
  background: var(--orange);
  color: var(--white);
}

.mele-notif [stroke=fg] {
  stroke: var(--fg2);
}
.mele-notif [fill=fg] {
  fill: var(--fg2);
}
.mele-notif [stroke=bg] {
  stroke: var(--bg1);
}
.mele-notif [fill=bg] {
  fill: var(--bg1);
}

[mod=mmodNotifications][behavior=desktop] mele-notif[actionsposition=right] .notif-actions {
  display: flex !important;
}

[mod=mmodNotifications][behavior=dashboard] mele-notif[actionsposition=right] .notif-actions {
  display: flex !important;
}

.mele-notif:last-of-type {
  border-bottom: none !important;
}

.mele-notifications:not([open]) .mele-item:not(:first-of-type) {
  display: none;
}
.mele-notifications.noopener > mele-wrapper > mele-footer-wrapper {
  display: none;
}
.mele-notifications mele-wrapper mele-body-wrapper {
  background: var(--notif);
}
.mele-notifications mele-wrapper mele-footer-wrapper {
  align-items: center;
  border: none !important;
  height: var(--base_height_50);
  position: relative;
  top: 1px;
}
.mele-notifications mele-wrapper mele-footer-wrapper mele-footer:not(:empty) {
  height: var(--base_height_50) !important;
  min-height: var(--base_height_50) !important;
  border-bottom: 1px solid var(--bg1);
  border-left: 1px solid var(--bg1);
  border-right: 1px solid var(--bg1);
  border-top: 1px solid var(--notif) !important;
  background: var(--notif);
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
}
.mele-notifications mele-wrapper mele-footer-wrapper mele-footer:not(:empty).high {
  background: var(--red);
  border-top: 1px solid var(--red) !important;
}
.mele-notifications mele-wrapper mele-footer-wrapper mele-footer:not(:empty).medium {
  background: var(--orange);
  border-top: 1px solid var(--orange) !important;
}
.mele-notifications mele-wrapper mele-footer-wrapper mele-footer:not(:empty).low {
  background: var(--notif);
  border-top: 1px solid var(--notif) !important;
}
.mele-notifications mele-wrapper mele-footer-wrapper mele-footer:not(:empty) mele-button {
  height: var(--base_height_50);
}
.mele-notifications mele-wrapper mele-footer-wrapper mele-footer:not(:empty) mele-button mele-icon [fill=bg] {
  height: var(--base_height_50);
  fill: var(--white) !important;
  stroke: var(--black) !important;
}

/* GENERIC STYLING */
@keyframes meleplayer-blink-marker {
  0% {
    background-color: var(--bg1);
  }
  50% {
    background-color: gold;
  }
  100% {
    background-color: var(--bg1);
  }
}
.mele-player[markering] mele-button[key=marker] {
  animation: meleplayer-blink-marker 1s ease infinite;
}

.mele-player {
  display: grid;
  grid-template-columns: repeat(9, 1fr);
  grid-template-areas: "a b c d e f g h i";
  box-sizing: border-box;
  position: absolute;
  z-index: 100;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: hidden;
}
.mele-player:not([controls]) {
  --video-bottom: 0px;
}
.mele-player:not([controls])::before {
  content: "";
  position: absolute;
  z-index: 20;
  top: 0;
  left: 0;
  right: 0;
  height: var(--base_height);
  background: #373737;
  color: white;
  pointer-events: none;
}
.mele-player[controls] {
  --video-bottom: var(--base_height);
}
.mele-player[controls] mele-channel[ch="0"] mele-channel-name, .mele-player[controls] mele-channel[ch="0"] mele-actor-time, .mele-player[controls] mele-channel[ch="0"] mele-actor-speed {
  display: none !important;
}
.mele-player devel {
  display: block;
  position: absolute;
  z-index: 1000;
  top: 0;
  right: 0;
  white-space: pre;
  font-family: monospace;
  font-size: 20px;
  background: #ffff0080;
  padding: 0px 20px;
}
.mele-player channels {
  position: absolute;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  z-index: 2000;
  bottom: calc(var(--base_height) * 1.25);
  left: 50%;
  transform: translateX(-50%);
  gap: calc(0.5 * var(--base_height));
}
.mele-player channels mele-button {
  background: rgba(128, 128, 128, 0.5);
  border-radius: 50%;
  margin: var(--button-margin);
  box-shadow: 1px 1px 4px 1px rgba(0, 0, 0, 0.3);
}
.mele-player [key=marker] {
  cursor: pointer;
  position: absolute;
  z-index: 2000;
  top: calc(var(--base_margin));
  right: calc(var(--base_height) * 0.75 + var(--base_margin));
  transform: translateX(50%);
  border-radius: 50%;
  width: calc(var(--base_height) * 1.5);
  height: calc(var(--base_height) * 1.5);
  background-color: var(--bg1);
}
.mele-player [key=marker]:not([disabled]):not([selected]):hover {
  background-color: var(--bg1);
}
.mele-player [key=marker] * {
  stroke-width: 1.5px;
  fill: var(--bg1);
}
.mele-player[timeline] [key=marker] {
  top: calc(var(--base_margin) + var(--base_height));
}
.mele-player controls {
  position: absolute;
  z-index: 2000;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #373737;
  box-shadow: 1px 1px 4px 1px rgba(0, 0, 0, 0.3);
}
.mele-player controls > div {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.mele-player controls div.center {
  position: absolute;
  z-index: 2000;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
}
.mele-player controls [key=screenshot] {
  display: none;
}
.mele-player controls mele-button {
  color: white;
}
.mele-player controls mele-button[iconleft] {
  flex-direction: column;
}
.mele-player controls mele-button[iconleft] mele-label {
  font-size: 10px !important;
}
.mele-player controls mele-button[iconleft] [stroke=white] {
  stroke: #d9d9d9;
}
.mele-player controls [key=mock] mele-labels {
  border: 1px solid white;
  color: white;
  border-radius: 4px;
  align-items: center;
  justify-content: center;
  height: var(--base_height_50);
  min-height: var(--base_height_50);
  padding: 0 var(--base_height_25);
  flex: 0;
}
.mele-player controls [key=mock] mele-labels mele-label {
  font-size: var(--font2) !important;
}
.mele-player controls [key=state] {
  font-size: var(--font2) !important;
  text-transform: uppercase;
  display: inline-flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  padding: 0 var(--base_height_25);
  color: white;
  width: calc(var(--font2) * 10);
}
.mele-player controls [key=state] playdate {
  display: block;
  text-align: center;
  font-size: var(--font3);
}
.mele-player controls [key=state] playtime {
  display: block;
  text-align: center;
  font-size: var(--font2);
}
.mele-player controls [key=state][label="video.state.stopped"] {
  color: #AAA;
}
.mele-player controls [key=state][label="video.state.paused"] {
  color: #AAA;
}
.mele-player controls [key=state][label="video.state.live"] {
  color: white;
}
.mele-player controls [key=state][label="video.state.connecting"] {
  color: #f66;
}
.mele-player controls [key=state][label="video.state.error"] {
  color: #f66;
}
.mele-player controls [key=recording] mele-labels {
  border: 1px solid gray;
  color: gray;
  border-radius: 4px;
  align-items: center;
  justify-content: center;
  width: calc(var(--font2) * 8);
  height: var(--base_height_50);
  min-height: var(--base_height_50);
  padding: 0 var(--base_height_25);
  flex: 0;
}
.mele-player controls [key=recording] mele-labels mele-label {
  width: calc(var(--font2) * 8);
  font-size: var(--font2) !important;
}
@keyframes blink_recording {
  0% {
    border-color: white;
    color: white;
  }
  40% {
    border-color: red;
    color: red;
  }
  60% {
    border-color: red;
    color: red;
  }
  100% {
    border-color: white;
    color: white;
  }
}
.mele-player controls [key=recording][label="video.recording_on"] mele-labels {
  animation-name: blink_recording;
  animation-duration: 1.5s;
  animation-iteration-count: infinite;
  animation-timing-function: ease-in-out;
  animation-direction: alternate;
}
.mele-player controls [key=live] circle[stroke=none] {
  fill: var(--green);
}
.mele-player controls [key=rwdmark] circle[stroke=none], .mele-player controls [key=fwdmark] circle[stroke=none] {
  fill: var(--red);
}
.mele-player controls [key=stop] circle[stroke=none] {
  fill: var(--red);
}
.mele-player[state=paused] controls [key=pause] {
  display: none;
}
.mele-player:not([state=paused]) controls [key=resume] {
  display: none;
}
.mele-player[recording=none] [key=recording] {
  display: none;
}
.mele-player[recording=disabled] [key=recording] {
  cursor: default;
}
.mele-player[recording=disabled] [key=recording]:hover {
  background: none;
}
.mele-player[mock] [key=mock] mele-labels {
  animation-name: blink_mock;
  animation-duration: 1.5s;
  animation-iteration-count: infinite;
  animation-timing-function: ease-in-out;
  animation-direction: alternate;
}
@keyframes blink_mock {
  0% {
    border-color: white;
    color: white;
  }
  40% {
    border-color: gold;
    color: gold;
  }
  60% {
    border-color: gold;
    color: gold;
  }
  100% {
    border-color: white;
    color: white;
  }
}
.mele-player seek {
  display: grid;
  place-content: center;
  position: absolute;
  z-index: 2000;
  left: 50%;
  bottom: 40%;
  transform: translateX(-50%);
}
.mele-player seek[hidden] {
  display: none;
}
.mele-player seek mele-list {
  background: rgba(0, 0, 0, 0.5);
}
.mele-player seek mele-list mele-item > mele-labels > mele-label {
  color: white !important;
  padding: 5px;
}
.mele-player[selected]:not([selected="0"]) mele-channel {
  display: none;
}
.mele-player[selected]:not([selected="0"]) mele-channel[ch="0"], .mele-player[selected]:not([selected="0"]) mele-channel[selected] {
  display: contents;
}
.mele-player[selected]:not([selected="0"]) mele-channel[selected] mele-channel-name {
  display: none;
}
.mele-player[selected]:not([selected="0"]) mele-channel[ch="0"] mele-channel-name.indicator {
  display: none;
}
.mele-player[selected]:not([selected="0"]) .indicator {
  z-index: 30;
  height: var(--base_height);
  max-height: calc(1.2 * var(--base_height));
  align-items: center;
  justify-content: center;
  color: white;
  display: grid;
  grid-template-areas: "title" "subtitle";
}
.mele-player[selected]:not([selected="0"]) .indicator .title {
  grid-area: title;
  font-size: var(--font3);
  font-family: var(--font_normal);
  letter-spacing: 1px;
  text-align: left;
  color: #b3b3b3;
  padding: 0;
  text-transform: uppercase;
  text-align: center;
}
.mele-player[selected]:not([selected="0"]) .indicator .subtitle {
  grid-area: subtitle;
  font-size: var(--font2);
  font-family: var(--font_bold);
  text-align: center;
  color: #d9d9d9;
}
.mele-player[selected]:not([selected="0"]) .ctrl {
  box-shadow: 0px 0px 10px 1px rgba(0, 0, 0, 0.3);
}
.mele-player:not([selected]), .mele-player[selected="0"] {
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  padding-top: 5vmin;
  padding-bottom: calc(2 * var(--base_height));
}
.mele-player:not([selected]) mele-channel:not([ch="0"]), .mele-player[selected="0"] mele-channel:not([ch="0"]) {
  position: relative;
  z-index: 300;
  max-width: 40vw;
  max-height: 28vw;
  margin: 3vh;
  background: black;
  border: 1px solid white;
  box-shadow: 0px 0px 10px 1px black;
}
.mele-player:not([selected]) mele-channel:not([ch="0"]) .mele-actor:not(.mele-actorh264), .mele-player[selected="0"] mele-channel:not([ch="0"]) .mele-actor:not(.mele-actorh264) {
  display: none;
}

/* CREATE MARKER MODAL */
.mele-modal[key=mele_player_marker] > mele-wrapper {
  max-height: 90% !important;
  max-width: 90% !important;
}
.mele-modal[key=mele_player_marker] div[key=images] {
  display: flex;
  flex-direction: row-reverse;
  overflow-x: auto;
  padding: 0 40vh;
}
.mele-modal[key=mele_player_marker] div[key=images] img {
  width: auto;
  height: 30vh;
  border: 2px solid var(--gray);
  box-sizing: border-box;
  margin-right: 1vh;
}
.mele-modal[key=mele_player_marker] div[key=images] img[selected] {
  border: 5px solid var(--blue);
}
.mele-modal[key=mele_player_marker] div[key=images] img:not([loaded]) {
  min-width: 40vh;
}

/* LIST OF MARKERS MODAL */
[key=mele_player_markers] mele-item::before, .mele_player_markers mele-item::before {
  display: none;
}
[key=mele_player_markers] mele-item .right [stroke=fg], .mele_player_markers mele-item .right [stroke=fg] {
  stroke: var(--red);
}
[key=mele_player_markers] mele-item.color-blue .left [stroke=fg], .mele_player_markers mele-item.color-blue .left [stroke=fg] {
  stroke: var(--blue);
}
[key=mele_player_markers] mele-item.color-blue .left [fill=fg], .mele_player_markers mele-item.color-blue .left [fill=fg] {
  fill: var(--blue);
}
[key=mele_player_markers] mele-item.color-green .left [stroke=fg], .mele_player_markers mele-item.color-green .left [stroke=fg] {
  stroke: var(--green);
}
[key=mele_player_markers] mele-item.color-green .left [fill=fg], .mele_player_markers mele-item.color-green .left [fill=fg] {
  fill: var(--green);
}
[key=mele_player_markers] mele-item.color-orange .left [stroke=fg], .mele_player_markers mele-item.color-orange .left [stroke=fg] {
  stroke: var(--orange);
}
[key=mele_player_markers] mele-item.color-orange .left [fill=fg], .mele_player_markers mele-item.color-orange .left [fill=fg] {
  fill: var(--orange);
}
[key=mele_player_markers] mele-item.color-red .left [stroke=fg], .mele_player_markers mele-item.color-red .left [stroke=fg] {
  stroke: var(--red);
}
[key=mele_player_markers] mele-item.color-red .left [fill=fg], .mele_player_markers mele-item.color-red .left [fill=fg] {
  fill: var(--red);
}
[key=mele_player_markers] mele-item mele-icon.left, .mele_player_markers mele-item mele-icon.left {
  width: calc(var(--base_height) * 0.9 * 1920 / 1080);
  height: calc(var(--base_height) * 0.9);
}
[key=mele_player_markers] mele-item mele-icon.left img, .mele_player_markers mele-item mele-icon.left img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.mele-player[live] [key=marker] {
  display: none;
}
.mele-player[live] mele-text[key=state] {
  margin-right: var(--base_margin);
}

.mele-player:not([live]) [key=live] * {
  stroke-width: 1px;
  stroke: white;
  fill: none !important;
}
.mele-player:not([live]) mele-text[key=state] {
  animation: blink_history_time 1s ease infinite;
  width: auto;
  align-items: center;
}
@keyframes blink_history_time {
  0% {
    background-color: transparent;
  }
  50% {
    background-color: #7f6c00;
  }
  100% {
    background-color: transparent;
  }
}

.mele-player[live] controls [key=live] {
  display: none;
}
.mele-player[live] controls [key=live] circle[stroke=none] {
  fill: violet;
  animation-name: blink_live;
  animation-duration: 1.5s;
  animation-iteration-count: infinite;
  animation-timing-function: ease-in-out;
  animation-direction: alternate;
}
@keyframes blink_live {
  0% {
    fill: #4faa22;
  }
  50% {
    fill: rgba(79, 170, 34, 0.2);
  }
  100% {
    fill: #4faa22;
  }
}

/* VIDEO CALENDAR AND EXPORT MODAL */
.mele-modal[key=video_calendar]:not([behavior=phone]) > mele-wrapper,
.mele-modal[key=video_export_end]:not([behavior=phone]) > mele-wrapper,
.mele-modal[key=video_export_destination]:not([behavior=phone]) > mele-wrapper {
  min-width: auto;
}
.mele-modal[key=video_calendar] > mele-wrapper,
.mele-modal[key=video_export_end] > mele-wrapper,
.mele-modal[key=video_export_destination] > mele-wrapper {
  max-height: 95% !important;
}
.mele-modal[key=video_calendar] > mele-wrapper > mele-body-wrapper > mele-body > mele-view,
.mele-modal[key=video_export_end] > mele-wrapper > mele-body-wrapper > mele-body > mele-view,
.mele-modal[key=video_export_destination] > mele-wrapper > mele-body-wrapper > mele-body > mele-view {
  max-height: 100%;
}
.mele-modal[key=video_calendar] > mele-wrapper > mele-body-wrapper > mele-body > mele-view > mele-wrapper > mele-body-wrapper,
.mele-modal[key=video_export_end] > mele-wrapper > mele-body-wrapper > mele-body > mele-view > mele-wrapper > mele-body-wrapper,
.mele-modal[key=video_export_destination] > mele-wrapper > mele-body-wrapper > mele-body > mele-view > mele-wrapper > mele-body-wrapper {
  overflow: hidden;
}
.mele-modal[key=video_calendar] > mele-wrapper > mele-body-wrapper > mele-body > mele-view .main,
.mele-modal[key=video_export_end] > mele-wrapper > mele-body-wrapper > mele-body > mele-view .main,
.mele-modal[key=video_export_destination] > mele-wrapper > mele-body-wrapper > mele-body > mele-view .main {
  display: flex;
  flex-direction: row;
  max-height: 100%;
  width: fit-content;
  justify-content: space-around;
}
.mele-modal[key=video_calendar] > mele-wrapper > mele-body-wrapper > mele-body > mele-view .main .center,
.mele-modal[key=video_export_end] > mele-wrapper > mele-body-wrapper > mele-body > mele-view .main .center,
.mele-modal[key=video_export_destination] > mele-wrapper > mele-body-wrapper > mele-body > mele-view .main .center {
  display: flex;
  flex-direction: column;
  max-height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  align-items: center;
  width: calc((var(--font2)*3 + 6px) * 11);
}
.mele-modal[key=video_calendar] > mele-wrapper > mele-body-wrapper > mele-body > mele-view .main .right mele-calendar-snapshots,
.mele-modal[key=video_export_end] > mele-wrapper > mele-body-wrapper > mele-body > mele-view .main .right mele-calendar-snapshots,
.mele-modal[key=video_export_destination] > mele-wrapper > mele-body-wrapper > mele-body > mele-view .main .right mele-calendar-snapshots {
  display: flex;
  flex-direction: column;
  max-height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  width: 12vw;
  align-items: center;
}
.mele-modal[key=video_calendar] > mele-wrapper > mele-body-wrapper > mele-body > mele-view .main .right mele-calendar-snapshots snapshot,
.mele-modal[key=video_export_end] > mele-wrapper > mele-body-wrapper > mele-body > mele-view .main .right mele-calendar-snapshots snapshot,
.mele-modal[key=video_export_destination] > mele-wrapper > mele-body-wrapper > mele-body > mele-view .main .right mele-calendar-snapshots snapshot {
  user-select: none;
  cursor: pointer;
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.mele-modal[key=video_calendar] > mele-wrapper > mele-body-wrapper > mele-body > mele-view .main .right mele-calendar-snapshots snapshot .left,
.mele-modal[key=video_export_end] > mele-wrapper > mele-body-wrapper > mele-body > mele-view .main .right mele-calendar-snapshots snapshot .left,
.mele-modal[key=video_export_destination] > mele-wrapper > mele-body-wrapper > mele-body > mele-view .main .right mele-calendar-snapshots snapshot .left {
  position: relative;
  padding: 4px;
  margin: 2px;
  border: 1px solid transparent;
}
.mele-modal[key=video_calendar] > mele-wrapper > mele-body-wrapper > mele-body > mele-view .main .right mele-calendar-snapshots snapshot .left:hover,
.mele-modal[key=video_export_end] > mele-wrapper > mele-body-wrapper > mele-body > mele-view .main .right mele-calendar-snapshots snapshot .left:hover,
.mele-modal[key=video_export_destination] > mele-wrapper > mele-body-wrapper > mele-body > mele-view .main .right mele-calendar-snapshots snapshot .left:hover {
  transition: border-color 0.3s;
  border-color: var(--fg2);
}
.mele-modal[key=video_calendar] > mele-wrapper > mele-body-wrapper > mele-body > mele-view .main .right mele-calendar-snapshots snapshot .left div,
.mele-modal[key=video_export_end] > mele-wrapper > mele-body-wrapper > mele-body > mele-view .main .right mele-calendar-snapshots snapshot .left div,
.mele-modal[key=video_export_destination] > mele-wrapper > mele-body-wrapper > mele-body > mele-view .main .right mele-calendar-snapshots snapshot .left div {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: calc(var(--font2) * 1.5);
  line-height: calc(var(--font2) * 1.5);
  background: var(--bg1);
  color: var(--fg2);
  font-size: 0.8vw;
  text-align: center;
  order: 1;
}
.mele-modal[key=video_calendar] > mele-wrapper > mele-body-wrapper > mele-body > mele-view .main .right mele-calendar-snapshots snapshot .left img,
.mele-modal[key=video_export_end] > mele-wrapper > mele-body-wrapper > mele-body > mele-view .main .right mele-calendar-snapshots snapshot .left img,
.mele-modal[key=video_export_destination] > mele-wrapper > mele-body-wrapper > mele-body > mele-view .main .right mele-calendar-snapshots snapshot .left img {
  display: block;
  width: 8vw;
  height: auto;
}
.mele-modal[key=video_calendar] > mele-wrapper > mele-body-wrapper > mele-body > mele-view .main .right mele-calendar-snapshots snapshot svg,
.mele-modal[key=video_export_end] > mele-wrapper > mele-body-wrapper > mele-body > mele-view .main .right mele-calendar-snapshots snapshot svg,
.mele-modal[key=video_export_destination] > mele-wrapper > mele-body-wrapper > mele-body > mele-view .main .right mele-calendar-snapshots snapshot svg {
  order: 2;
  width: 2vw;
  height: 4vw;
  margin-top: calc(var(--font2) * 1.5);
}
.mele-modal[key=video_calendar] > mele-wrapper > mele-body-wrapper > mele-body > mele-view .main .right mele-calendar-snapshots snapshot svg:hover *[stroke],
.mele-modal[key=video_export_end] > mele-wrapper > mele-body-wrapper > mele-body > mele-view .main .right mele-calendar-snapshots snapshot svg:hover *[stroke],
.mele-modal[key=video_export_destination] > mele-wrapper > mele-body-wrapper > mele-body > mele-view .main .right mele-calendar-snapshots snapshot svg:hover *[stroke] {
  stroke: var(--blue);
}

.mele-modal[key=video_calendar] mele-input[key=type] mele-list > mele-wrapper > mele-body-wrapper > mele-body {
  flex: 1 1 0 !important;
}
.mele-modal[key=video_calendar] mele-input[key=type] mele-list > mele-wrapper > mele-body-wrapper > mele-body mele-item {
  min-width: auto !important;
}
.mele-modal[key=video_calendar] mele-input[key=type] mele-list > mele-wrapper > mele-body-wrapper > mele-body mele-item mele-label {
  font-size: var(--font2);
}

.mele-modal[key=video_export_end] [key=video_export_start_time] {
  margin-top: var(--font2);
}
.mele-modal[key=video_export_end] [key=export_start_datetime] {
  font-size: var(--font2);
  display: block;
  margin: var(--font2);
  margin-top: 0;
  width: 100%;
  text-align: center;
}
.mele-modal[key=video_export_end] [key=export_start_datetime] > * {
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: calc(var(--font2)*3);
  height: calc(var(--font2)*3);
  border: 1px solid rgba(128, 128, 128, 0.2);
  box-sizing: border-box;
  cursor: not-allowed !important;
}
.mele-modal[key=video_export_end] [key=export_start_datetime] year {
  width: calc(var(--font2)*5);
}
.mele-modal[key=video_export_end] [key=video_calendar] datetime {
  margin-top: 0;
}

.mele-modal[key=video_calendar]:not([subview=export]) > mele-wrapper > mele-body-wrapper > mele-body > mele-view .main {
  height: calc((var(--font2)*3 + 6px) * 9);
}

mele-actor-cameragrid {
  overflow: hidden;
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  bottom: var(--video-bottom);
  right: 0;
  user-select: none;
}
mele-actor-cameragrid canvas {
  z-index: 15;
  width: 100%;
  height: 100%;
  object-fit: contain;
}

/* GENERIC STYLING */
mele-actor-crosshair {
  position: absolute;
  z-index: 100;
  width: 100%;
  height: 100%;
  top: 0;
  right: 0;
  left: 0;
  bottom: var(--video-bottom);
  padding: 0 !important;
  background: none !important;
}

mele-actor-crosshair svg {
  display: block;
  max-width: 100%;
  max-height: 100%;
  width: 100%;
  height: 100%;
  object-fit: contain;
  box-sizing: border-box;
}

mele-actor-crosshair svg path {
  stroke: cyan;
  stroke-width: 1px;
  fill: none;
}

/* GENERIC STYLING */
mele-channel[ch="0"] > mele-actor-gps {
  grid-area: c;
}

mele-actor-h264 {
  position: absolute;
  z-index: 10;
  bottom: var(--video-bottom);
  left: 0;
  right: 0;
  display: block;
}
mele-actor-h264 video {
  display: block;
  width: 100%;
  height: auto;
  object-fit: contain;
  background-color: #434343;
}

@keyframes doppler_blink {
  0%, 100% {
    filter: saturate(1);
  }
  50% {
    filter: saturate(3);
  }
}
mele-actor-dopplermeta {
  overflow: hidden;
  --config-fill: var(--red);
  display: contents;
  user-select: none;
}
mele-actor-dopplermeta[state=on] {
  --config-fill: var(--green);
}
mele-actor-dopplermeta[state=on] .blinkbg {
  animation: doppler_blink 1s infinite;
}
mele-actor-dopplermeta[state=off], mele-actor-dopplermeta[state=poweroff] {
  --config-fill: var(--gray);
}
mele-actor-dopplermeta canvas {
  z-index: 15;
  width: 100%;
  height: 100%;
  object-fit: contain;
}
mele-actor-dopplermeta [key=showcalibrate]::before {
  display: none !important;
}
mele-actor-dopplermeta dopplerconfig {
  z-index: 25;
  cursor: pointer;
  position: absolute;
  top: calc(var(--base_height) + var(--base_margin));
  right: calc(var(--base_height) * 0.75 + var(--base_margin));
  transform: translateX(50%);
  border-radius: 50%;
  width: calc(var(--base_height) * 1.5);
  height: calc(var(--base_height) * 1.5);
}
mele-actor-dopplermeta dopplerconfig:empty {
  display: none;
}
mele-actor-dopplermeta [key=startstop] {
  z-index: 25;
  cursor: pointer;
  position: absolute;
  top: calc(var(--base_height) * 2.5 + var(--base_margin) * 3);
  right: calc(var(--base_height) * 0.75 + var(--base_margin));
  transform: translateX(50%);
  border-radius: var(--base_margin);
  background: var(--bg1) !important;
}
mele-actor-dopplermeta [key=startstop]:hover {
  background: var(--bg1) !important;
}
mele-actor-dopplermeta [key=startstop] mele-icon {
  width: 100%;
  height: 100%;
}
mele-actor-dopplermeta [key=startstop] mele-icon svg {
  width: 100% !important;
  height: 100% !important;
}
mele-actor-dopplermeta [key=startstop] mele-icon svg [fill=red] {
  fill: var(--red);
}
mele-actor-dopplermeta [key=startstop] mele-icon svg [stroke=red] {
  stroke: var(--red);
}
mele-actor-dopplermeta [key=startstop] mele-icon svg [fill=orange] {
  fill: var(--orange);
}
mele-actor-dopplermeta [key=startstop] mele-icon svg [stroke=orange] {
  stroke: var(--orange);
}
mele-actor-dopplermeta [key=startstop] mele-icon svg [fill=green] {
  fill: var(--green);
}
mele-actor-dopplermeta [key=startstop] mele-icon svg [stroke=green] {
  stroke: var(--green);
}
mele-actor-dopplermeta [key=startstop] mele-icon svg [fill=gray] {
  fill: var(--gray);
}
mele-actor-dopplermeta [key=startstop] mele-icon svg [stroke=gray] {
  stroke: var(--gray);
}
mele-actor-dopplermeta div[key=sog_speed] {
  grid-area: d;
}
mele-actor-dopplermeta div[key=mode] {
  grid-area: e;
}
mele-actor-dopplermeta div[key=direction_limit] {
  grid-area: f;
}
mele-actor-dopplermeta div[key=lane_limit] {
  grid-area: g;
}
mele-actor-dopplermeta div[key=speed_limit] {
  grid-area: h;
}
mele-actor-dopplermeta div[key=hit_limit] {
  grid-area: i;
}
mele-actor-dopplermeta div[key=sn] {
  grid-area: b;
}
mele-actor-dopplermeta .identity {
  padding: 0 10px;
  position: absolute;
  z-index: 500;
  bottom: var(--video-bottom);
  left: 50%;
  transform: translateX(-50%);
  font-size: 12px;
  background: #3737375e;
  color: white;
}
mele-actor-dopplermeta alerts {
  z-index: 50;
  position: absolute;
  bottom: calc(var(--video-bottom) + var(--base_height) * 0.25 + var(--base_margin));
  left: 50%;
  transform: translateX(-50%);
  background: var(--red) !important;
  color: white !important;
  opacity: 0.9;
  padding: var(--base_margin) calc(var(--base_margin) * 2);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 0px 10px 1px rgba(0, 0, 0, 0.3);
}
mele-actor-dopplermeta alerts:empty {
  display: none;
}
mele-actor-dopplermeta alerts.info {
  background: #444 !important;
  opacity: 0.6;
}
mele-actor-dopplermeta alerts div {
  font-size: var(--font2);
  text-transform: uppercase;
  white-space: nowrap;
}
mele-actor-dopplermeta:not([showcalibration]) mele-view[key=calibration_info] {
  display: none;
}
mele-actor-dopplermeta mele-view[key=calibration_info] {
  z-index: 700;
  position: absolute;
  top: calc(var(--base_height) * 1.2);
  left: 0;
  right: 0;
  background: var(--bg1) !important;
  box-shadow: 0px 0px 10px 1px var(--fg1);
  opacity: 0.9;
  left: 50%;
  transform: translateX(-50%);
  width: max-content;
  max-width: 95%;
  max-height: 75%;
  box-sizing: border-box;
  padding: 0.5em;
  border-radius: 1em;
  overflow: hidden;
}
mele-actor-dopplermeta mele-view[key=calibration_info].available > mele-wrapper > mele-body-wrapper > mele-body > mele-text {
  display: none;
}
mele-actor-dopplermeta mele-view[key=calibration_info]:not(.available) > mele-wrapper > mele-body-wrapper > mele-body > div {
  display: none;
}
mele-actor-dopplermeta mele-view[key=calibration_info]:not(.available) > mele-wrapper > mele-body-wrapper > mele-body > mele-text {
  font-family: var(--font_bold);
  font-size: var(--font0);
  color: var(--red);
  margin: var(--font0);
}
mele-actor-dopplermeta mele-view[key=calibration_info] mele-input {
  --input-padding: 2px 4px;
  --font1: 1vw;
  --font3: 1vw;
  --small-height: 32px;
}
mele-actor-dopplermeta mele-view[key=calibration_info] mele-value-content {
  width: auto;
}

mele-modal[key=dopplermeta_status] > mele-wrapper {
  min-width: fit-content !important;
  max-height: 90%;
}
mele-modal[key=dopplermeta_status] > mele-wrapper > mele-body-wrapper > mele-body {
  margin: 5px 25px;
}
mele-modal[key=dopplermeta_status] > mele-wrapper > mele-footer-wrapper > mele-footer {
  padding: 0 25px;
}
mele-modal[key=dopplermeta_status] mele-view > mele-wrapper > mele-body-wrapper > mele-body {
  flex-direction: column;
}
mele-modal[key=dopplermeta_status] mele-input {
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  justify-content: flex-start;
}
mele-modal[key=dopplermeta_status] mele-input[key=state] {
  --input-padding: 10px 0 10px 0;
}
mele-modal[key=dopplermeta_status] mele-input[key=state] span {
  text-align: center;
}
mele-modal[key=dopplermeta_status] mele-input[key=state][value=dry] {
  color: #22aaaa;
}
mele-modal[key=dopplermeta_status] mele-input[key=state][value=simulator] {
  color: #22aaaa;
}
mele-modal[key=dopplermeta_status] mele-input[key=state][value=on] {
  color: var(--green);
}
mele-modal[key=dopplermeta_status] mele-input[key=state][value=error] {
  color: var(--red);
}
mele-modal[key=dopplermeta_status] mele-input[key=radar_camera] mele-label {
  color: var(--fg1);
}
mele-modal[key=dopplermeta_status] mele-input[key=radar_camera] span {
  white-space: pre;
  text-align: center;
  font-size: var(--font3);
  color: var(--fg2);
}
mele-modal[key=dopplermeta_status] .limits, mele-modal[key=dopplermeta_status] .shortcuts {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
}
mele-modal[key=dopplermeta_status][readonly] .shortcuts {
  opacity: 0.2;
}
mele-modal[key=dopplermeta_status] .shortcuts svg {
  user-select: none;
  width: var(--base_height);
  height: var(--base_height);
  padding: 0 var(--large_margin);
}
mele-modal[key=dopplermeta_status] .identity {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
}
mele-modal[key=dopplermeta_status] .identity mele-input mele-label {
  white-space: nowrap;
  color: var(--fg1);
}
mele-modal[key=dopplermeta_status] .identity mele-input span {
  line-height: calc(var(--font1) * 1.5);
  color: var(--fg2);
}
mele-modal[key=dopplermeta_status] .identity [key=sn], mele-modal[key=dopplermeta_status] .identity [key=checksum] {
  width: 20%;
}
mele-modal[key=dopplermeta_status] .identity [key=sn] span, mele-modal[key=dopplermeta_status] .identity [key=checksum] span {
  text-align: center;
  font-size: var(--font1);
}
mele-modal[key=dopplermeta_status] .identity [key=version] {
  width: 50%;
}
mele-modal[key=dopplermeta_status] .identity [key=version] span {
  text-align: center;
  font-size: var(--font3);
}
mele-modal[key=dopplermeta_status] .identity, mele-modal[key=dopplermeta_status] [key=radar_camera] {
  display: none;
}
mele-modal[key=dopplermeta_status] mele-input[type=grid] mele-body {
  justify-content: center !important;
}
mele-modal[key=dopplermeta_status] mele-input[type=grid] mele-item {
  min-width: 10em !important;
  max-width: 10em !important;
}
mele-modal[key=dopplermeta_status] mele-input[type=grid] mele-item mele-labels {
  align-items: center;
}
mele-modal[key=dopplermeta_status] mele-input[type=rotarystring] {
  --input-width: auto;
}
mele-modal[key=dopplermeta_status] mele-input[type=rotarystring] mele-value {
  min-height: var(--small-height);
  line-height: var(--small-height);
}
mele-modal[key=dopplermeta_status] mele-input[type=rotarystring] input {
  width: calc(var(--font1) * 3.4 * 0.6 + var(--small_height_2) + 10px) !important;
  text-align: right;
  padding-right: calc(var(--small_height_2) + 2px);
}
mele-modal[key=dopplermeta_status] mele-input[type=rotarystring][key=hit_tolerance] input {
  width: calc(var(--font1) * 2.4 * 0.6 + var(--small_height_2) + 10px) !important;
}
mele-modal[key=dopplermeta_status] mele-input[before], mele-modal[key=dopplermeta_status] mele-input[after] {
  --before-after-w: auto;
}
mele-modal[key=dopplermeta_status] mele-input[before] mele-value-wrapper, mele-modal[key=dopplermeta_status] mele-input[after] mele-value-wrapper {
  border: none !important;
}
mele-modal[key=dopplermeta_status] mele-input[before] mele-value-wrapper mele-value-before, mele-modal[key=dopplermeta_status] mele-input[after] mele-value-wrapper mele-value-before {
  min-width: auto;
}
mele-modal[key=dopplermeta_status] mele-input[before]:not([readonly]) mele-value-wrapper mele-value-content, mele-modal[key=dopplermeta_status] mele-input[after]:not([readonly]) mele-value-wrapper mele-value-content {
  border: var(--input-border);
  border-radius: 4px;
}

mele-modal[key=dopplermeta_status]:not([simulator]) mele-input[key=mode] mele-item[key=simulator] {
  display: none !important;
}

mele-actor-dopplersog {
  grid-area: d;
}

mele-actor-dopplerbeam {
  display: block;
  position: absolute;
  z-index: 20;
  left: 0;
  bottom: var(--video-bottom);
  right: 0;
  pointer-events: none;
}
mele-actor-dopplerbeam canvas {
  width: 100%;
  height: auto;
  object-fit: contain;
}

mele-actor-dopplerfollow {
  pointer-events: none;
  display: block;
  position: absolute;
  z-index: 20;
  left: 0;
  bottom: var(--video-bottom);
  right: 0;
}
mele-actor-dopplerfollow canvas {
  width: 100%;
  height: auto;
  object-fit: contain;
}

mele-actor-dopplerevents {
  position: absolute;
  z-index: 500;
  left: 0;
  top: calc(var(--base_height) * 1);
  bottom: calc(var(--video-bottom) + var(--base_height) * 0.25 + var(--base_margin));
  padding-top: 2px;
  overflow-x: visible;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-items: flex-start;
}
mele-actor-dopplerevents dopplerevent {
  cursor: pointer;
  display: block;
  position: relative;
  height: var(--base_height);
  min-height: var(--base_height);
  width: calc(var(--base_height)*2.5);
  overflow: hidden;
  margin: 2px 0;
}
mele-actor-dopplerevents dopplerevent svg {
  position: absolute;
  z-index: 20;
  right: 0;
  top: 0;
  width: auto;
  height: 100%;
}
mele-actor-dopplerevents dopplerevent canvas {
  position: absolute;
  z-index: 10;
  left: 0;
  top: 0;
  height: 100%;
  width: auto;
  background-color: #88888820;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  background-repeat: no-repeat;
  background-position: calc(var(--base_height)*0.95) center;
  background-size: calc(var(--base_height)*.7);
}
mele-actor-dopplerevents dopplerevent div {
  background: #ffffffa0;
  color: black;
  position: absolute;
  z-index: 15;
  bottom: 0;
  left: 0;
  width: calc(100% - var(--base_height) / 2);
  font-size: calc(var(--base_height) / 4);
  padding-left: 0.5em;
  box-sizing: border-box;
}

mele-modal[key=dopplerevent_detail] .mele-view[view] > mele-wrapper > mele-body-wrapper > mele-body {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
}
mele-modal[key=dopplerevent_detail] radar {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 0 !important;
  overflow: hidden;
  position: relative;
}
mele-modal[key=dopplerevent_detail] alprs {
  display: none;
}
mele-modal[key=dopplerevent_detail] > mele-wrapper {
  height: 100% !important;
  max-height: 100% !important;
  max-width: 80% !important;
}
mele-modal[key=dopplerevent_detail] img[key=overview] {
  height: 45vh;
  width: auto;
  max-width: 100%;
  object-fit: contain;
  background-color: #88888820;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  background-repeat: no-repeat;
  background-position: center center;
  background-size: calc(var(--base_height)*1.5);
}
mele-modal[key=dopplerevent_detail] [key=icon] {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 0;
  z-index: 10;
}
mele-modal[key=dopplerevent_detail] [key=icon] svg {
  width: calc(var(--font1) * 2 * 2);
  height: calc(var(--font1) * 2 * 2);
}
mele-modal[key=dopplerevent_detail] [key=test] {
  user-select: none;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  height: 50vh;
  z-index: 5;
  display: flex;
  justify-content: center;
  align-items: center;
}
mele-modal[key=dopplerevent_detail] [key=test] > div {
  font-size: 14vh;
  transform: rotate(-25deg);
  color: gold;
  opacity: 0.3;
  white-space: pre;
}
mele-modal[key=dopplerevent_detail] [key=alpr] {
  display: flex;
  flex-direction: row;
  overflow: hidden;
  user-select: none;
  padding: 0;
  height: 10vh;
  width: 100%;
  align-items: center;
  justify-content: space-around;
  box-sizing: border-box;
}
mele-modal[key=dopplerevent_detail] [key=alpr] > * {
  max-height: 90%;
  max-width: 50%;
  object-fit: contain;
  overflow: hidden;
}
mele-modal[key=dopplerevent_detail] [key=alpr] [key=lpn] {
  background: #666;
  color: white;
  font-size: calc(min(4.5vh, 2.5vw));
  text-transform: uppercase;
  display: flex;
  align-items: center;
}
mele-modal[key=dopplerevent_detail] [key=alpr] [key=lpn]:not(:empty) {
  background: rgba(0, 0, 0, 0.5);
  border-radius: 8px;
  padding: 0.4em 1em;
  margin: 0;
}
mele-modal[key=dopplerevent_detail] [key=alpr] [key=lp] {
  height: 90%;
}
mele-modal[key=dopplerevent_detail] [key=alpr] [key=lp]:not([src]), mele-modal[key=dopplerevent_detail] [key=alpr] [key=lp][src=""] {
  display: none;
}
mele-modal[key=dopplerevent_detail] [key=values] {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
  overflow: hidden;
  flex-wrap: wrap;
  width: 32em;
  margin-bottom: 0.5em;
}
mele-modal[key=dopplerevent_detail] mele-input {
  width: 12em;
  padding: 0.2em 1.5em !important;
}
mele-modal[key=dopplerevent_detail] mele-input mele-value-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}
mele-modal[key=dopplerevent_detail] mele-input mele-value-wrapper mele-value-content {
  width: fit-content;
}
mele-modal[key=dopplerevent_detail] mele-input mele-value-wrapper mele-value-after {
  min-width: auto;
}
mele-modal[key=dopplerevent_detail] mele-input mele-label {
  text-align: center;
}
mele-modal[key=dopplerevent_detail] mele-input span {
  text-align: right;
}
mele-modal[key=dopplerevent_detail] mele-input[key=result] {
  width: 100%;
  font-family: var(font_bold);
}
mele-modal[key=dopplerevent_detail] mele-input[key=result] span {
  text-align: center;
  text-transform: uppercase;
}
mele-modal[key=dopplerevent_detail] mele-input[key=result][value~=hit] {
  color: var(--red);
}
mele-modal[key=dopplerevent_detail] mele-input[key=result][value~=valid] {
  color: var(--green);
}
mele-modal[key=dopplerevent_detail].result_hit mele-input[key=speed] mele-value-wrapper *, mele-modal[key=dopplerevent_detail].result_hit mele-input[key=speed] mele-value-wrapper span {
  color: var(--red) !important;
}
mele-modal[key=dopplerevent_detail].result_valid mele-input[key=speed] mele-value-wrapper *, mele-modal[key=dopplerevent_detail].result_valid mele-input[key=speed] mele-value-wrapper span {
  color: var(--green) !important;
}
mele-modal[key=dopplerevent_detail].result_simulator div[key=alpr] {
  display: none;
}

body[mode=admin] mele-modal[key=dopplerevent_detail] > mele-wrapper {
  max-width: 90vw !important;
}
body[mode=admin] mele-modal[key=dopplerevent_detail] radar [key=test] {
  display: none;
}
body[mode=admin] mele-modal[key=dopplerevent_detail] canvas {
  max-width: 45vw;
}
body[mode=admin] mele-modal[key=dopplerevent_detail] alprs {
  display: block;
}
body[mode=admin] mele-modal[key=dopplerevent_detail] alprs table {
  border-collapse: collapse;
}
body[mode=admin] mele-modal[key=dopplerevent_detail] alprs table td {
  border: 1px solid gray;
}
body[mode=admin] mele-modal[key=dopplerevent_detail] alprs table td.tile {
  text-align: center;
}
body[mode=admin] mele-modal[key=dopplerevent_detail] alprs table td.tile img {
  height: 13vh;
  vertical-align: middle;
}
body[mode=admin] mele-modal[key=dopplerevent_detail] alprs table td.lpn {
  text-align: center;
}
body[mode=admin] mele-modal[key=dopplerevent_detail] alprs table td.lpn img {
  height: 7vh;
  vertical-align: middle;
}
body[mode=admin] mele-modal[key=dopplerevent_detail] alprs table td.meta {
  vertical-align: middle;
  font-size: 2vh;
}
body[mode=admin] mele-modal[key=dopplerevent_detail] alprs table td.meta lpn {
  display: block;
  white-space: nowrap;
  font-family: var(--font_bold);
  text-align: center;
  padding: 4px 10px;
}
body[mode=admin] mele-modal[key=dopplerevent_detail] alprs table td.meta confidence {
  display: block;
  white-space: nowrap;
  font-family: var(--font_light);
  opacity: 0.7;
  text-align: center;
  padding: 4px 10px;
}
body[mode=admin] mele-modal[key=dopplerevent_detail] alprs table td.good {
  background: #ffff88;
  color: black;
}
body[mode=admin] mele-modal[key=dopplerevent_detail] alprs table td.best {
  background: #80ee80;
  color: black;
}

mele-doppleritem {
  width: 100%;
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  min-height: calc(var(--base_height)*1.5);
  cursor: pointer;
  position: relative;
  overflow: hidden;
  user-select: none;
  background: var(--bg1);
}
mele-doppleritem > left {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: calc(var(--base_height)/8);
  width: calc(var(--base_height) * 1.3);
  height: calc(var(--base_height) * 1.3);
  border-radius: 50%;
}
mele-doppleritem > left .speed {
  font-size: calc(var(--font1)*1.3);
  color: white;
  margin-bottom: 12px;
  margin-top: -4px;
}
mele-doppleritem > left svg {
  height: calc(var(--base_height)/2.5);
  fill: none;
  stroke: white;
}
mele-doppleritem > middle {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: left;
  margin: 0 calc(var(--base_height)/8) 0 0;
  font-size: var(--font2);
}
mele-doppleritem > middle .datetime {
  text-align: center;
  font-size: var(--font3);
}
mele-doppleritem > right {
  display: block;
  position: relative;
  width: calc(var(--base_height)*2);
  height: 100%;
  overflow: hidden;
}
mele-doppleritem > right img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: #88888820;
}
mele-doppleritem[result=hit] left {
  background: var(--red);
}
mele-doppleritem[result=valid] left {
  background: green;
}
mele-doppleritem[result=skip] left {
  background: var(--gray);
}

mele-actor-alpr {
  position: absolute;
  z-index: 500;
  left: 0;
  top: calc(var(--base_height) * 1.2);
  bottom: calc(var(--video-bottom) + var(--base_height) * 0.25 + var(--base_margin));
  overflow-x: hidden;
  overflow-y: auto;
  display: block;
}
mele-actor-alpr alpr {
  user-select: none;
  cursor: pointer;
  display: block;
  text-align: center;
  font-size: 3vmin;
  width: 20vmin;
  height: 6vmin;
  line-height: 6vmin;
  white-space: nowrap;
  font-family: var(--font_normal);
  background: #666666;
  color: white;
  border-radius: 1vmin;
  margin: 1vmin;
  border: 1px solid white;
}
mele-actor-alpr alpr:first-of-type {
  margin-top: 0;
}
mele-actor-alpr alpr.warning {
  background: var(--orange);
}
mele-actor-alpr alpr.special {
  background: var(--magenta);
}
mele-actor-alpr alpr.alert {
  background: var(--red);
}

mele-actor-radar > mele-input {
  transform: translateY(0);
}
mele-actor-radar > mele-input.enlarge {
  transform: scale(1.1) translateY(4px);
}
mele-actor-radar.hidden > mele-input {
  transform: translateY(-200px);
}

mele-actor-radarconfig {
  position: absolute;
  z-index: 400;
  left: 50%;
  transform: translateX(-50%);
  top: 6vmin;
  border-radius: 50%;
  background: white;
  color: #a00;
  border: 1vmin solid #a00;
  width: 10vmin;
  height: 10vmin;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: center;
  font-family: var(--font_bold);
  margin-left: 14vmin;
  overflow: hidden;
  cursor: pointer;
}
mele-actor-radarconfig[mode=off] {
  opacity: 0.5;
}
mele-actor-radarconfig:not([mode=off]):not([mode=manual]):not([mode=automatic]) {
  display: none;
}
mele-actor-radarconfig > * {
  width: 100%;
  text-align: center;
}
mele-actor-radarconfig mele-image {
  display: block;
  padding: 0;
  margin-top: -0.5vmin;
  height: 4vmin;
}
mele-actor-radarconfig mele-image svg * {
  stroke: #000 !important;
}
mele-actor-radarconfig speed {
  display: block;
  font-size: 5vmin;
  margin-top: -3vmin;
}
mele-actor-radarconfig mode {
  display: block;
  font-size: 1.5vmin;
  margin-top: -2.5vmin;
  font-family: var(--font_normal);
}

/* GENERIC STYLING */
mele-actor-roi {
  position: absolute;
  z-index: 100;
  width: 100%;
  height: 100%;
  top: 0;
  right: 0;
  left: 0;
  bottom: var(--video-bottom);
}

mele-actor-roi svg {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  box-sizing: border-box;
}

mele-actor-roi svg rect {
  stroke: red;
  stroke-width: 6px;
  fill: none;
}

mele-actor-roi[state=disconnected] svg rect {
  display: none;
}

mele-actor-roi[state=connected] svg rect {
  display: none;
}

mele-actor-roi[state=analyzing] svg rect {
  stroke: white;
}

mele-actor-roi[state=packing] svg rect {
  stroke: white;
}

mele-actor-roi[state=ready] svg rect {
  stroke: gold;
}

mele-actor-roi[state=starting] svg rect {
  stroke: white;
}

mele-actor-roi[state=measuring] svg rect {
  animation: blink 0.8s infinite;
}

mele-actor-roi[state=finished] svg rect {
  stroke: green;
}

mele-actor-roi[state=interupted] svg rect {
  stroke: red;
}

mele-actor-roi[state=invalid] svg rect {
  stroke: red;
}

mele-actor-roi[state=error] svg rect {
  stroke: red;
}

@keyframes blink {
  100%, 0% {
    stroke: lightgreen;
  }
  60% {
    stroke: darkgreen;
  }
}
/* GENERIC STYLING */
mele-actor-speed {
  grid-area: c;
}

/* GENERIC STYLING */
mele-channel[ch="0"] > mele-actor-time {
  grid-area: a;
}

/* GENERIC STYLING */
mele-actor-timeline {
  display: block;
  position: absolute;
  z-index: 20;
  left: 0;
  right: 0;
  top: 0;
}
mele-actor-timeline svg {
  display: block;
  width: 100%;
  height: var(--base_height);
}
mele-actor-timeline svg * {
  vector-effect: non-scaling-stroke;
  user-select: none;
}
mele-actor-timeline svg .background {
  fill: #8888;
}
mele-actor-timeline svg .now {
  stroke: var(--orange);
  stroke-width: 3;
}
mele-actor-timeline svg .tick1 {
  stroke: #ccc;
  stroke-width: 1;
}
mele-actor-timeline svg .tick2 {
  stroke: #eee;
  stroke-width: 2;
}
mele-actor-timeline svg .label2 {
  text-anchor: middle;
  dominant-baseline: ideographic;
  fill: #eee;
  font-size: calc(var(--base_height) * 0.3);
}
mele-actor-timeline svg .h264 {
  fill: black;
}
mele-actor-timeline svg .markered {
  fill: var(--green);
}
mele-actor-timeline svg .lightbared {
  fill: var(--lightblue);
}
mele-actor-timeline svg .sirened {
  fill: var(--red);
}

.mele-player[timeline] mele-actor-marked {
  top: calc(var(--base_height) * 1.1);
}

mele-actor-marked {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: calc(var(--base_height) * 0.1);
  left: 50%;
  transform: translateX(-50%);
  pointer-events: none;
  z-index: 30;
  /* Stále nastavíme farby cez premenné */
  --pulse-color: transparent;
  --border-color: transparent;
  /* Nová animácia iba s opacity */
  /* Zachované logické prepínače */
}
mele-actor-marked span {
  display: inline-block;
  width: calc(var(--base_height) * 1.2);
  height: calc(var(--base_height) * 0.3);
  border-radius: calc(var(--base_height) * 0.1);
  animation: pulse 1s ease-in-out infinite;
  background-color: var(--pulse-color);
  border: 1px solid var(--border-color);
  margin: calc(var(--base_height) * 0.1);
  opacity: 1;
}
@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.2;
  }
}
mele-actor-marked[marker] span.marker {
  --pulse-color: var(--green);
  --border-color: var(--bg1);
}
mele-actor-marked[lightbar] span.lightbar {
  --pulse-color: var(--lightblue);
  --border-color: var(--bg1);
}
mele-actor-marked[siren] span.siren {
  --pulse-color: var(--red);
  --border-color: var(--bg1);
}
mele-actor-marked:not([marker]) span.marker {
  display: none;
}
mele-actor-marked:not([lightbar]) span.lightbar {
  display: none;
}
mele-actor-marked:not([siren]) span.siren {
  display: none;
}

/* GENERIC STYLING */
mele-actor-zoom {
  position: absolute;
  top: 0;
  left: 0;
  bottom: var(--video-bottom);
  right: 0;
}
mele-actor-zoom[zoom="0"] [key=zoomin], mele-actor-zoom[zoom="0"] [key=zoomout] {
  display: none;
}
mele-actor-zoom[zoom="0"] [key=zoom] mele-labels {
  display: none !important;
}
mele-actor-zoom:not([zoom="0"]) [key=zoom] mele-icon {
  display: none !important;
}
mele-actor-zoom .buttons {
  display: flex;
  flex-direction: column;
  position: absolute;
  bottom: calc(var(--base_height) * 0.25 + var(--base_margin));
  margin: 0;
  gap: 4px;
  right: calc(var(--base_height) * 0.25 + var(--base_margin));
  z-index: 2000;
}
mele-actor-zoom[zooming] [key=refocus], mele-actor-zoom[zooming] [key=zoomin], mele-actor-zoom[zooming] [key=zoomout] {
  pointer-events: none;
  opacity: 0.3;
}
mele-actor-zoom [key=refocus] {
  display: none;
}
mele-actor-zoom mele-button {
  margin: 0;
  border-radius: var(--base_margin);
  background: var(--bg1);
  color: var(--fg1);
  height: calc(var(--base_height) * 0.8);
}
mele-actor-zoom mele-button mele-labels mele-label {
  text-transform: none;
}
mele-actor-zoom mele-button mele-labels mele-label2 {
  font-size: var(--font2);
}
mele-actor-zoom mele-button:not([disabled]):not([selected]):hover {
  background: rgba(255, 255, 255, 0.9);
}
mele-actor-zoom mele-button[wait] wait > mele-image {
  width: 84px;
  height: 84px;
}
mele-actor-zoom mele-view[key=settings] {
  display: block;
  z-index: 125;
  position: absolute;
  bottom: calc(var(--base_height) + var(--button-margin) * 3);
  right: calc(var(--base_height) + var(--button-margin) * 4);
  background: var(--bg1) !important;
  box-shadow: 0 0 20px 10px rgba(0, 0, 0, 0.3);
  opacity: 0.9;
  width: min-content;
  padding: var(--base_margin);
}
mele-actor-zoom mele-view[key=settings] mele-input {
  --input-padding: 4px 10px;
  --base_width: 64px;
}
mele-actor-zoom mele-view[key=settings] mele-input[type=grid] {
  width: max-content;
}
mele-actor-zoom mele-view[key=settings] mele-input[key=mode] mele-item:not([key]) {
  display: none !important;
}
mele-actor-zoom mele-view[key=settings] mele-value-content {
  width: auto;
}
mele-actor-zoom mele-view[key=settings] [key=switches] {
  width: 100%;
  display: grid;
}
mele-actor-zoom canvas {
  position: absolute;
  z-index: 12;
  bottom: 0;
  left: 0;
  width: 100%;
  height: auto;
  object-fit: contain;
}

.mele-calendar * {
  user-select: none;
}

.mele-calendar[nosecond] .timestamp-wrapper .dt.second {
  display: none;
}
.mele-calendar .calendar-title {
  height: var(--base_height_50) !important;
  min-height: var(--base_height_50) !important;
  text-transform: uppercase;
  background: var(--bg3) !important;
  border-bottom: 1px solid var(--bg2) !important;
}
.mele-calendar .timestamp-wrapper {
  border-bottom: none !important;
}
.mele-calendar .calendar-body {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
}
.mele-calendar .calendar-body .calendar {
  -webkit-tap-highlight-color: transparent;
  height: var(--base_height);
  display: flex;
  align-items: center;
  justify-content: center;
  width: initial;
  min-width: initial;
  padding: 0;
  margin: 0;
  cursor: pointer;
}
.mele-calendar .calendar-body .calendar[disabled] {
  color: var(--gray);
  cursor: pointer;
}
.mele-calendar .calendar-body .calendar.year {
  border-style: solid;
  border-color: var(--bg2);
  border-width: 0px 1px 1px 0px;
}
.mele-calendar .calendar-body .calendar.month {
  border-style: solid;
  border-color: var(--bg2);
  border-width: 0px 1px 1px 0px;
}
.mele-calendar .calendar-body .calendar.day {
  border-style: solid;
  border-color: var(--bg2);
  border-width: 0px 1px 1px 0px;
}
.mele-calendar .calendar-body .calendar.day:not(.dayname):nth-child(7n+6), .mele-calendar .calendar-body .calendar.day:not(.dayname):nth-child(7n+7) {
  background: var(--bg3);
}
.mele-calendar .calendar-body .calendar.day:not(.dayname):nth-child(7n+6)[selected], .mele-calendar .calendar-body .calendar.day:not(.dayname):nth-child(7n+7)[selected] {
  color: var(--white);
  background: var(--blue) !important;
}
.mele-calendar .calendar-body .calendar[selected], .mele-calendar .calendar-body .calendar:hover {
  color: var(--white);
  background: var(--blue) !important;
}
.mele-calendar .calendar-body .calendar.minute, .mele-calendar .calendar-body .calendar.second {
  height: var(--base_height);
}
.mele-calendar .calendar-body .calendar.hour.am:nth-of-type(n+7) {
  border-bottom: 1px solid var(--bg3);
}
.mele-calendar .calendar-body .calendar.dayname {
  opacity: 1 !important;
  height: var(--base_height_50);
  pointer-events: none;
}
.mele-calendar .calendar-body .calendar.dayname > mele-labels > mele-label {
  font-size: var(--font3);
}

.mele-calendar[tab=day] .calendar-body {
  grid-template-columns: repeat(7, 1fr);
}
.mele-calendar[tab=month] .calendar-body {
  grid-template-columns: repeat(3, 1fr);
}
.mele-calendar[tab=year] .calendar-body {
  grid-template-columns: repeat(3, 1fr);
}
.mele-calendar[tab=hour] .calendar-body {
  grid-template-columns: repeat(6, 1fr);
}
.mele-calendar[tab=minute] .calendar-body {
  grid-template-columns: repeat(6, 1fr);
}
.mele-calendar[tab=second] .calendar-body {
  grid-template-columns: repeat(6, 1fr);
}
.mele-calendar[type=date] mele-timestamp mele-item[key=hour], .mele-calendar[type=date] mele-timestamp mele-item[key=minute], .mele-calendar[type=date] mele-timestamp mele-item[key=second] {
  display: none;
}
.mele-calendar[type=time] mele-timestamp mele-item[key=year], .mele-calendar[type=time] mele-timestamp mele-item[key=month], .mele-calendar[type=time] mele-timestamp mele-item[key=day] {
  display: none;
}

[behavior=phone] .mele-calendar .mele-item.mele-button.calendar.minute {
  height: 36px;
}

/* GENERIC STYLING */
mele-calendar-datetime {
  user-select: none;
  display: block;
  margin: var(--font2);
  width: 100%;
  text-align: center;
}
mele-calendar-datetime value {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
mele-calendar-datetime value > div {
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: calc(var(--font2)*3);
  height: calc(var(--font2)*3);
  box-sizing: border-box;
}
mele-calendar-datetime value > .year {
  width: calc(var(--font2)*5);
}
mele-calendar-datetime value > span {
  width: var(--font2);
}

mele-calendar-datetime:not([readonly]) value > div {
  border: 1px solid gray;
  cursor: pointer;
}
mele-calendar-datetime:not([readonly]) value > div:hover:not([selected]) {
  background: var(--fg2);
  color: var(--bg2);
  transition: background 0.3s;
}
mele-calendar-datetime:not([readonly]) value > div[selected] {
  background: var(--blue);
  color: white;
}

mele-calendar-datetime[lastunit=minute] > value > .second {
  display: none;
}

mele-calendar-datetime[lastunit=hour] > value > .second {
  display: none;
}
mele-calendar-datetime[lastunit=hour] > value > .minute {
  display: none;
}

mele-calendar-datetime[lastunit=day] > value > .second {
  display: none;
}
mele-calendar-datetime[lastunit=day] > value > .minute {
  display: none;
}
mele-calendar-datetime[lastunit=day] > value > .hour {
  display: none;
}

mele-calendar-datetime[lastunit=month] > value > .second {
  display: none;
}
mele-calendar-datetime[lastunit=month] > value > .minute {
  display: none;
}
mele-calendar-datetime[lastunit=month] > value > .hour {
  display: none;
}
mele-calendar-datetime[lastunit=month] > value > .day {
  display: none;
}

mele-calendar-datetime[lastunit=year] > value > .second {
  display: none;
}
mele-calendar-datetime[lastunit=year] > value > .minute {
  display: none;
}
mele-calendar-datetime[lastunit=year] > value > .hour {
  display: none;
}
mele-calendar-datetime[lastunit=year] > value > .day {
  display: none;
}
mele-calendar-datetime[lastunit=year] > value > .month {
  display: none;
}

/* GENERIC STYLING */
mele-calendar-player {
  user-select: none;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: var(--font2);
}
mele-calendar-player[unit=day] values v:not(.h264), mele-calendar-player[unit=hour] values v:not(.h264), mele-calendar-player[unit=minute] values v:not(.h264), mele-calendar-player[unit=second] values v:not(.h264) {
  opacity: 0.3;
  cursor: no-drop;
}
mele-calendar-player unit {
  display: block;
  margin: 0;
}
mele-calendar-player values {
  display: block;
  margin: var(--font2);
  margin-top: 0;
}
mele-calendar-player values v {
  position: relative;
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: calc(var(--font2)*3);
  height: calc(var(--font2)*3);
  border: 1px solid gray;
  box-sizing: border-box;
  margin: 2px;
  cursor: pointer;
}
mele-calendar-player values v.h264:hover:not([selected]) {
  background: var(--fg2);
  color: var(--bg2);
  transition: background 0.3s;
}
mele-calendar-player values v[selected] {
  background: var(--blue);
  color: white;
}
mele-calendar-player values idx {
  display: none;
  pointer-events: none;
}
mele-calendar-player values idx.markered {
  display: block;
  position: absolute;
  top: -1px;
  left: 0px;
  right: 0px;
  height: 3px;
  background: var(--green);
  z-index: 20;
}
mele-calendar-player values idx.sirened {
  display: block;
  position: absolute;
  top: 3px;
  left: 0;
  right: 0;
  height: 3px;
  background: var(--red);
  z-index: 20;
}
mele-calendar-player values idx.lightbared {
  display: block;
  position: absolute;
  top: 7px;
  left: 0;
  right: 0;
  height: 3px;
  background: var(--lightblue);
  z-index: 20;
}
mele-calendar-player values idx.dopplercalibration {
  display: block;
  position: absolute;
  bottom: 0;
  left: 0;
  font-size: var(--font3);
  color: var(--blue);
}
mele-calendar-player values idx.dopplercalibration::before {
  content: "C";
}
mele-calendar-player values v.dopplerevent:after {
  position: absolute;
  top: 0vw;
  right: 0vw;
  width: 0;
  height: 0;
  color: transparent;
  content: "&nbsp;";
  border-top: calc(var(--font2) * 0.8) solid transparent;
  border-right: calc(var(--font2) * 0.8) solid transparent;
  border-left: calc(var(--font2) * 0.8) solid gold;
  transform: rotateY(0deg) rotate(180deg);
}
mele-calendar-player values v.radarhit:after {
  position: absolute;
  top: 0vw;
  right: 0vw;
  width: 0;
  height: 0;
  color: transparent;
  content: "&nbsp;";
  border-top: calc(var(--font2) * 0.8) solid transparent;
  border-right: calc(var(--font2) * 0.8) solid transparent;
  border-left: calc(var(--font2) * 0.8) solid red;
  transform: rotateY(0deg) rotate(180deg);
}
mele-calendar-player[unit=year] values {
  width: calc( 6 * ((var(--font2) * 3) + 4px));
  text-align: center;
}
mele-calendar-player[unit=month] values {
  width: calc( 6 * ((var(--font2) * 3) + 4px));
}
mele-calendar-player[unit=day] values {
  width: calc( 7 * ((var(--font2) * 3) + 4px));
}
mele-calendar-player[unit=hour] values {
  width: calc( 6 * ((var(--font2) * 3) + 4px));
}
mele-calendar-player[unit=minute] values {
  width: calc( 10 * ((var(--font2) * 3) + 4px));
}
mele-calendar-player[unit=second] values {
  width: calc( 10 * ((var(--font2) * 3) + 4px));
}

/* GENERIC STYLING */
.mele-timestamp > mele-wrapper {
  width: 100%;
}
.mele-timestamp > mele-wrapper > mele-body-wrapper > mele-body {
  background: var(--bg3);
  display: grid;
  width: 100%;
  grid-template-columns: 2fr 1fr 1fr 0.1fr 1fr 1fr;
  align-content: center;
}
.mele-timestamp > mele-wrapper > mele-body-wrapper > mele-body span {
  background: var(--bg2);
  height: 100%;
}
.mele-timestamp > mele-wrapper > mele-body-wrapper > mele-body mele-sinput.mele-sinput {
  position: relative;
  height: 50px;
  line-height: 25px;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
.mele-timestamp > mele-wrapper > mele-body-wrapper > mele-body mele-sinput.mele-sinput mele-label {
  order: 2;
  font-size: 14px;
  text-transform: uppercase;
}
.mele-timestamp > mele-wrapper > mele-body-wrapper > mele-body mele-sinput.mele-sinput.selected {
  outline: none;
}
.mele-timestamp > mele-wrapper > mele-body-wrapper > mele-body mele-sinput.mele-sinput.selected:not([invalid]) {
  background: var(--blue);
  color: white;
}

/* SPECIAL TREATMENT OF DIFFERENT TYPES */
.mele-timestamp[type=date] > mele-wrapper > mele-body-wrapper > mele-body {
  grid-template-columns: 2fr 1fr 1fr;
}
.mele-timestamp[type=time] > mele-wrapper > mele-body-wrapper > mele-body {
  grid-template-columns: 1fr 1fr;
}
.mele-timestamp[type=datetime] > mele-wrapper > mele-body-wrapper > mele-body {
  grid-template-columns: 2fr 1fr 1fr 0.2fr 1fr 1fr;
}
.mele-timestamp[type=datetimems] > mele-wrapper > mele-body-wrapper > mele-body {
  grid-template-columns: 2fr 1fr 1fr 0.2fr 1fr 1fr 1fr;
}

/* COLORING */
mele-carousel {
  width: 100%;
  text-align: center;
  overflow: hidden;
  position: relative;
}
mele-carousel mele-body {
  display: flex;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  scroll-behavior: smooth;
}
mele-carousel mele-body .slide {
  scroll-snap-align: start;
  flex-shrink: 0;
  width: 100%;
  height: auto;
  margin-right: 50px;
  transform-origin: center center;
  transform: scale(1);
  transition: transform 0.5s;
}
mele-carousel mele-button.noreadonly[key=next] {
  position: absolute;
  right: 0;
  top: 50%;
}
mele-carousel mele-button.noreadonly[key=prev] {
  position: absolute;
  left: 0;
  top: 50%;
}
mele-carousel .indicators {
  position: absolute;
  bottom: 0px;
  height: 40px;
  width: 100%;
  display: grid;
  place-content: center;
  grid-auto-flow: column;
  grid-gap: 10px;
}
mele-carousel .indicators .indicator {
  cursor: pointer;
  background: var(--gray);
  height: 10px;
  width: 10px;
  border-radius: 50%;
  border: 1px solid white;
}
mele-carousel .indicators .indicator[selected] {
  background: var(--red);
}

/* GENERIC STYLING */
.mele-table {
  height: 100%;
  position: relative;
}
.mele-table mele-header[key=columns] {
  font-size: var(--font2);
  text-align: center;
  display: flex;
  height: var(--base_height);
  box-sizing: border-box;
  min-width: unset;
  max-width: unset;
}
.mele-table mele-header[key=columns] th {
  font-family: var(--font_bold) !important;
  height: 100%;
  text-transform: uppercase;
  display: flex;
  justify-content: center;
  align-items: center;
}
.mele-table > mele-wrapper > mele-body-wrapper {
  width: 100%;
  height: 100%;
}
.mele-table > mele-wrapper > mele-body-wrapper > mele-body {
  display: table !important;
  box-sizing: border-box;
  width: 100% !important;
  flex: unset;
}
.mele-table > mele-wrapper > mele-body-wrapper > mele-body mele-item.section {
  display: table-row-group;
}
.mele-table > mele-wrapper > mele-body-wrapper > mele-body mele-item.section:hover {
  background: none !important;
}
.mele-table > mele-wrapper > mele-body-wrapper > mele-body mele-item.section mele-icon {
  display: none !important;
}
.mele-table > mele-wrapper > mele-body-wrapper > mele-body mele-item.section mele-labels {
  flex-direction: row;
  justify-content: center;
  height: var(--base_height_50);
  align-items: center;
}
.mele-table > mele-wrapper > mele-body-wrapper > mele-body mele-item.section mele-labels mele-label {
  text-align: center !important;
  font-family: var(--font_bold);
}
.mele-table:not(.readonly) mele-row, .mele-table:not(.readonly) mele-row-hidden {
  cursor: pointer;
}
.mele-table:not(.readonly) mele-row:hover, .mele-table:not(.readonly) mele-row-hidden:hover {
  background: var(--bg3_transparent);
}
.mele-table:not(.readonly) mele-row[selected]:hover, .mele-table:not(.readonly) mele-row-hidden[selected]:hover {
  background: var(--blue);
  color: var(--white);
}
.mele-table mele-row, .mele-table mele-row-hidden {
  display: table-row;
}
.mele-table mele-row td, .mele-table mele-row-hidden td {
  padding-left: 10px;
  padding-right: 10px;
  height: var(--base_height_50);
  font-size: var(--font3);
  display: table-cell;
  text-align: center;
  vertical-align: middle;
}
.mele-table mele-row:nth-child(odd), .mele-table mele-row-hidden:nth-child(odd) {
  background: var(--bg1_alt);
}
.mele-table mele-row[selected], .mele-table mele-row[selected]:hover, .mele-table mele-row-hidden[selected], .mele-table mele-row-hidden[selected]:hover {
  background: var(--blue);
  color: var(--white);
}
.mele-table mele-row:last-of-type {
  box-shadow: 1px 1px 0 0 var(--bg1_alt);
}
.mele-table mele-row-hidden {
  display: table-row !important;
  visibility: hidden;
  min-height: auto !important;
  line-height: 0 !important;
}
.mele-table mele-row-hidden td {
  font-size: var(--font2);
  padding: 0px !important;
  height: initial !important;
}

/* COLORING */
.mele-window:not([behavior=desktop]) .mele-table td, .mele-modal:not([behavior=desktop]) .mele-table td {
  padding-top: 10px;
  padding-bottom: 10px;
}

.mele-table.inline {
  height: auto;
}
.mele-table.inline > mele-wrapper > mele-header-wrapper > *:not(:empty):not(.empty) {
  box-shadow: none;
}
.mele-table.inline mele-row:nth-child(odd):not([selected]), .mele-table.inline .mele-table mele-row-hidden:nth-child(odd):not([selected]) {
  background: inherit;
}
.mele-table.inline > mele-wrapper > mele-header-wrapper {
  border-bottom: 1px solid var(--bg3);
}
.mele-table.inline mele-row td {
  border-bottom: 1px solid var(--bg3);
}

.mele-table[responsive] > mele-wrapper > mele-header-wrapper {
  display: none;
}
.mele-table[responsive] > mele-wrapper > mele-body-wrapper > mele-body {
  display: grid !important;
  grid-template-columns: 1fr;
  padding: 5px;
  grid-gap: 5px;
}
.mele-table[responsive] > mele-wrapper > mele-body-wrapper > mele-body mele-row-hidden {
  display: none !important;
}
.mele-table[responsive] > mele-wrapper > mele-body-wrapper > mele-body mele-row.mele-row {
  display: flex;
  flex-direction: column;
  background: var(--bg1);
  position: relative;
  margin-right: 25px;
}
.mele-table[responsive] > mele-wrapper > mele-body-wrapper > mele-body mele-row.mele-row[selected] {
  background: var(--blue);
}
.mele-table[responsive] > mele-wrapper > mele-body-wrapper > mele-body mele-row.mele-row td:not(.icon) {
  display: flex;
  padding: 0;
  box-sizing: border-box;
  border-bottom: 1px solid var(--bg3);
  align-items: center;
  text-align: justify;
}
.mele-table[responsive] > mele-wrapper > mele-body-wrapper > mele-body mele-row.mele-row td:not(.icon)[responsive]::before {
  content: attr(responsive);
  display: flex;
  flex-basis: 33%;
  padding: 0 8px;
  align-items: center;
  color: var(--fg1);
  font-family: var(--font_bold);
  text-transform: uppercase;
}

/* SPECIAL HANDLING FOR PHONE VIEW */
[behavior=phone] .mele-table > mele-wrapper > mele-header-wrapper > mele-header[key=columns] {
  width: fit-content;
  min-height: 32px !important;
  height: fit-content;
  background: var(--bg3) !important;
  border-bottom: none !important;
}

[behavior=phone] .mele-table[view] > mele-wrapper > mele-header-wrapper > mele-header[key=core_header].empty {
  display: block !important;
  min-height: var(--base_height);
  background: linear-gradient(to bottom, var(--bg1) 10%, var(--bg2) 70%);
}

/* GENERIC STYLING */
.mele-keyvalues {
  display: flex;
  flex-direction: column;
}
.mele-keyvalues > mele-wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
}
.mele-keyvalues > mele-wrapper > mele-header-wrapper {
  display: flex;
  flex-direction: column;
  flex: 0 0 auto;
  z-index: 1;
  font-size: var(--font1);
  text-align: center;
  padding: calc(var(--font1) * 0.5);
}
.mele-keyvalues > mele-wrapper > mele-header-wrapper.empty {
  display: none !important;
}
.mele-keyvalues > mele-wrapper > mele-body-wrapper {
  display: flex;
  flex: 1 1 auto;
  position: relative;
  overflow-y: auto;
  overflow-x: hidden;
  font-size: var(--font2);
}
.mele-keyvalues > mele-wrapper > mele-body-wrapper > mele-body {
  display: grid;
  grid-template-columns: auto auto;
}
.mele-keyvalues > mele-wrapper > mele-body-wrapper > mele-body kv {
  display: contents;
}
.mele-keyvalues > mele-wrapper > mele-body-wrapper > mele-body kv k {
  grid-column: 1;
}
.mele-keyvalues > mele-wrapper > mele-body-wrapper > mele-body kv v {
  grid-column: 2;
  display: block;
  word-break: break-word;
  overflow-wrap: break-word;
  white-space: normal;
}
.mele-keyvalues > mele-wrapper > mele-body-wrapper > mele-body kv:not([key]) v {
  grid-column: span 2;
}

/* GENERIC STYLING */
.mele-group {
  display: flex;
  flex-direction: column;
  width: 100%;
  cursor: default;
  user-select: none;
}
.mele-group .group-wrapper {
  display: flex;
  flex-direction: column;
  flex: 1;
}
.mele-group .group-wrapper .group-header-wrapper {
  display: flex;
  flex-direction: column;
  flex: 0 0 auto;
  font-family: var(--font_semibold);
}
.mele-group .group-wrapper .group-header-wrapper .group-header {
  font-size: var(--font2);
  text-transform: uppercase;
  text-align: center;
}
.mele-group .group-wrapper .group-footer-wrapper {
  display: flex;
  flex-direction: column;
  flex: 0 0 auto;
  font-family: var(--font_bold);
  font-size: var(--font3);
}
.mele-group .group-wrapper .group-body-wrapper {
  display: flex;
  flex: 0 1 auto;
  position: relative;
  overflow-y: auto;
  overflow-x: hidden;
}
.mele-group .group-wrapper .group-body-wrapper .group-body {
  position: relative;
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  align-content: flex-start;
  justify-content: center;
  width: 100%;
}
.mele-group[collapsible] .group-wrapper .group-header-wrapper {
  cursor: pointer;
}
.mele-group[collapsible] .group-wrapper .group-header-wrapper .group-header {
  position: relative;
}
.mele-group[collapsible] .group-wrapper .group-header-wrapper .group-header:not(:empty)::after {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
  width: 20px;
  display: block;
  position: absolute;
  right: 10px;
  top: 0px;
}
.mele-group[collapsed] .group-wrapper .group-header-wrapper .group-header {
  position: relative;
}
.mele-group[collapsed] .group-wrapper .group-header-wrapper .group-header:not(:empty)::after {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
}
.mele-group[collapsed] .group-wrapper .group-body-wrapper, .mele-group[collapsed] .group-wrapper .group-footer-wrapper {
  display: none;
}

/* SPECIAL TREATMENT OF DIFFERENT TYPES */
.mele-group.frame .group-wrapper {
  border: 1px solid var(--bg3);
  margin: var(--base_margin) var(--large_margin);
}
.mele-group.frame .group-wrapper .group-header-wrapper {
  text-align: center;
  padding: var(--base_margin);
  text-transform: uppercase;
}
.mele-group.frame .group-wrapper .group-footer-wrapper {
  text-align: center;
  padding: var(--base_margin);
  text-transform: uppercase;
}
.mele-group.frame[collapsed] .group-wrapper {
  position: relative;
}
.mele-group.frame[collapsed] .group-wrapper::after {
  content: "...";
  position: absolute;
  top: 8px;
  right: 17px;
}

.mele-group.hr {
  padding: 10px 5px;
}

.mele-group.hr .group-wrapper .group-header-wrapper .group-header {
  background: var(--bg2);
  padding: 5px 0;
  text-align: center;
}
.mele-group.hr .group-wrapper .group-header-wrapper .group-header:empty {
  display: none;
}

body:not([behavior=phone]) [view]:not([role~=narrow]) .group-wrapper .group-body-wrapper .group-body .mele-group[width="1/2"] {
  width: 49.99999% !important;
}
body:not([behavior=phone]) [view]:not([role~=narrow]) .group-wrapper .group-body-wrapper .group-body .mele-group [width="1/3"] {
  width: 33.3332% !important;
}
body:not([behavior=phone]) [view]:not([role~=narrow]) .group-wrapper .group-body-wrapper .group-body .mele-group[width="1/4"] {
  width: 24.9999% !important;
}
body:not([behavior=phone]) [view]:not([role~=narrow]) .group-wrapper .group-body-wrapper .group-body .mele-group [width="2/3"] {
  width: 66.66665% !important;
}
body:not([behavior=phone]) [view]:not([role~=narrow]) .group-wrapper .group-body-wrapper .group-body .mele-group[width="3/4"] {
  width: 74.999925% !important;
}

body:not([behavior=phone]) .mele-view:not([role~=narrow]) .mele-group [width="1/2"] {
  width: calc( 50% - var(--space));
}
body:not([behavior=phone]) .mele-view:not([role~=narrow]) .mele-group [width="1/3"] {
  width: calc( 33.3333% - var(--space));
}
body:not([behavior=phone]) .mele-view:not([role~=narrow]) .mele-group [width="1/4"] {
  width: calc( 25% - var(--space));
}
body:not([behavior=phone]) .mele-view:not([role~=narrow]) .mele-group [width="2/3"] {
  width: calc( 66.6666% - var(--space));
}
body:not([behavior=phone]) .mele-view:not([role~=narrow]) .mele-group [width="3/4"] {
  width: calc( 75% - var(--space));
}

/* GENERIC STYLING */
.mele-tabs {
  display: flex;
  flex-direction: column;
  width: 100%;
  cursor: default;
  user-select: none;
  background: var(--bg1);
}
.mele-tabs > mele-wrapper {
  display: flex;
  flex-direction: row;
  flex: 1;
}
.mele-tabs > mele-wrapper > mele-tabs-wrapper {
  display: flex;
  flex-direction: column;
  flex: 0 0 auto;
  font-family: var(--font_bold);
}
.mele-tabs > mele-wrapper > mele-tabs-wrapper .mele-item[disabled] {
  opacity: var(--disabled);
}
.mele-tabs > mele-wrapper > mele-body-wrapper {
  display: flex;
  flex: 1 1 auto;
  position: relative;
  overflow-y: auto;
  overflow-x: hidden;
  flex-direction: column;
}
.mele-tabs > mele-wrapper > mele-body-wrapper > mele-body {
  position: relative;
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  align-content: flex-start;
  width: 100%;
}
.mele-tabs > mele-wrapper > mele-body-wrapper > mele-body mele-group[disabled] {
  display: none;
}
.mele-tabs > mele-wrapper > mele-footer-wrapper {
  display: flex;
  flex-direction: column-reverse;
  flex: 0 0 auto;
  max-width: 100vw;
}
.mele-tabs > mele-wrapper > mele-footer-wrapper > * {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.mele-tabs > mele-wrapper > mele-footer-wrapper > * > *:empty, .mele-tabs > mele-wrapper > mele-footer-wrapper > * > *.empty {
  display: none !important;
}
.mele-tabs > mele-wrapper > mele-footer-wrapper > *:empty, .mele-tabs > mele-wrapper > mele-footer-wrapper > *.empty {
  display: none !important;
}
.mele-tabs > mele-wrapper > mele-footer-wrapper > *:not(:empty):not(.empty) {
  min-height: var(--base_height);
  border-top: 1px solid var(--bg3);
}
.mele-tabs > mele-wrapper > mele-footer-wrapper > *:not(:empty):not(.empty) ~ *:not(:empty):not(.empty) {
  min-height: auto;
  box-shadow: none;
  overflow: hidden;
}
.mele-tabs[phase=none] .mele-button[action=prev], .mele-tabs[phase=none] .mele-button[action=next] {
  opacity: var(--disabled);
}
.mele-tabs[phase=first] .mele-button[action=prev] {
  opacity: var(--disabled);
}
.mele-tabs[phase=last] .mele-button[action=next] {
  opacity: var(--disabled);
}

/* SPECIAL TREATMENT OF DIFFERENT TYPES */
mele-tabs.mele-tabs[direction=horizontal] > mele-wrapper {
  flex-direction: column;
}
mele-tabs.mele-tabs[direction=horizontal] > mele-wrapper > mele-tabs-wrapper > .mele-list {
  align-items: center;
}
mele-tabs.mele-tabs[direction=horizontal] > mele-wrapper > mele-tabs-wrapper > .mele-list > mele-wrapper > mele-body-wrapper > mele-body > .mele-item {
  height: var(--base_height);
  padding: 0px var(--large_margin);
}

mele-tabs.mele-tabs[direction=horizontal].hr > mele-wrapper > mele-tabs-wrapper > .mele-list {
  background: linear-gradient(0, rgba(0, 0, 0, 0) calc(50% - 1px), var(--fg2) calc(50%), rgba(0, 0, 0, 0) calc(50% + 1px));
}
mele-tabs.mele-tabs[direction=horizontal].hr > mele-wrapper > mele-tabs-wrapper > .mele-list > mele-wrapper {
  background: var(--bg1);
}

mele-tabs.mele-tabs[direction=veritical] > mele-wrapper {
  flex-direction: row;
}

.mele-tabs[mode=listlike] > mele-wrapper {
  flex-direction: column;
}

.mele-tabs[mode=listlike][selected] mele-tabs-wrapper {
  display: none;
}
.mele-tabs[mode=listlike][selected] > mele-wrapper mele-body-wrapper > mele-body {
  order: 2;
}
.mele-tabs[mode=listlike][selected] > mele-wrapper mele-body-wrapper .tab-detail-back {
  order: 1;
}

.mele-tabs[mode=listlike]:not([selected]) mele-tabs-wrapper {
  width: 100%;
}
.mele-tabs[mode=listlike]:not([selected]) .tab-detail-back {
  display: none;
}

.mele-tabs[mode=scrollable] mele-tabs-wrapper {
  display: none;
}

/* WIDTH OF GROUP */
.mele-tabs[width=none] {
  width: initial;
}

.mele-tabs {
  width: 100%;
}

/* GENERIC STYLING */
.mele-row {
  display: table-row;
}
.mele-row td.icon {
  width: 40px !important;
  max-width: 40px !important;
}
.mele-row td svg {
  height: 32px;
  width: 32px;
}

/* SPECIAL TREATMENT OF DIFFERENT TYPES */
.mele-row[section] {
  pointer-events: none;
}
.mele-row[section] td {
  text-align: left;
  background: var(--bg3);
  padding: 0 0 0 var(--large_margin) !important;
  font-family: var(--font_bold);
  text-transform: uppercase;
}

/* COLORING */
.mele-row td.icon [stroke=fg] {
  stroke: var(--fg2);
}
.mele-row td.icon [fill=fg] {
  fill: var(--fg2);
}
.mele-row td.icon [stroke=bg] {
  stroke: var(--bg1);
}
.mele-row td.icon [fill=bg] {
  fill: var(--bg1);
}
.mele-row td.img img {
  height: 70%;
  vertical-align: middle;
}

/* GENERIC STYLING */
.mele-sinput {
  font-size: var(--font2);
  color: var(--fg1);
  resize: none;
  padding: 0 4px;
}
.mele-sinput[contenteditable] {
  border-radius: 4px;
  border: 1px solid var(--bg3);
  background: var(--bg2);
}
.mele-sinput:empty:before {
  content: attr(placeholder);
  opacity: var(--disabled);
}

.mele-sinput[invalid] {
  background: var(--bginvalid);
}

.mele-sinput[readonly] {
  background: none;
}

/* COLORING */
/* GENERIC STYLING */
.dropdown-wrapper {
  user-select: none;
  --small-height: var(--small_height);
  display: grid;
  grid-template-columns: 1fr var(--small-height);
}
.dropdown-wrapper:focus {
  outline: none;
  transition: all 0.1s ease;
}
.dropdown-wrapper .dropdown-body {
  flex-basis: 100%;
}
.dropdown-wrapper .dropdown-body .dropdown-item .dropdown-label2 {
  color: var(--fg2);
}
.dropdown-wrapper .dropdown-body .dropdown-item:hover {
  background: inherit;
}
.dropdown-wrapper .dropdown-body .dropdown-item[selected] {
  color: var(--fg2);
  background: transparent;
}
.dropdown-wrapper .dropdown-body .dropdown-item[selected] .dropdown-value {
  display: none;
}
.dropdown-wrapper .dropdown-body .dropdown-item .dropdown-color {
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}
.dropdown-wrapper svg {
  width: var(--small_height_2);
  min-width: var(--small_height_2);
  height: var(--small_height_2);
  border: 4px solid transparent;
  box-sizing: border-box;
}
.dropdown-wrapper svg [stroke=fg] {
  stroke: var(--fg2);
}
.dropdown-wrapper svg [fill=fg] {
  fill: var(--fg2);
}
.dropdown-wrapper svg [stroke=bg] {
  stroke: var(--bg1);
}
.dropdown-wrapper svg [fill=bg] {
  fill: var(--bg1);
}

.dropdown-item:first-of-type dropdown-color {
  border-top-left-radius: 5px;
}

.dropdown-item:last-of-type dropdown-color, .dropdown-item:only-child dropdown-color {
  border-bottom-left-radius: 5px;
}

.dropdown-item {
  position: relative;
  display: flex;
  flex: 1;
  flex-basis: 100%;
  justify-content: flex-start;
  align-items: center;
  flex-direction: row;
  min-height: var(--small_height_2);
  overflow: hidden;
  cursor: pointer;
}
.dropdown-item.active {
  background: var(--bg3_transparent);
}
.dropdown-item .dropdown-color {
  position: absolute;
  left: 0px;
  width: 5px;
  height: 100%;
}
.dropdown-item .dropdown-color.red {
  background: var(--red);
}
.dropdown-item .dropdown-color.green {
  background: var(--green);
}
.dropdown-item .dropdown-color.orange {
  background: var(--orange);
}
.dropdown-item .dropdown-color.blue {
  background: var(--blue);
}
.dropdown-item .dropdown-color.magenta {
  background: var(--magenta);
}
.dropdown-item .dropdown-color.gray {
  background: var(--gray);
}
.dropdown-item .dropdown-label {
  padding-left: 12px;
  font-size: var(--font2);
  display: flex;
  flex: 1;
  word-break: break-word;
}
.dropdown-item .dropdown-value {
  padding-right: 12px;
  font-size: var(--font2);
}
.dropdown-item .dropdown-label2 {
  padding-left: 11px;
  font-size: var(--font3);
  line-height: 10px;
}
.dropdown-item:not([selected]):hover {
  background: var(--bg3_transparent);
}
.dropdown-item[selected] {
  background: var(--blue);
  color: var(--white);
}

[behavior=phone] dropdown-item {
  min-height: var(--small_height);
}

mele-modal.dropdown > mele-wrapper > mele-header-wrapper > mele-input.mele-input {
  display: grid;
  padding: 0;
}

.modal-wrapper .modal-body .list-wrapper .list-body-wrapper .list-body .item-wrapper {
  min-height: unset;
}

/* GENERIC STYLING */
.mele-editor {
  width: 100%;
}
.mele-editor .ql-toolbar {
  display: flex;
  justify-content: center;
}

/* SPECIAL TREATMENT OF DIFFERENT TYPES */
/*!
* Quill Editor v1.0.0
* https://quilljs.com/
* Copyright (c) 2014, Jason Chen
* Copyright (c) 2013, salesforce.com
*/
.ql-container {
  box-sizing: border-box;
  font-family: Helvetica, Arial, sans-serif;
  font-size: 13px;
  height: 100%;
  margin: 0px;
  position: relative;
}

.ql-clipboard {
  left: -100000px;
  height: 1px;
  overflow-y: hidden;
  position: absolute;
  top: 50%;
}

.ql-clipboard p {
  margin: 0;
  padding: 0;
}

.ql-editor {
  box-sizing: border-box;
  cursor: text;
  line-height: 1.42;
  height: 100%;
  outline: none;
  overflow-y: auto;
  padding: 12px 15px;
  tab-size: 4;
  -moz-tab-size: 4;
  text-align: left;
  white-space: pre-wrap;
  word-wrap: break-word;
}

.ql-editor p,
.ql-editor ol,
.ql-editor ul,
.ql-editor pre,
.ql-editor blockquote,
.ql-editor h1,
.ql-editor h2,
.ql-editor h3,
.ql-editor h4,
.ql-editor h5,
.ql-editor h6 {
  margin: 0;
  padding: 0;
  counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
}

.ql-editor ol,
.ql-editor ul {
  padding-left: 1.5em;
}

.ql-editor ol > li,
.ql-editor ul > li {
  list-style-type: none;
}

.ql-editor ul > li::before {
  content: "●";
}

.ql-editor li::before {
  display: inline-block;
  margin-right: 0.3em;
  text-align: right;
  white-space: nowrap;
  width: 1.2em;
}

.ql-editor li:not(.ql-direction-rtl)::before {
  margin-left: -1.5em;
}

.ql-editor ol li,
.ql-editor ul li {
  padding-left: 1.5em;
}

.ql-editor ol li {
  counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
  counter-increment: list-num;
}

.ql-editor ol li:before {
  content: counter(list-num, decimal) ". ";
}

.ql-editor ol li.ql-indent-1 {
  counter-increment: list-1;
}

.ql-editor ol li.ql-indent-1:before {
  content: counter(list-1, lower-alpha) ". ";
}

.ql-editor ol li.ql-indent-1 {
  counter-reset: list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;
}

.ql-editor ol li.ql-indent-2 {
  counter-increment: list-2;
}

.ql-editor ol li.ql-indent-2:before {
  content: counter(list-2, lower-roman) ". ";
}

.ql-editor ol li.ql-indent-2 {
  counter-reset: list-3 list-4 list-5 list-6 list-7 list-8 list-9;
}

.ql-editor ol li.ql-indent-3 {
  counter-increment: list-3;
}

.ql-editor ol li.ql-indent-3:before {
  content: counter(list-3, decimal) ". ";
}

.ql-editor ol li.ql-indent-3 {
  counter-reset: list-4 list-5 list-6 list-7 list-8 list-9;
}

.ql-editor ol li.ql-indent-4 {
  counter-increment: list-4;
}

.ql-editor ol li.ql-indent-4:before {
  content: counter(list-4, lower-alpha) ". ";
}

.ql-editor ol li.ql-indent-4 {
  counter-reset: list-5 list-6 list-7 list-8 list-9;
}

.ql-editor ol li.ql-indent-5 {
  counter-increment: list-5;
}

.ql-editor ol li.ql-indent-5:before {
  content: counter(list-5, lower-roman) ". ";
}

.ql-editor ol li.ql-indent-5 {
  counter-reset: list-6 list-7 list-8 list-9;
}

.ql-editor ol li.ql-indent-6 {
  counter-increment: list-6;
}

.ql-editor ol li.ql-indent-6:before {
  content: counter(list-6, decimal) ". ";
}

.ql-editor ol li.ql-indent-6 {
  counter-reset: list-7 list-8 list-9;
}

.ql-editor ol li.ql-indent-7 {
  counter-increment: list-7;
}

.ql-editor ol li.ql-indent-7:before {
  content: counter(list-7, lower-alpha) ". ";
}

.ql-editor ol li.ql-indent-7 {
  counter-reset: list-8 list-9;
}

.ql-editor ol li.ql-indent-8 {
  counter-increment: list-8;
}

.ql-editor ol li.ql-indent-8:before {
  content: counter(list-8, lower-roman) ". ";
}

.ql-editor ol li.ql-indent-8 {
  counter-reset: list-9;
}

.ql-editor ol li.ql-indent-9 {
  counter-increment: list-9;
}

.ql-editor ol li.ql-indent-9:before {
  content: counter(list-9, decimal) ". ";
}

.ql-editor .ql-indent-1:not(.ql-direction-rtl) {
  padding-left: 3em;
}

.ql-editor li.ql-indent-1:not(.ql-direction-rtl) {
  padding-left: 4.5em;
}

.ql-editor .ql-indent-1.ql-direction-rtl.ql-align-right {
  padding-right: 3em;
}

.ql-editor li.ql-indent-1.ql-direction-rtl.ql-align-right {
  padding-right: 4.5em;
}

.ql-editor .ql-indent-2:not(.ql-direction-rtl) {
  padding-left: 6em;
}

.ql-editor li.ql-indent-2:not(.ql-direction-rtl) {
  padding-left: 7.5em;
}

.ql-editor .ql-indent-2.ql-direction-rtl.ql-align-right {
  padding-right: 6em;
}

.ql-editor li.ql-indent-2.ql-direction-rtl.ql-align-right {
  padding-right: 7.5em;
}

.ql-editor .ql-indent-3:not(.ql-direction-rtl) {
  padding-left: 9em;
}

.ql-editor li.ql-indent-3:not(.ql-direction-rtl) {
  padding-left: 10.5em;
}

.ql-editor .ql-indent-3.ql-direction-rtl.ql-align-right {
  padding-right: 9em;
}

.ql-editor li.ql-indent-3.ql-direction-rtl.ql-align-right {
  padding-right: 10.5em;
}

.ql-editor .ql-indent-4:not(.ql-direction-rtl) {
  padding-left: 12em;
}

.ql-editor li.ql-indent-4:not(.ql-direction-rtl) {
  padding-left: 13.5em;
}

.ql-editor .ql-indent-4.ql-direction-rtl.ql-align-right {
  padding-right: 12em;
}

.ql-editor li.ql-indent-4.ql-direction-rtl.ql-align-right {
  padding-right: 13.5em;
}

.ql-editor .ql-indent-5:not(.ql-direction-rtl) {
  padding-left: 15em;
}

.ql-editor li.ql-indent-5:not(.ql-direction-rtl) {
  padding-left: 16.5em;
}

.ql-editor .ql-indent-5.ql-direction-rtl.ql-align-right {
  padding-right: 15em;
}

.ql-editor li.ql-indent-5.ql-direction-rtl.ql-align-right {
  padding-right: 16.5em;
}

.ql-editor .ql-indent-6:not(.ql-direction-rtl) {
  padding-left: 18em;
}

.ql-editor li.ql-indent-6:not(.ql-direction-rtl) {
  padding-left: 19.5em;
}

.ql-editor .ql-indent-6.ql-direction-rtl.ql-align-right {
  padding-right: 18em;
}

.ql-editor li.ql-indent-6.ql-direction-rtl.ql-align-right {
  padding-right: 19.5em;
}

.ql-editor .ql-indent-7:not(.ql-direction-rtl) {
  padding-left: 21em;
}

.ql-editor li.ql-indent-7:not(.ql-direction-rtl) {
  padding-left: 22.5em;
}

.ql-editor .ql-indent-7.ql-direction-rtl.ql-align-right {
  padding-right: 21em;
}

.ql-editor li.ql-indent-7.ql-direction-rtl.ql-align-right {
  padding-right: 22.5em;
}

.ql-editor .ql-indent-8:not(.ql-direction-rtl) {
  padding-left: 24em;
}

.ql-editor li.ql-indent-8:not(.ql-direction-rtl) {
  padding-left: 25.5em;
}

.ql-editor .ql-indent-8.ql-direction-rtl.ql-align-right {
  padding-right: 24em;
}

.ql-editor li.ql-indent-8.ql-direction-rtl.ql-align-right {
  padding-right: 25.5em;
}

.ql-editor .ql-indent-9:not(.ql-direction-rtl) {
  padding-left: 27em;
}

.ql-editor li.ql-indent-9:not(.ql-direction-rtl) {
  padding-left: 28.5em;
}

.ql-editor .ql-indent-9.ql-direction-rtl.ql-align-right {
  padding-right: 27em;
}

.ql-editor li.ql-indent-9.ql-direction-rtl.ql-align-right {
  padding-right: 28.5em;
}

.ql-editor .ql-video {
  display: block;
  max-width: 100%;
}

.ql-editor .ql-video.ql-align-center {
  margin: 0 auto;
}

.ql-editor .ql-video.ql-align-right {
  margin: 0 0 0 auto;
}

.ql-editor .ql-bg-black {
  background-color: #000;
}

.ql-editor .ql-bg-red {
  background-color: #e60000;
}

.ql-editor .ql-bg-orange {
  background-color: #f90;
}

.ql-editor .ql-bg-yellow {
  background-color: #ff0;
}

.ql-editor .ql-bg-green {
  background-color: #008a00;
}

.ql-editor .ql-bg-blue {
  background-color: #06c;
}

.ql-editor .ql-bg-purple {
  background-color: #93f;
}

.ql-editor .ql-color-white {
  color: #fff;
}

.ql-editor .ql-color-red {
  color: #e60000;
}

.ql-editor .ql-color-orange {
  color: #f90;
}

.ql-editor .ql-color-yellow {
  color: #ff0;
}

.ql-editor .ql-color-green {
  color: #008a00;
}

.ql-editor .ql-color-blue {
  color: #06c;
}

.ql-editor .ql-color-purple {
  color: #93f;
}

.ql-editor .ql-font-serif {
  font-family: Georgia, Times New Roman, serif;
}

.ql-editor .ql-font-monospace {
  font-family: Monaco, Courier New, monospace;
}

.ql-editor .ql-size-small {
  font-size: 0.75em;
}

.ql-editor .ql-size-large {
  font-size: 1.5em;
}

.ql-editor .ql-size-huge {
  font-size: 2.5em;
}

.ql-editor .ql-direction-rtl {
  direction: rtl;
  text-align: inherit;
}

.ql-editor .ql-align-center {
  text-align: center;
}

.ql-editor .ql-align-justify {
  text-align: justify;
}

.ql-editor .ql-align-right {
  text-align: right;
}

.ql-editor.ql-blank::before {
  color: rgba(0, 0, 0, 0.6);
  content: attr(data-placeholder);
  font-style: italic;
  pointer-events: none;
  position: absolute;
}

.ql-snow.ql-toolbar:after,
.ql-snow .ql-toolbar:after {
  clear: both;
  content: "";
  display: table;
}

.ql-snow.ql-toolbar button,
.ql-snow .ql-toolbar button {
  background: none;
  border: none;
  cursor: pointer;
  display: inline-block;
  float: left;
  height: 24px;
  outline: none;
  padding: 3px 5px;
  width: 28px;
}

.ql-snow.ql-toolbar button svg,
.ql-snow .ql-toolbar button svg {
  float: left;
  height: 100%;
}

.ql-snow.ql-toolbar input.ql-image[type=file],
.ql-snow .ql-toolbar input.ql-image[type=file] {
  display: none;
}

.ql-snow.ql-toolbar button:hover,
.ql-snow .ql-toolbar button:hover,
.ql-snow.ql-toolbar button.ql-active,
.ql-snow .ql-toolbar button.ql-active,
.ql-snow.ql-toolbar .ql-picker-label:hover,
.ql-snow .ql-toolbar .ql-picker-label:hover,
.ql-snow.ql-toolbar .ql-picker-label.ql-active,
.ql-snow .ql-toolbar .ql-picker-label.ql-active,
.ql-snow.ql-toolbar .ql-picker-item:hover,
.ql-snow .ql-toolbar .ql-picker-item:hover,
.ql-snow.ql-toolbar .ql-picker-item.ql-selected,
.ql-snow .ql-toolbar .ql-picker-item.ql-selected {
  color: #06c;
}

.ql-snow.ql-toolbar button:hover .ql-fill,
.ql-snow .ql-toolbar button:hover .ql-fill,
.ql-snow.ql-toolbar button.ql-active .ql-fill,
.ql-snow .ql-toolbar button.ql-active .ql-fill,
.ql-snow.ql-toolbar .ql-picker-label:hover .ql-fill,
.ql-snow .ql-toolbar .ql-picker-label:hover .ql-fill,
.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-fill,
.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-fill,
.ql-snow.ql-toolbar .ql-picker-item:hover .ql-fill,
.ql-snow .ql-toolbar .ql-picker-item:hover .ql-fill,
.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-fill,
.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-fill,
.ql-snow.ql-toolbar button:hover .ql-stroke.ql-fill,
.ql-snow .ql-toolbar button:hover .ql-stroke.ql-fill,
.ql-snow.ql-toolbar button.ql-active .ql-stroke.ql-fill,
.ql-snow .ql-toolbar button.ql-active .ql-stroke.ql-fill,
.ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,
.ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,
.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,
.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,
.ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,
.ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,
.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill,
.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill {
  fill: #06c;
}

.ql-snow.ql-toolbar button:hover .ql-stroke,
.ql-snow .ql-toolbar button:hover .ql-stroke,
.ql-snow.ql-toolbar button.ql-active .ql-stroke,
.ql-snow .ql-toolbar button.ql-active .ql-stroke,
.ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke,
.ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke,
.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke,
.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke,
.ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke,
.ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke,
.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke,
.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke,
.ql-snow.ql-toolbar button:hover .ql-stroke-mitter,
.ql-snow .ql-toolbar button:hover .ql-stroke-mitter,
.ql-snow.ql-toolbar button.ql-active .ql-stroke-mitter,
.ql-snow .ql-toolbar button.ql-active .ql-stroke-mitter,
.ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke-mitter,
.ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke-mitter,
.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke-mitter,
.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke-mitter,
.ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke-mitter,
.ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke-mitter,
.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke-mitter,
.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke-mitter {
  stroke: #06c;
}

.ql-snow {
  box-sizing: border-box;
}

.ql-snow * {
  box-sizing: border-box;
}

.ql-snow .ql-hidden {
  display: none;
}

.ql-snow .ql-out-bottom,
.ql-snow .ql-out-top {
  visibility: hidden;
}

.ql-snow .ql-tooltip {
  position: absolute;
}

.ql-snow .ql-tooltip a {
  cursor: pointer;
  text-decoration: none;
}

.ql-snow .ql-formats {
  display: inline-block;
  vertical-align: middle;
}

.ql-snow .ql-formats:after {
  clear: both;
  content: "";
  display: table;
}

.ql-snow .ql-toolbar.snow,
.ql-snow .ql-stroke {
  fill: none;
  stroke: #444;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 2;
}

.ql-snow .ql-stroke-mitter {
  fill: none;
  stroke: #444;
  stroke-mitterlimit: 10;
  stroke-width: 2;
}

.ql-snow .ql-fill,
.ql-snow .ql-stroke.ql-fill {
  fill: #444;
}

.ql-snow .ql-empty {
  fill: none;
}

.ql-snow .ql-even {
  fill-rule: evenodd;
}

.ql-snow .ql-thin,
.ql-snow .ql-stroke.ql-thin {
  stroke-width: 1;
}

.ql-snow .ql-transparent {
  opacity: 0.4;
}

.ql-snow .ql-direction svg:last-child {
  display: none;
}

.ql-snow .ql-direction.ql-active svg:last-child {
  display: inline;
}

.ql-snow .ql-direction.ql-active svg:first-child {
  display: none;
}

.ql-snow .ql-editor h1 {
  font-size: 2em;
}

.ql-snow .ql-editor h2 {
  font-size: 1.5em;
}

.ql-snow .ql-editor h3 {
  font-size: 1.17em;
}

.ql-snow .ql-editor h4 {
  font-size: 1em;
}

.ql-snow .ql-editor h5 {
  font-size: 0.83em;
}

.ql-snow .ql-editor h6 {
  font-size: 0.67em;
}

.ql-snow .ql-editor a {
  text-decoration: underline;
}

.ql-snow .ql-editor blockquote {
  border-left: 4px solid #ccc;
  margin-bottom: 5px;
  margin-top: 5px;
  padding-left: 16px;
}

.ql-snow .ql-editor code,
.ql-snow .ql-editor pre {
  background-color: #f0f0f0;
  border-radius: 3px;
}

.ql-snow .ql-editor pre {
  white-space: pre-wrap;
  margin-bottom: 5px;
  margin-top: 5px;
  padding: 5px 10px;
}

.ql-snow .ql-editor code {
  font-size: 85%;
  padding-bottom: 2px;
  padding-top: 2px;
}

.ql-snow .ql-editor code:before,
.ql-snow .ql-editor code:after {
  content: " ";
  letter-spacing: -2px;
}

.ql-snow .ql-editor pre.ql-syntax {
  background-color: #23241f;
  color: #f8f8f2;
  overflow: visible;
}

.ql-snow .ql-editor img {
  max-width: 100%;
}

.ql-snow .ql-picker {
  color: #444;
  display: inline-block;
  float: left;
  font-size: 14px;
  font-weight: 500;
  height: 24px;
  position: relative;
  vertical-align: middle;
}

.ql-snow .ql-picker-label {
  cursor: pointer;
  display: inline-block;
  height: 100%;
  padding-left: 8px;
  padding-right: 2px;
  position: relative;
  width: 100%;
}

.ql-snow .ql-picker-label::before {
  display: inline-block;
  line-height: 22px;
}

.ql-snow .ql-picker-options {
  background-color: #fff;
  display: none;
  min-width: 100%;
  padding: 4px 8px;
  position: absolute;
  white-space: nowrap;
}

.ql-snow .ql-picker-options .ql-picker-item {
  cursor: pointer;
  display: block;
  padding-bottom: 5px;
  padding-top: 5px;
}

.ql-snow .ql-picker.ql-expanded .ql-picker-label {
  color: #ccc;
  z-index: 2;
}

.ql-snow .ql-picker.ql-expanded .ql-picker-label .ql-fill {
  fill: #ccc;
}

.ql-snow .ql-picker.ql-expanded .ql-picker-label .ql-stroke {
  stroke: #ccc;
}

.ql-snow .ql-picker.ql-expanded .ql-picker-options {
  display: block;
  margin-top: -1px;
  top: 100%;
  z-index: 1;
}

.ql-snow .ql-color-picker,
.ql-snow .ql-icon-picker {
  width: 28px;
}

.ql-snow .ql-color-picker .ql-picker-label,
.ql-snow .ql-icon-picker .ql-picker-label {
  padding: 2px 4px;
}

.ql-snow .ql-color-picker .ql-picker-label svg,
.ql-snow .ql-icon-picker .ql-picker-label svg {
  right: 4px;
}

.ql-snow .ql-icon-picker .ql-picker-options {
  padding: 4px 0px;
}

.ql-snow .ql-icon-picker .ql-picker-item {
  height: 24px;
  width: 24px;
  padding: 2px 4px;
}

.ql-snow .ql-color-picker .ql-picker-options {
  padding: 3px 5px;
  width: 152px;
}

.ql-snow .ql-color-picker .ql-picker-item {
  border: 1px solid transparent;
  float: left;
  height: 16px;
  margin: 2px;
  padding: 0px;
  width: 16px;
}

.ql-snow .ql-color-picker .ql-picker-item.ql-primary-color {
  margin-bottom: toolbarPadding;
}

.ql-snow .ql-picker:not(.ql-color-picker):not(.ql-icon-picker) svg {
  position: absolute;
  margin-top: -9px;
  right: 0;
  top: 50%;
  width: 18px;
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-label]:not([data-label=""])::before,
.ql-snow .ql-picker.ql-font .ql-picker-label[data-label]:not([data-label=""])::before,
.ql-snow .ql-picker.ql-size .ql-picker-label[data-label]:not([data-label=""])::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-label]:not([data-label=""])::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-label]:not([data-label=""])::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-label]:not([data-label=""])::before {
  content: attr(data-label);
}

.ql-snow .ql-picker.ql-header {
  width: 98px;
}

.ql-snow .ql-picker.ql-header .ql-picker-label::before,
.ql-snow .ql-picker.ql-header .ql-picker-item::before {
  content: "Normal";
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
  content: "Heading 1";
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
  content: "Heading 2";
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
  content: "Heading 3";
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
  content: "Heading 4";
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
  content: "Heading 5";
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
  content: "Heading 6";
}

.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
  font-size: 2em;
}

.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
  font-size: 1.5em;
}

.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
  font-size: 1.17em;
}

.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
  font-size: 1em;
}

.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
  font-size: 0.83em;
}

.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
  font-size: 0.67em;
}

.ql-snow .ql-picker.ql-font {
  width: 108px;
}

.ql-snow .ql-picker.ql-font .ql-picker-label::before,
.ql-snow .ql-picker.ql-font .ql-picker-item::before {
  content: "Sans Serif";
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=serif]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {
  content: "Serif";
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=monospace]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {
  content: "Monospace";
}

.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {
  font-family: Georgia, Times New Roman, serif;
}

.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {
  font-family: Monaco, Courier New, monospace;
}

.ql-snow .ql-picker.ql-size {
  width: 98px;
}

.ql-snow .ql-picker.ql-size .ql-picker-label::before,
.ql-snow .ql-picker.ql-size .ql-picker-item::before {
  content: "Normal";
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=small]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {
  content: "Small";
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=large]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {
  content: "Large";
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=huge]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {
  content: "Huge";
}

.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {
  font-size: 10px;
}

.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {
  font-size: 18px;
}

.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {
  font-size: 32px;
}

.ql-snow .ql-color-picker.ql-background .ql-picker-item {
  background-color: #fff;
}

.ql-snow .ql-color-picker.ql-color .ql-picker-item {
  background-color: #000;
}

.ql-toolbar.ql-snow {
  border: 1px solid #ccc;
  box-sizing: border-box;
  font-family: "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  padding: 8px;
}

.ql-toolbar.ql-snow .ql-formats {
  margin-right: 15px;
}

.ql-toolbar.ql-snow .ql-picker-label {
  border: 1px solid transparent;
}

.ql-toolbar.ql-snow .ql-picker-options {
  border: 1px solid transparent;
  box-shadow: rgba(0, 0, 0, 0.2) 0 2px 8px;
}

.ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-label {
  border-color: #ccc;
}

.ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-options {
  border-color: #ccc;
}

.ql-toolbar.ql-snow .ql-color-picker .ql-picker-item.ql-selected,
.ql-toolbar.ql-snow .ql-color-picker .ql-picker-item:hover {
  border-color: #000;
}

.ql-toolbar.ql-snow + .ql-container.ql-snow {
  border-top: 0px;
}

.ql-snow .ql-tooltip {
  background-color: #fff;
  border: 1px solid #ccc;
  box-shadow: 0px 0px 5px #ddd;
  color: #444;
  margin-top: 10px;
  padding: 5px 12px;
  white-space: nowrap;
}

.ql-snow .ql-tooltip::before {
  content: "Visit URL:";
  line-height: 26px;
  margin-right: 8px;
}

.ql-snow .ql-tooltip input[type=text] {
  display: none;
  border: 1px solid #ccc;
  font-size: 13px;
  height: 26px;
  margin: 0px;
  padding: 3px 5px;
  width: 170px;
}

.ql-snow .ql-tooltip a.ql-preview {
  display: inline-block;
  max-width: 200px;
  overflow-x: hidden;
  text-overflow: ellipsis;
  vertical-align: top;
}

.ql-snow .ql-tooltip a.ql-action::after {
  border-right: 1px solid #ccc;
  content: "Edit";
  margin-left: 16px;
  padding-right: 8px;
}

.ql-snow .ql-tooltip a.ql-remove::before {
  content: "Remove";
  margin-left: 8px;
}

.ql-snow .ql-tooltip a {
  line-height: 26px;
}

.ql-snow .ql-tooltip.ql-editing a.ql-preview,
.ql-snow .ql-tooltip.ql-editing a.ql-remove {
  display: none;
}

.ql-snow .ql-tooltip.ql-editing input[type=text] {
  display: inline-block;
}

.ql-snow .ql-tooltip.ql-editing a.ql-action::after {
  border-right: 0px;
  content: "Save";
  padding-right: 0px;
}

.ql-snow .ql-tooltip[data-mode=link]::before {
  content: "Enter link:";
}

.ql-snow .ql-tooltip[data-mode=formula]::before {
  content: "Enter formula:";
}

.ql-snow .ql-tooltip[data-mode=video]::before {
  content: "Enter video:";
}

.ql-snow a {
  color: #06c;
}

.ql-container.ql-snow {
  border: 1px solid #ccc;
}

mele-uploader {
  --uploader-width: 100%;
  --uploader-footer-height: 44px;
  --uploader-footer-bg: var(--input_bg);
  --uploader-body-height: 300px;
  --uploader-file-gap: 10px;
  display: grid;
  width: var(--uploader-width);
  grid-auto-columns: 1fr;
  min-height: var(--uploader-body-height);
  /* Hide file input visually */
  /* Auto mode - hide body */
  /* State-based footer visibility */
  /* Unavailable text sizing */
}
mele-uploader input {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}
mele-uploader[auto] > mele-wrapper > mele-body-wrapper {
  display: none;
}
mele-uploader.mele-view[unavailable] mele-footer-wrapper {
  display: flex;
  background: var(--uploader-footer-bg);
}
mele-uploader.mele-view[readonly] mele-footer-wrapper {
  display: none !important;
}
mele-uploader mele-text[key=unavailable] {
  background-size: calc(var(--uploader-body-height) - 100px) !important;
}

/* Body alignment - centers content when empty or loading */
mele-uploader.mele-uploader > mele-wrapper > mele-body-wrapper > mele-body {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: var(--uploader-file-gap);
  padding: var(--uploader-file-gap);
  align-content: start;
  /* Align to top when items present */
  /* Center when empty or single item */
}
mele-uploader.mele-uploader > mele-wrapper > mele-body-wrapper > mele-body:empty, mele-uploader.mele-uploader > mele-wrapper > mele-body-wrapper > mele-body:has(mele-file:only-child) {
  place-content: center;
}

mele-uploader[rendertype=list] > mele-wrapper > mele-body-wrapper > mele-body {
  display: flex;
  flex-direction: column;
  gap: var(--uploader-file-gap);
  padding: 0;
}
mele-uploader[rendertype=list] > mele-wrapper > mele-body-wrapper > mele-body mele-file {
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  max-width: 100%;
  min-height: 120px;
  margin: 0;
  padding-bottom: 10px;
  border: unset;
  border-bottom: 1px solid var(--input_border);
}
mele-uploader[rendertype=list] > mele-wrapper > mele-body-wrapper > mele-body mele-file mele-file-actions {
  visibility: hidden !important;
  opacity: 0% !important;
}
mele-uploader[rendertype=list] > mele-wrapper > mele-body-wrapper > mele-body mele-file:last-child {
  border-bottom: unset;
}
mele-uploader[rendertype=list] > mele-wrapper > mele-body-wrapper > mele-body mele-file:has(mele-image) {
  flex-direction: row;
}
mele-uploader[rendertype=list] > mele-wrapper > mele-body-wrapper > mele-body mele-file mele-file-info {
  border-top: unset;
}
mele-uploader[rendertype=list] > mele-wrapper > mele-body-wrapper > mele-body mele-file img {
  height: 120px;
  width: unset;
  padding: 0;
}
mele-uploader[rendertype=list] > mele-wrapper > mele-body-wrapper > mele-body mele-file mele-image {
  height: 120px;
  width: 120px;
}

mele-file {
  display: grid;
  /* Define grid areas for predictable ordering */
  grid-template-areas: "preview" "info";
  grid-template-rows: 1fr auto;
  border: 1px solid var(--input_border);
  border-radius: 4px;
  margin: 10px;
  position: relative;
  width: 100%;
  max-width: 400px;
  min-height: 250px;
  /* Consistent minimum height */
  overflow: hidden;
  /* Preview area (img or mele-image) */
  /* Icon sizing for non-image files */
  /* Info section - always at bottom */
  /* Action buttons - absolute positioned */
}
mele-file > img,
mele-file > mele-image {
  grid-area: preview;
  width: 100%;
  height: 250px;
  /* Fixed preview height */
  object-fit: contain;
  padding: 10px;
  background: var(--white);
  cursor: pointer;
  /* Ensure icons and images scale consistently */
  display: flex;
  align-items: center;
  justify-content: center;
}
mele-file > mele-image {
  font-size: 120px;
  /* Consistent icon size */
  color: var(--input_border);
}
mele-file > mele-image > img {
  width: 120px;
  height: 120px;
  object-fit: contain;
}
mele-file mele-file-info {
  grid-area: info;
  display: grid;
  grid-template-areas: "name name" "create size";
  grid-template-columns: 1fr 1fr;
  grid-gap: 5px;
  padding: 8px;
  font-size: 12px;
  background: var(--placeholder-bg);
  border-top: 1px solid var(--input_border);
  user-select: none;
}
mele-file mele-file-name {
  grid-area: name;
  color: var(--blue);
  font-size: 14px;
  font-family: var(--font_bold);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
mele-file mele-file-create {
  grid-area: create;
}
mele-file mele-file-size {
  grid-area: size;
  text-align: right;
}
mele-file mele-file-actions {
  position: absolute;
  right: 8px;
  top: 8px;
  z-index: 10;
  display: flex;
  gap: 4px;
  visibility: hidden;
  opacity: 0;
  transition: visibility 0.15s linear, opacity 0.15s linear;
  background: rgba(255, 255, 255, 0.95);
  padding: 4px;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
mele-file:hover mele-file-actions {
  visibility: visible;
  opacity: 1;
}

.canvas.mele-modal {
  background: rgba(0, 0, 0, 0.9);
}
.canvas.mele-modal .brightness {
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  gap: 8px;
  color: var(--white);
  text-transform: uppercase;
  font-size: 12px;
  font-family: var(--font_bold);
  align-items: flex-end;
}
.canvas.mele-modal .brightness input[type=range] {
  width: 150px;
}
.canvas.mele-modal > mele-wrapper {
  background: transparent;
}
.canvas.mele-modal > mele-wrapper canvas {
  margin: 32px;
  cursor: pointer;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.5);
}

mele-modal[key=pdfpreview] .iframe {
  width: 100%;
  height: 100%;
  border: none;
}

.mele-signature {
  height: 100%;
  width: 100%;
}
.mele-signature .clear {
  position: absolute;
  top: 10px;
  right: 10px;
}

mele-modal[key=":signature"]:not([behavior=phone]) > mele-wrapper {
  min-height: 40%;
  max-height: 40%;
  height: 40%;
}

mele-datetime {
  --dt-height: 320px;
  display: grid;
  width: 100%;
  min-height: var(--dt-height);
  grid-template-rows: 48px 48px 1fr;
  position: relative;
}
mele-datetime * {
  user-select: none;
}
mele-datetime .tabs {
  border-bottom: 1px solid var(--fg1);
}
mele-datetime .nav, mele-datetime .tabs {
  display: grid;
  grid-template-columns: 48px 1fr 48px;
  place-content: center;
}
mele-datetime .nav mele-button, mele-datetime .tabs mele-button {
  height: 32px !important;
  width: 32px !important;
  min-width: 32px !important;
}
mele-datetime .nav mele-text, mele-datetime .tabs mele-text {
  align-items: center;
  justify-content: center;
  display: flex;
}
mele-datetime .nav.names {
  grid-template-columns: 1fr 1fr 1fr;
  text-transform: uppercase;
}
mele-datetime .grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  place-items: center;
}
mele-datetime calendar-item {
  cursor: pointer;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
mele-datetime calendar-item span {
  padding: 8px;
}
mele-datetime calendar-item.gray {
  opacity: 0.3;
  pointer-events: none !important;
}
mele-datetime calendar-item[selected] span, mele-datetime calendar-item .marked span {
  background: var(--blue);
  color: var(--white);
  border-radius: 100%;
}
mele-datetime .list {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  height: calc( var(--dt-height) - 48px - 48px );
  overflow: hidden;
  grid-gap: 15px;
}
mele-datetime .list::before {
  position: absolute;
  content: "";
  background: var(--blue);
  width: 100%;
  height: 30px;
  top: calc( 50% + 10px);
}
mele-datetime .list .column {
  padding: 100px 0;
  z-index: 1;
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  scroll-snap-type: y mandatory;
}
mele-datetime .list .column calendar-item {
  height: 28px;
  scroll-snap-align: center;
}
mele-datetime .list .column calendar-item[selected] span, mele-datetime .list .column calendar-item .marked span {
  background: transparent;
}

mele-datetime[disabled] {
  pointer-events: none;
  opacity: 0.6;
}
mele-datetime[disabled] .nav {
  grid-template-columns: 1fr !important;
}
mele-datetime[disabled] .nav > mele-button {
  display: none !important;
}

/* GENERIC STYLING */
.mele-wftable table {
  min-height: var(--base_height);
}
.mele-wftable table tr:nth-child(odd):not(:hover):not(.selected) {
  background: var(--bg1_alt);
}
.mele-wftable table tr:hover {
  background: var(--bg3_transparent);
}
.mele-wftable table tr.selected {
  background: var(--blue);
  color: var(--white);
}
.mele-wftable table th, .mele-wftable table td {
  font-size: var(--font3);
  padding-left: 10px;
  padding-right: 10px;
  height: var(--base_height_50);
  text-align: center;
  vertical-align: middle;
}
.mele-wftable table th {
  font-family: var(--font_bold);
}
.mele-wftable table td {
  font-family: var(--font_normal);
}

.mele-wftable[click] table td {
  cursor: pointer;
}

.mele-wftable mele-button {
  position: absolute;
  left: 0px;
  top: 0px;
}

.modal-wf-actions > mele-wrapper {
  width: auto !important;
  margin: 4px;
  box-shadow: 0px 0px 6px 2px rgba(128, 128, 128, 0.9);
}
.modal-wf-actions > mele-wrapper > mele-body-wrapper > mele-body {
  align-self: center;
}

mele-printer:not([open]) {
  display: none;
}

mele-printer {
  display: flex;
  height: auto;
  width: 100%;
  background: #607D8B;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0 50px;
}

mele-printer .message {
  color: white;
}

/* GENERIC STYLING */
.mele-pdf {
  cursor: pointer;
}
.mele-pdf .wrapper {
  position: relative;
  width: 100%;
  background: #f5f5f5;
}
.mele-pdf .preview {
  width: 100%;
  height: 100%;
  border: none;
  pointer-events: none;
}

mele-modal[key=pdfpreview] .iframe {
  width: 100%;
  height: 100%;
  border: none;
}

/* GENERIC STYLING */
.mele-attachments {
  display: contents;
}

mele-skmap {
  display: block;
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 240px;
}
mele-skmap .lightbar {
  animation: flash-red-blue 2s ease-in-out infinite;
}
@keyframes flash-red-blue {
  0% {
    stroke: #e74c3c;
  }
  /* red */
  25% {
    stroke: #3498db;
  }
  /* blue */
  50% {
    stroke: #e74c3c;
  }
  /* red */
  75% {
    stroke: #3498db;
  }
  /* blue */
  100% {
    stroke: #e74c3c;
  }
  /* red */
}
mele-skmap .leaflet-container {
  width: 100%;
  height: 100%;
  background: #ddd;
  outline: 0;
}
mele-skmap:not([style*="display: none"]) .leaflet-container {
  visibility: visible;
}
mele-skmap .leaflet-attribution-flag {
  display: none !important;
}

.device-popup {
  font-family: Arial, sans-serif;
  min-width: 250px;
}

.leaflet-popup-close-button {
  display: none !important;
}

.device-popup__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e0e0e0;
}

.device-popup__content {
  line-height: 1.8;
}

.device-popup__row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 4px;
}

.device-popup__description {
  margin-top: 12px;
  padding-top: 8px;
  border-top: 1px solid #e0e0e0;
  font-size: 12px;
}
.device-popup__description font, .device-popup__description font[size] {
  font-size: inherit !important;
}
.device-popup__description table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}
.device-popup__description td {
  padding: 2px 4px;
  vertical-align: top;
}
.device-popup__description div[align=LEFT] {
  text-align: left;
}
.device-popup__description div[align=RIGHT] {
  text-align: right;
}

.fullscreen {
  position: fixed;
  width: 48px;
  height: 48px;
  background: red;
  left: 1rem;
  top: 1rem;
}

.camera-video {
  width: 100%;
  height: 100%;
  background: #000;
  object-fit: cover;
}

.camera-video[data-facing-mode=user] {
  transform: scaleX(-1);
}

.camera-controls-container {
  top: 0;
  right: 0;
  height: 100%;
  display: none;
  background: #000;
  position: absolute;
  flex-direction: column;
  justify-content: flex-end;
}

.camera-controls-container.show {
  display: flex;
}

.camera-controls-container.position-left {
  left: 0;
  right: auto;
}

.camera-controls-container .buttons-wrapper {
  gap: 15px;
  height: 100%;
  display: flex;
  padding: 0 0.5em;
  flex-direction: column;
  justify-content: flex-end;
}

.camera-controls-container .buttons-wrapper .button:nth-last-of-type(2):not(.hide) {
  margin-top: 50px;
}

.camera-controls-container .buttons-wrapper .button:last-of-type:not(.hide) {
  margin-bottom: 30px;
}

.camera-controls-container .buttons-wrapper .button.hide {
  display: none;
}

.slider-wrapper {
  --slider-position: 150px;
  --thumb-size: 64px;
  --track-padding: 5px;
  top: 50%;
  position: absolute;
  will-change: right;
  padding: 30px 0 0 0;
  transform: translateY(-50%);
  transition: right 150ms ease-out;
  right: calc(var(--slider-position) * -1);
  width: calc(var(--thumb-size) + calc(var(--track-padding) * 2));
}

.slider-wrapper.position-left {
  right: auto;
  will-change: left;
  transition: left 150ms ease-out;
  left: calc(var(--slider-position) * -1);
}

.slider-wrapper.position-left.show {
  left: var(--slider-position);
}

.slider-wrapper.show {
  right: var(--slider-position);
}

.slider-wrapper > label[for=slider] {
  top: 0;
  right: 0;
  width: 100%;
  color: white;
  padding: 10px;
  font-size: 0.8em;
  line-height: 0.8em;
  position: absolute;
  text-align: center;
  border-radius: 25px;
  background: rgba(119, 119, 119, 0.7);
}

.slider-wrapper #slider {
  width: 0;
  cursor: grab;
  height: 400px;
  margin: 15px 0;
  direction: rtl;
  appearance: none;
  background: none;
  writing-mode: vertical-lr;
  transform: translateX(35px);
}

.slider-wrapper #slider::-webkit-slider-runnable-track {
  width: 0;
  border-radius: var(--thumb-size);
  background: rgba(119, 119, 119, 0.7);
  padding: var(--track-padding) calc(calc(var(--thumb-size) / 2) + var(--track-padding));
}

.slider-wrapper #slider::-webkit-slider-thumb {
  cursor: grab;
  border-radius: 50%;
  width: var(--thumb-size);
  height: var(--thumb-size);
  background: rgba(0, 0, 0, 0.5);
  margin-left: calc(calc(var(--thumb-size) / 2) * -1);
  -webkit-appearance: none;
  appearance: none;
}

.slider-wrapper #slider.is-dragging::-webkit-slider-thumb {
  background: rgba(0, 0, 0, 0.4);
}

.slider-wrapper #slider:focus {
  outline: none;
}

.region-of-interest-container {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  overflow: hidden;
  position: absolute;
}

.region-of-interest-container .box {
  --amin-time: 150ms;
  --corner-width: 2px;
  overflow: hidden;
  position: absolute;
  background: rgba(255, 255, 255, 0.1);
  will-change: width, height, left, top;
  transition: width var(--amin-time) ease-out, height var(--amin-time) ease-out, left var(--amin-time) ease-out, top var(--amin-time) ease-out;
}

.region-of-interest-container .box.show {
  display: block;
}

.region-of-interest-container .box.detected .corner {
  border-color: #ffd700;
}

.region-of-interest-container .box .corner {
  --corner-size: 50px;
  position: absolute;
  width: var(--corner-size);
  height: var(--corner-size);
  border: var(--corner-width) solid #00ff00;
}

.region-of-interest-container .box .corner.tl, .region-of-interest-container .box .corner.tr {
  top: 0;
}

.region-of-interest-container .box .corner.tr, .region-of-interest-container .box .corner.br {
  right: 0;
}

.region-of-interest-container .box .corner.bl, .region-of-interest-container .box .corner.br {
  bottom: 0;
}

.region-of-interest-container .box .corner.tl, .region-of-interest-container .box .corner.bl {
  left: 0;
}

.region-of-interest-container .box .corner.tl {
  border-width: var(--corner-width) 0 0 var(--corner-width);
}

.region-of-interest-container .box .corner.tr {
  border-width: var(--corner-width) var(--corner-width) 0 0;
}

.region-of-interest-container .box .corner.bl {
  border-width: 0 0 var(--corner-width) var(--corner-width);
}

.region-of-interest-container .box .corner.br {
  border-width: 0 var(--corner-width) var(--corner-width) 0;
}

mele-body:has(.camera-video-element) {
  background: #000;
}

.camera-video-element {
  position: relative;
  display: block;
  background: #000;
  width: 100%;
  height: 100%;
  z-index: 1;
  opacity: 0;
  will-change: opacity;
  transition: opacity 250ms ease-out;
}
.camera-video-element *, .camera-video-element {
  box-sizing: border-box;
  user-select: none;
}
.camera-video-element.show {
  opacity: 1;
}
.camera-video-element .mele-button {
  background: white;
}

[disabled] [disabled] {
  opacity: inherit !important;
}

mele-window.wf[behavior=desktop] > mele-body, mele-modal.wf[behavior=desktop] > mele-body, mele-popup.wf[behavior=desktop] > mele-body {
  background: var(--bg1);
}
mele-window.wf[behavior=desktop] .mele-view[role~=bottom] > mele-wrapper > mele-footer-wrapper > *, mele-modal.wf[behavior=desktop] .mele-view[role~=bottom] > mele-wrapper > mele-footer-wrapper > *, mele-popup.wf[behavior=desktop] .mele-view[role~=bottom] > mele-wrapper > mele-footer-wrapper > * {
  justify-content: center;
}
mele-window.wf[behavior=desktop] .mele-view.wf mele-footer mele-button, mele-modal.wf[behavior=desktop] .mele-view.wf mele-footer mele-button, mele-popup.wf[behavior=desktop] .mele-view.wf mele-footer mele-button {
  width: fit-content;
  min-width: var(--small_width);
}
mele-window.wf .mele-input[key=sort1], mele-modal.wf .mele-input[key=sort1], mele-popup.wf .mele-input[key=sort1] {
  border-top: 1px solid var(--bg3);
  margin-top: var(--base_margin);
  padding-top: calc(var(--base_margin) * 2);
}
mele-window.wf .mele-container[key=history] mele-table[key=logs] > mele-wrapper > mele-body-wrapper > mele-body > mele-row td, mele-modal.wf .mele-container[key=history] mele-table[key=logs] > mele-wrapper > mele-body-wrapper > mele-body > mele-row td, mele-popup.wf .mele-container[key=history] mele-table[key=logs] > mele-wrapper > mele-body-wrapper > mele-body > mele-row td {
  padding: 10px !important;
}
mele-window.wf .mele-container[key=history] mele-table[key=logs] > mele-wrapper > mele-body-wrapper > mele-body > mele-row td:nth-of-type(1), mele-window.wf .mele-container[key=history] mele-table[key=logs] > mele-wrapper > mele-body-wrapper > mele-body > mele-row td:nth-of-type(2), mele-window.wf .mele-container[key=history] mele-table[key=logs] > mele-wrapper > mele-body-wrapper > mele-body > mele-row td:nth-of-type(3), mele-modal.wf .mele-container[key=history] mele-table[key=logs] > mele-wrapper > mele-body-wrapper > mele-body > mele-row td:nth-of-type(1), mele-modal.wf .mele-container[key=history] mele-table[key=logs] > mele-wrapper > mele-body-wrapper > mele-body > mele-row td:nth-of-type(2), mele-modal.wf .mele-container[key=history] mele-table[key=logs] > mele-wrapper > mele-body-wrapper > mele-body > mele-row td:nth-of-type(3), mele-popup.wf .mele-container[key=history] mele-table[key=logs] > mele-wrapper > mele-body-wrapper > mele-body > mele-row td:nth-of-type(1), mele-popup.wf .mele-container[key=history] mele-table[key=logs] > mele-wrapper > mele-body-wrapper > mele-body > mele-row td:nth-of-type(2), mele-popup.wf .mele-container[key=history] mele-table[key=logs] > mele-wrapper > mele-body-wrapper > mele-body > mele-row td:nth-of-type(3) {
  white-space: nowrap;
  vertical-align: top;
}
mele-window.wf logdetails, mele-modal.wf logdetails, mele-popup.wf logdetails {
  display: block;
  margin: 0px;
}
mele-window.wf logdetails *, mele-modal.wf logdetails *, mele-popup.wf logdetails * {
  text-align: left;
  font-size: var(--font3);
}
mele-window.wf logdetails note + changes, mele-modal.wf logdetails note + changes, mele-popup.wf logdetails note + changes {
  margin-top: 8px;
}
mele-window.wf logdetails note, mele-modal.wf logdetails note, mele-popup.wf logdetails note {
  display: block;
  font-family: var(--font_bold);
}
mele-window.wf logdetails changes, mele-modal.wf logdetails changes, mele-popup.wf logdetails changes {
  display: block;
  color: var(--fg2);
}
mele-window.wf logdetails changes change, mele-modal.wf logdetails changes change, mele-popup.wf logdetails changes change {
  display: block;
}
mele-window.wf logdetails changes change f, mele-window.wf logdetails changes change f *, mele-modal.wf logdetails changes change f, mele-modal.wf logdetails changes change f *, mele-popup.wf logdetails changes change f, mele-popup.wf logdetails changes change f * {
  font-family: var(--font_light);
  text-transform: uppercase;
}
mele-window.wf logdetails changes change f:after, mele-modal.wf logdetails changes change f:after, mele-popup.wf logdetails changes change f:after {
  content: ": ";
}
mele-window.wf logdetails changes change v, mele-window.wf logdetails changes change v *, mele-modal.wf logdetails changes change v, mele-modal.wf logdetails changes change v *, mele-popup.wf logdetails changes change v, mele-popup.wf logdetails changes change v * {
  font-family: var(--font_normal);
}
mele-window.wf[vars=print] mele-group, mele-modal.wf[vars=print] mele-group, mele-popup.wf[vars=print] mele-group {
  display: block !important;
}
mele-window.wf[vars=print] mele-group.hr > mele-wrapper, mele-modal.wf[vars=print] mele-group.hr > mele-wrapper, mele-popup.wf[vars=print] mele-group.hr > mele-wrapper {
  border-top: none;
}
mele-window.wf[vars=print] mele-group.hr > mele-wrapper > mele-header-wrapper, mele-modal.wf[vars=print] mele-group.hr > mele-wrapper > mele-header-wrapper, mele-popup.wf[vars=print] mele-group.hr > mele-wrapper > mele-header-wrapper {
  right: unset !important;
  left: unset !important;
  padding: 0;
}
mele-window.wf[vars=print] mele-group > mele-wrapper > mele-body-wrapper > mele-body, mele-modal.wf[vars=print] mele-group > mele-wrapper > mele-body-wrapper > mele-body, mele-popup.wf[vars=print] mele-group > mele-wrapper > mele-body-wrapper > mele-body {
  padding: 0;
}
mele-window.wf[vars=print] mele-group > mele-wrapper > mele-body-wrapper > mele-body > .mele-input > mele-labels > mele-label, mele-modal.wf[vars=print] mele-group > mele-wrapper > mele-body-wrapper > mele-body > .mele-input > mele-labels > mele-label, mele-popup.wf[vars=print] mele-group > mele-wrapper > mele-body-wrapper > mele-body > .mele-input > mele-labels > mele-label {
  font-size: 16px;
  font-weight: bold;
}
mele-window.wf[vars=print] mele-group > mele-wrapper > mele-header-wrapper > mele-header, mele-modal.wf[vars=print] mele-group > mele-wrapper > mele-header-wrapper > mele-header, mele-popup.wf[vars=print] mele-group > mele-wrapper > mele-header-wrapper > mele-header {
  font-size: 22px;
  font-weight: bold;
}
mele-window.wf[vars=print] mele-group[key=history], mele-modal.wf[vars=print] mele-group[key=history], mele-popup.wf[vars=print] mele-group[key=history] {
  display: none !important;
}
mele-window.wf[vars=print] mele-group[key=tab_players], mele-modal.wf[vars=print] mele-group[key=tab_players], mele-popup.wf[vars=print] mele-group[key=tab_players] {
  display: none !important;
}
mele-window.wf[vars=print] > mele-wrapper > mele-body-wrapper > mele-body > mele-tabs > mele-wrapper > mele-tabs-wrapper, mele-modal.wf[vars=print] > mele-wrapper > mele-body-wrapper > mele-body > mele-tabs > mele-wrapper > mele-tabs-wrapper, mele-popup.wf[vars=print] > mele-wrapper > mele-body-wrapper > mele-body > mele-tabs > mele-wrapper > mele-tabs-wrapper {
  display: none;
}
mele-window.wf[vars=print] > mele-wrapper > mele-body-wrapper > mele-body > mele-group > mele-wrapper > mele-body-wrapper > mele-body > mele-tabs > mele-wrapper > mele-tabs-wrapper, mele-modal.wf[vars=print] > mele-wrapper > mele-body-wrapper > mele-body > mele-group > mele-wrapper > mele-body-wrapper > mele-body > mele-tabs > mele-wrapper > mele-tabs-wrapper, mele-popup.wf[vars=print] > mele-wrapper > mele-body-wrapper > mele-body > mele-group > mele-wrapper > mele-body-wrapper > mele-body > mele-tabs > mele-wrapper > mele-tabs-wrapper {
  display: none;
}
mele-window.wf[vars=print] mele-header[key=core_header], mele-modal.wf[vars=print] mele-header[key=core_header], mele-popup.wf[vars=print] mele-header[key=core_header] {
  background: #ff4d4d;
}
mele-window.wf[vars=print] > mele-wrapper > mele-body-wrapper > mele-body, mele-modal.wf[vars=print] > mele-wrapper > mele-body-wrapper > mele-body, mele-popup.wf[vars=print] > mele-wrapper > mele-body-wrapper > mele-body {
  border: 2px solid #000000;
  margin: 15px;
  padding: 0;
  height: max-content;
}
mele-window.wf div[key=workflow], mele-modal.wf div[key=workflow], mele-popup.wf div[key=workflow] {
  width: 100%;
}

@media print {
  body[vars=print], body[vars=print] * {
    page-break-before: always;
    position: relative;
    top: 0;
  }
  body[vars=print] > mele-wrapper > mele-footer-wrapper > mele-footer {
    display: none;
  }

  .wait {
    display: none;
  }
}
div.mele-input {
  display: grid;
  height: 60px;
  width: 100%;
  grid-auto-flow: column;
}

div.mele-group {
  border: 1px solid black;
}

.wfactiongroupbuttons[behavior=desktop] > mele-wrapper {
  padding: 4px;
  margin: 0px 0px 4px calc(-6px - 4px);
  width: calc(var(--small_width) + 2 * 6px);
  min-width: fit-content;
}
.wfactiongroupbuttons[behavior=desktop] > mele-wrapper > mele-body-wrapper > mele-body {
  flex-direction: column;
  align-items: center;
  min-width: fit-content;
}
.wfactiongroupbuttons[behavior=desktop] > mele-wrapper > mele-body-wrapper > mele-body mele-button {
  width: -webkit-fill-available;
  min-width: fit-content;
}

.mele-group.buttongroup {
  flex-basis: fit-content;
  margin-right: var(--base_height);
}
.mele-group.buttongroup > mele-wrapper > mele-body-wrapper > mele-body {
  flex-wrap: nowrap;
}
.mele-group.buttongroup > mele-wrapper > mele-body-wrapper > mele-body mele-button {
  margin-top: 0;
  margin-bottom: 0;
}

[mod=mmodSplash] > mele-body {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding-bottom: 10vw;
  background: var(--black);
  margin: 0px !important;
}
[mod=mmodSplash] > mele-body mele-image[key=logo] {
  display: none;
  position: absolute;
  top: var(--base_margin);
  left: calc(var(--large_margin) + var(--base_margin));
  width: 64px;
  height: 64px;
  z-index: 100;
}
[mod=mmodSplash] > mele-body mele-image[key=applogo] {
  width: 60vw;
  height: 20vw;
}
[mod=mmodSplash] > mele-body mele-image[key=applogo] svg {
  width: initial !important;
  height: initial !important;
}
[mod=mmodSplash] .title {
  font-size: 4vw;
  padding-top: 2%;
}
[mod=mmodSplash] .copyright {
  font-family: var(--font_light);
  position: absolute;
  font-size: var(--font2);
  left: 10px;
  bottom: 10px;
  color: var(--white);
}

[mod=mmodAppBar] > mele-body > mele-image[key=logo]:not([icon]) {
  display: none;
}

[mod=mmodAppBar] > mele-body [key=appbar] > mele-wrapper > mele-body-wrapper > mele-body > .mele-item[status=hidden] {
  display: none !important;
}
[mod=mmodAppBar] > mele-body [key=appbar] > mele-wrapper > mele-body-wrapper > mele-body > .mele-item[status=disabled] {
  opacity: 0.3 !important;
  pointer-events: none;
}

[mod=mmodAppBar] [key=statusbox] {
  user-select: none;
  display: flex;
  flex-direction: column !important;
  width: 120px;
  margin: 0px;
  border-top: none !important;
  background: var(--gray);
  color: var(--white);
  cursor: pointer;
}
[mod=mmodAppBar] [key=statusbox][color=green] {
  background: var(--green);
  color: var(--white);
}
[mod=mmodAppBar] [key=statusbox][color=orange] {
  background: var(--orange);
  color: var(--white);
}
[mod=mmodAppBar] [key=statusbox][color=red] {
  background: var(--red);
  color: var(--white);
}
[mod=mmodAppBar] [key=statusbox][color=blue] {
  background: var(--blue);
  color: var(--white);
}
[mod=mmodAppBar] [key=statusbox] > * {
  display: block;
  text-align: center;
  text-transform: uppercase;
  font-size: var(--font3);
}
[mod=mmodAppBar] [key=statusbox] > *[key=status] {
  font-size: var(--font2);
}
[mod=mmodAppBar] [key=statusbox] [key=datetime] {
  display: none;
}

[mod=mmodAppBar] [key=indicators] {
  width: var(--base_height);
  display: flex;
  flex-wrap: wrap;
  border: none !important;
}
[mod=mmodAppBar] [key=indicators] mele-input {
  width: calc(0.5 * var(--base_height));
  height: calc(0.5 * var(--base_height));
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: none;
}
[mod=mmodAppBar] [key=indicators] mele-input mele-value-content {
  justify-content: center;
}
[mod=mmodAppBar] [key=indicators] mele-input mele-value-content mele-image {
  height: calc(0.8 * var(--base_height_50));
  width: calc(0.8 * var(--base_height_50));
  margin: 0;
  padding: 2px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 0px 5px var(--bg3_shadow);
}
[mod=mmodAppBar] [key=indicators] mele-input mele-value-content mele-image svg > * {
  font-size: 12px !important;
}

[mod=mmodAppBar][behavior=dashboard] {
  box-shadow: 0px 0px 10px 1px rgba(128, 128, 128, 0.5);
}
[mod=mmodAppBar][behavior=dashboard] > mele-body > mele-image[key=logo], [mod=mmodAppBar][behavior=dashboard] > mele-body [view] {
  background: var(--bg2);
}
[mod=mmodAppBar][behavior=dashboard] [key=mmodMarker] {
  position: fixed;
  left: 0;
  padding: 0 !important;
  z-index: 100;
  background-color: var(--bg2);
}
[mod=mmodAppBar][behavior=dashboard] [key=appbar] > mele-wrapper > mele-body-wrapper > mele-body > * {
  min-width: var(--base_height) !important;
  border-top: 3px solid transparent;
  box-sizing: border-box;
}
[mod=mmodAppBar][behavior=dashboard] [key=appbar] > mele-wrapper > mele-body-wrapper > mele-body > *[selected] {
  background: var(--bg3);
  border-top-color: var(--fg3);
}
[mod=mmodAppBar][behavior=dashboard] [key=appbar] > mele-wrapper > mele-body-wrapper > mele-body > *[selected] > mele-labels > mele-label {
  color: var(--fg1);
}
[mod=mmodAppBar][behavior=dashboard] [key=appbar] > mele-wrapper > mele-body-wrapper > mele-body > *[selected] [stroke=fg] {
  stroke: var(--fg1);
}
[mod=mmodAppBar][behavior=dashboard] [key=appbar] > mele-wrapper > mele-body-wrapper > mele-body > *[selected] [fill=fg] {
  fill: var(--fg1);
}
[mod=mmodAppBar][behavior=dashboard] [key=appbar] > mele-wrapper > mele-body-wrapper > mele-body > mele-item[key=separator] {
  min-width: auto !important;
  width: 1px;
  margin: 0;
  padding: 0;
  background: var(--fg2);
}
[mod=mmodAppBar][behavior=dashboard] [key=appbar] > mele-wrapper > mele-body-wrapper > mele-body > mele-item[key=separator] mele-labels {
  display: none !important;
}
[mod=mmodAppBar][behavior=dashboard] [key=appbar] > mele-wrapper > mele-body-wrapper > mele-body > mele-item[key=halfspace] {
  visibility: hidden;
  min-width: calc(var(--base_height) / 2) !important;
}
[mod=mmodAppBar][behavior=dashboard] [key=appbar] > mele-wrapper > mele-body-wrapper > mele-body > mele-item[key=space] {
  visibility: hidden;
}
[mod=mmodAppBar][behavior=dashboard] [key=appbar] > mele-wrapper > mele-body-wrapper > mele-body > mele-item[key=flex] {
  flex: auto;
  visibility: hidden;
  min-width: auto !important;
}
[mod=mmodAppBar][behavior=dashboard] [key=appbar] > mele-wrapper > mele-body-wrapper > mele-body > mele-item mele-icon svg {
  padding-bottom: 10px;
}
[mod=mmodAppBar][behavior=dashboard] [key=appbar] > mele-wrapper > mele-body-wrapper > mele-body > mele-item mele-labels {
  position: absolute;
  left: 0px;
  bottom: 4px;
  right: 0px;
  display: block;
}
[mod=mmodAppBar][behavior=dashboard] [key=appbar] > mele-wrapper > mele-body-wrapper > mele-body > mele-item mele-labels mele-label {
  display: block;
  font-size: 8px;
  text-align: center;
}

@keyframes blink-marking {
  0% {
    background-color: var(--bg2);
  }
  50% {
    background-color: gold;
  }
  100% {
    background-color: var(--bg2);
  }
}
mele-modal[modal=mmodAppBar][behavior=dashboard].buttons > mele-wrapper {
  width: auto !important;
  right: 0px;
  left: initial !important;
  border: none;
  background: var(--bg2);
  box-shadow: 0px 0px 10px 1px rgba(128, 128, 128, 0.5);
  border: none !important;
  margin-bottom: 2px;
}
mele-modal[modal=mmodAppBar][behavior=dashboard].buttons mele-list > mele-wrapper > mele-body-wrapper > mele-body > mele-item {
  min-width: var(--base_height) !important;
  box-sizing: border-box;
}
mele-modal[modal=mmodAppBar][behavior=dashboard].buttons mele-list > mele-wrapper > mele-body-wrapper > mele-body > mele-item mele-icon svg {
  padding-bottom: 10px;
}
mele-modal[modal=mmodAppBar][behavior=dashboard].buttons mele-list > mele-wrapper > mele-body-wrapper > mele-body > mele-item mele-labels {
  position: absolute;
  left: 0px;
  bottom: 4px;
  right: 0px;
  display: block;
}
mele-modal[modal=mmodAppBar][behavior=dashboard].buttons mele-list > mele-wrapper > mele-body-wrapper > mele-body > mele-item mele-labels mele-label {
  display: block;
  font-size: 8px;
  text-align: center;
}

mele-modal[modal=mmodAppBar][behavior=dashboard].list > mele-wrapper {
  width: auto !important;
  right: 0px;
  left: initial !important;
  border: none;
  background: var(--bg1);
  box-shadow: 0px 0px 10px 1px rgba(128, 128, 128, 0.5);
  border: none !important;
  margin-bottom: 2px;
}

[mod=mmodAppBar][behavior=desktop] > mele-body {
  margin: 0px;
  border-right: 1px solid var(--gray);
  flex-direction: column;
}
[mod=mmodAppBar][behavior=desktop] > mele-body > mele-image[key=logo] {
  height: 56px;
  width: 100%;
  background: var(--bg1);
  padding: 4px;
}
[mod=mmodAppBar][behavior=desktop] > mele-body > mele-body [view] {
  background: var(--bg2);
}
[mod=mmodAppBar][behavior=desktop] > mele-body [key=appbar] > mele-wrapper > mele-body-wrapper > mele-body > * {
  min-height: 48px;
  min-width: 48px;
}
[mod=mmodAppBar][behavior=desktop] > mele-body [key=appbar] > mele-wrapper > mele-body-wrapper > mele-body > * [stroke=fg] {
  stroke: var(--fg2) !important;
}
[mod=mmodAppBar][behavior=desktop] > mele-body [key=appbar] > mele-wrapper > mele-body-wrapper > mele-body > * [fill=fg] {
  fill: var(--fg2) !important;
}
[mod=mmodAppBar][behavior=desktop] > mele-body [key=appbar] > mele-wrapper > mele-body-wrapper > mele-body > * > mele-icon > svg {
  width: inherit;
  height: inherit;
  padding: 2px;
}
[mod=mmodAppBar][behavior=desktop] > mele-body [key=appbar] > mele-wrapper > mele-body-wrapper > mele-body > *[selected] {
  background: var(--bg3) !important;
}
[mod=mmodAppBar][behavior=desktop] > mele-body [key=appbar] > mele-wrapper > mele-body-wrapper > mele-body > *[selected] [stroke=fg] {
  stroke: var(--fg1) !important;
}
[mod=mmodAppBar][behavior=desktop] > mele-body [key=appbar] > mele-wrapper > mele-body-wrapper > mele-body > *[selected] [fill=fg] {
  fill: var(--fg1) !important;
}
[mod=mmodAppBar][behavior=desktop] > mele-body [key=appbar] > mele-wrapper > mele-body-wrapper > mele-body > mele-item[key] {
  flex-direction: column;
  padding: var(--base_margin) !important;
}
[mod=mmodAppBar][behavior=desktop] > mele-body [key=appbar] > mele-wrapper > mele-body-wrapper > mele-body > mele-item[key] mele-labels {
  padding: 0px;
  padding-bottom: 4px;
}
[mod=mmodAppBar][behavior=desktop] > mele-body [key=appbar] > mele-wrapper > mele-body-wrapper > mele-body > mele-item[key] mele-labels mele-label {
  color: var(--fg1) !important;
  text-align: left;
  font-size: 9px;
  line-height: 9px;
  text-transform: none;
  font-family: var(--font_light);
}
[mod=mmodAppBar][behavior=desktop] > mele-body [key=appbar] > mele-wrapper > mele-body-wrapper > mele-body > mele-item:not([key]) {
  min-height: 0px;
  height: 0px;
  border-top: 1px solid var(--gray);
  margin: 0px !important;
  padding: 0px !important;
  overflow: hidden !important;
}
[mod=mmodAppBar][behavior=desktop] > mele-body [key=appbar] > mele-wrapper > mele-footer-wrapper {
  display: none;
}
[mod=mmodAppBar][behavior=desktop] > mele-body mele-button[type=appstatus] {
  display: none;
}

[mod=mmodAppBar][behavior=desktop][width="160"] > mele-body [key=appbar] > mele-wrapper > mele-body-wrapper > mele-body {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
[mod=mmodAppBar][behavior=desktop][width="160"] > mele-body [key=appbar] > mele-wrapper > mele-body-wrapper > mele-body > .mele-item {
  flex-basis: 50% !important;
}
[mod=mmodAppBar][behavior=desktop][width="160"] > mele-body [key=appbar] > mele-wrapper > mele-body-wrapper > mele-body > .mele-item:not([key]) {
  flex-basis: 100% !important;
  height: auto;
  color: var(--white);
  background: var(--bg3);
}
[mod=mmodAppBar][behavior=desktop][width="160"] > mele-body [key=appbar] > mele-wrapper > mele-body-wrapper > mele-body > .mele-item:not([key]) mele-labels {
  align-items: center;
}
[mod=mmodAppBar][behavior=desktop][width="160"] > mele-body [key=appbar] > mele-wrapper > mele-body-wrapper > mele-body > .mele-item:not([key]) mele-labels mele-label {
  font-size: var(--font3);
}

[modal=mmodAppBar] mele-item[disabled] {
  opacity: 0.3;
  pointer-events: none;
}
[modal=mmodAppBar] mele-item:not([key]) {
  display: none;
}
[modal=mmodAppBar] mele-item[key=bout] {
  display: none;
}
[modal=mmodAppBar] mele-item[key=logout], [modal=mmodAppBar] mele-item[key=changepwd], [modal=mmodAppBar] mele-item[key=system], [modal=mmodAppBar] mele-item[key=printer_test] {
  background: var(--bg3);
  box-shadow: 0px 4px 10px 1px rgba(128, 128, 128, 0.5);
}
[modal=mmodAppBar] mele-input[key=language] mele-list mele-body {
  justify-content: space-evenly !important;
  margin-right: calc(2 * var(--base_margin));
}
[modal=mmodAppBar] mele-input[key=language] mele-list mele-body mele-item {
  flex: 1;
  min-width: calc(var(--base_height) * 0.7) !important;
  min-height: calc(var(--base_height) - 2 * var(--base_margin)) !important;
  margin: var(--base_margin) 0px;
  border-radius: var(--base_margin) !important;
}

.moduleNotification::after {
  height: 10px;
  width: 10px;
  border-radius: 50%;
  content: "";
  display: block;
  position: absolute;
  right: 3px;
  top: 3px;
  z-index: 1000;
}

[priority="1"]::after {
  background: var(--orange);
}

[priority="2"]::after {
  background: var(--magenta);
}

[priority="3"]::after {
  background: var(--red);
}

[mod=mmodAppWall] {
  background: none;
}
[mod=mmodAppWall] > mele-button[key=viewback] {
  right: 216px;
  left: auto;
}
[mod=mmodAppWall] > mele-body {
  flex-direction: row-reverse;
  background: var(--gray_transparent);
}
[mod=mmodAppWall] > mele-body > [view] {
  min-width: 280px;
  max-width: 280px;
}
[mod=mmodAppWall] > mele-body > mele-list > mele-wrapper > mele-header-wrapper > [key=core_header] {
  flex-direction: row-reverse;
}
[mod=mmodAppWall] > mele-body > mele-list > mele-wrapper > mele-header-wrapper > [key=core_header] mele-header-text {
  display: flex;
  align-items: baseline;
}
[mod=mmodAppWall] > mele-body > mele-list > mele-wrapper > mele-header-wrapper > [key=core_header] mele-header-text mele-image {
  padding: 0px;
  width: 32px;
  height: 32px;
}
[mod=mmodAppWall] > mele-body > mele-list > mele-wrapper > mele-header-wrapper > [key=core_header] mele-header-text mele-image [fill=fg] {
  fill: red;
}
[mod=mmodAppWall] > mele-body > mele-list > mele-wrapper > mele-header-wrapper > [key=core_header] mele-header-text span {
  font-size: 32px;
}
[mod=mmodAppWall] > mele-body > mele-list > mele-wrapper > mele-header-wrapper > [key=status] {
  padding: 0px;
}
[mod=mmodAppWall] > mele-body > mele-list > mele-wrapper > mele-header-wrapper > [key=status] > mele-value {
  padding: 0px;
}
[mod=mmodAppWall] > mele-body > mele-list > mele-wrapper > mele-header-wrapper > [key=status] > mele-value > mele-value-wrapper {
  border: none !important;
}
[mod=mmodAppWall] > mele-body > mele-list > mele-wrapper > mele-header-wrapper > [key=status] mele-icon {
  display: none;
}
[mod=mmodAppWall] > mele-body > mele-list > mele-wrapper > mele-header-wrapper > [key=status] > mele-labels {
  display: none !important;
}
[mod=mmodAppWall] > mele-body > mele-list > mele-wrapper > mele-header-wrapper > [key=status] .mele-dropdown {
  background: none !important;
  border: none !important;
}
[mod=mmodAppWall] > mele-body > mele-list > mele-wrapper > mele-body-wrapper > mele-body > mele-item mele-icon svg {
  padding-bottom: 10px;
}
[mod=mmodAppWall] > mele-body > mele-list > mele-wrapper > mele-body-wrapper > mele-body > mele-item mele-labels {
  position: absolute;
  left: 0px;
  bottom: 4px;
  right: 0px;
  display: block;
}
[mod=mmodAppWall] > mele-body > mele-list > mele-wrapper > mele-body-wrapper > mele-body > mele-item mele-labels mele-label {
  display: block;
  font-size: 8px;
  text-align: center;
}
[mod=mmodAppWall] > mele-body [key=behavior] mele-body {
  justify-content: center !important;
}
[mod=mmodAppWall] > mele-body [key=behavior] mele-item {
  min-width: 24px !important;
  padding: 4px 8px !important;
}
[mod=mmodAppWall] > mele-body [key=behavior] mele-item > mele-icon {
  width: 24px !important;
  height: 24px !important;
}
[mod=mmodAppWall] > mele-body [key=behavior] mele-item > mele-icon svg {
  width: 24px !important;
  height: 24px !important;
}
[mod=mmodAppWall][behavior=phone] [key=behavior] {
  display: none !important;
}
[mod=mmodAppWall] mele-item[key=mmodModeAdmin] {
  background: var(--bginvalid);
}

body[mode=admin] [mod=mmodAppWall] [key=appwall] > mele-wrapper > mele-body-wrapper > mele-body > mele-item:not([key=mmodModeUser]) {
  background: var(--bginvalid);
}

[mod=mmodAppWall] > mele-body [key=appwall] > mele-wrapper > mele-body-wrapper > mele-body > .mele-item[status=hidden] {
  display: none !important;
}
[mod=mmodAppWall] > mele-body [key=appwall] > mele-wrapper > mele-body-wrapper > mele-body > .mele-item[status=disabled] {
  opacity: 0.3 !important;
  pointer-events: none;
}

[mod=mmodAppLogo][behavior=tablet] mele-button[key=applogo][class*=color-], [mod=mmodAppLogo][behavior=phone] mele-button[key=applogo][class*=color-] {
  border-left-width: 4px;
}

[mod=mmodAppLogo] {
  background: none !important;
}
[mod=mmodAppLogo] > mele-body > mele-view {
  background: none !important;
}
[mod=mmodAppLogo] > mele-body > mele-view mele-button[key=applogo] {
  position: absolute;
  top: 0px;
  right: 0px;
  z-index: 300;
}
[mod=mmodAppLogo] [key=badge] {
  position: absolute;
  top: 1px;
  left: 8px;
  max-width: 64px;
  height: 17px;
  overflow: hidden;
  z-index: 200;
  text-align: right;
  margin: 0px;
  border: 1px inset var(--fg3);
  font-size: 12px;
  display: inline-block;
  border-radius: 50%;
  padding: 0px 4px;
}
[mod=mmodAppLogo] [key=badge]:not([label]), [mod=mmodAppLogo] [key=badge][label="0"] {
  display: none;
}
[mod=mmodAppLogo] [key=indicators] {
  position: absolute;
  top: 47px;
  right: 0px;
  width: 60px;
  height: 16px;
  overflow: hidden;
  z-index: 100;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
}
[mod=mmodAppLogo] [key=indicators] mele-input {
  min-height: 20px;
  height: 20px;
  min-width: 20px;
  width: 20px;
  padding: 0px;
  margin: 0px;
}
[mod=mmodAppLogo] [key=indicators] mele-input[value="1"] [fill] {
  fill: var(--fg1);
}
[mod=mmodAppLogo] [key=indicators] mele-input[value="1"] [stroke] {
  stroke: var(--fg1);
}
[mod=mmodAppLogo] [key=indicators] mele-input[value="0"] [fill] {
  fill: var(--fg3);
}
[mod=mmodAppLogo] [key=indicators] mele-input[value="0"] [stroke] {
  stroke: var(--fg3);
}
[mod=mmodAppLogo] [key=indicators] mele-input mele-input-labels {
  display: none;
}
[mod=mmodAppLogo] [key=indicators] mele-input mele-image {
  margin: 0px !important;
}
[mod=mmodAppLogo] [key=indicators] mele-input mele-image svg {
  box-sizing: border-box;
  padding: 0px !important;
  width: 14px !important;
  height: 14px !important;
}

[mod=mmodAppLogo][behavior=desktop] {
  display: none;
}

[mod=mmodQuickBar] .quickbar-banner {
  font-size: 20px;
  font-family: var(--font_bold);
  color: var(--fg1);
  padding-left: 16px;
}
[mod=mmodQuickBar] .quickbar-banner > span {
  color: #f9012f;
}
[mod=mmodQuickBar] > mele-body {
  margin: 0px !important;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
[mod=mmodQuickBar] > mele-body > div {
  width: 100%;
  background: var(--bg3);
  display: flex;
  align-items: center;
  justify-content: space-between;
}
[mod=mmodQuickBar] > mele-body > div > div {
  display: flex;
  align-items: center;
}
[mod=mmodQuickBar] > mele-body > div > div > .mele-input {
  flex-basis: initial;
}
[mod=mmodQuickBar] > mele-body > div > div.right {
  padding: 0px 8px;
}
[mod=mmodQuickBar] > mele-body mele-input[key=language] mele-item {
  padding: 0px 1em !important;
}
[mod=mmodQuickBar] > mele-body mele-input[key=status] {
  min-width: 170px;
}
[mod=mmodQuickBar] > mele-body mele-input[key=callsign] {
  min-width: 128px !important;
}
[mod=mmodQuickBar] > mele-body mele-input[type=string] mele-value {
  padding: 0px 0px 0px;
}
[mod=mmodQuickBar] > mele-body mele-button {
  margin: 0px;
  padding-right: 16px;
}
[mod=mmodQuickBar] > mele-body mele-text[key=server_url] {
  position: absolute;
  right: 21px;
  top: 29px;
  font-size: 9.5px;
  background: none;
  color: gray;
}
[mod=mmodQuickBar] > mele-body mele-button[key=user_id] {
  min-width: 160px;
}

[modal=mmodQuickBar][key=user_modal] mele-button {
  width: 100%;
}

[mod=mmodNotifications] {
  pointer-events: none;
  background: transparent !important;
}
[mod=mmodNotifications] > mele-body {
  bottom: initial;
}
[mod=mmodNotifications] mele-notifications > mele-wrapper > mele-body-wrapper > mele-body {
  pointer-events: all;
}
[mod=mmodNotifications] mele-notifications > mele-wrapper > mele-footer-wrapper > mele-footer {
  pointer-events: all;
}

/* GENERIC STYLING */
[mod=mmodNotifications][behavior=desktop] > mele-body, [mod=mmodNotifications][behavior=dashboard] > mele-body {
  margin: 0px 67px !important;
}
[mod=mmodNotifications][behavior=desktop] > mele-body > mele-notifications > mele-wrapper > mele-body-wrapper, [mod=mmodNotifications][behavior=dashboard] > mele-body > mele-notifications > mele-wrapper > mele-body-wrapper {
  border-radius: 0px 0px 10px 10px;
}
[mod=mmodNotifications][behavior=desktop] > mele-body mele-notif > mele-icon, [mod=mmodNotifications][behavior=dashboard] > mele-body mele-notif > mele-icon {
  width: var(--small_height) !important;
  height: var(--small_height) !important;
}

[mod=mmodNotifications] {
  /****************************** SERVER CONNECTION LINE ******************************/
  /****************************** SERVER DISCONNECTION NOTICE ******************************/
}
[mod=mmodNotifications].disconnected[views=DASHBOARD] [key=disconnected_line] {
  top: 0;
}
[mod=mmodNotifications].disconnected [key=disconnected_line] {
  position: fixed;
  z-index: 99999999999;
  top: 0px;
  left: 0;
  right: 0;
  height: 4px;
  width: 100%;
  background: var(--gray);
}
[mod=mmodNotifications].disconnected [key=disconnected_line]:before {
  display: block;
  position: fixed;
  content: "";
  left: -200px;
  width: 200px;
  height: 4px;
  background-color: var(--red);
  animation: disconected 1.5s linear infinite;
}
@keyframes disconected {
  0% {
    left: -200px;
    width: 200px;
  }
  100% {
    left: 100%;
    width: 200px;
  }
}
[mod=mmodNotifications]:not(.disconnected)[views=DASHBOARD] [key=disconnected_line] {
  top: 0;
}
[mod=mmodNotifications]:not(.disconnected) [key=disconnected_line] {
  position: absolute;
  z-index: 99999999999;
  top: 0px;
  left: -100%;
  height: 4px;
  width: 100%;
  background: var(--green);
  animation: conected 1s ease-in-out forwards;
}
@keyframes conected {
  0% {
    left: -100%;
    height: 4px;
  }
  70% {
    left: 0;
    height: 4px;
  }
  100% {
    left: 0;
    height: 0px;
    visibility: hidden;
  }
}
[mod=mmodNotifications].disconnected_notice [key=disconnected_notice] {
  position: fixed;
  z-index: 99999999;
  top: 4px;
  width: 100vw;
  height: var(--base_height);
  left: 0;
  right: 0;
  background: var(--red);
  color: var(--white);
  font-size: var(--font1);
  display: flex;
  justify-content: center;
  align-items: center;
}
[mod=mmodNotifications]:not(.disconnected_notice) [key=disconnected_notice] {
  display: none;
}

body.nowebkitdirectory mele-button[key=import_folder] {
  display: none !important;
}

[mod=mmodOfficeImport] {
  background: none !important;
  pointer-events: none !important;
}
[mod=mmodOfficeImport] .dropzone {
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #888;
  transition: opacity 0.2s ease;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 6px dashed #444;
  box-sizing: border-box;
  color: #444;
  font-size: 6vw;
  pointer-events: none;
}
[mod=mmodOfficeImport] .dropzone.dragover {
  opacity: 1;
  pointer-events: all;
}

/* IMPORT */
mele-modal[key=mmodOfficeImport] > mele-wrapper {
  max-height: unset !important;
}

mele-modal[key=mmodOfficeImport] > mele-wrapper > mele-body-wrapper {
  margin: 1em;
}

mele-modal[key=mmodOfficeImport] > mele-wrapper > mele-body-wrapper > mele-body {
  overflow: hidden;
}

mele-modal[key=mmodOfficeImport] mele-input {
  border: none !important;
}

mele-modal[key=mmodOfficeImport] mele-input mele-labels {
  text-transform: unset;
  padding: 0;
}

mele-modal[key=mmodOfficeImport] mele-input[key=progress] > mele-value > mele-value-wrapper > mele-value-content {
  width: 100%;
}

mele-modal[key=mmodOfficeImport] [key="string_value:progress"] {
  position: relative;
  margin-bottom: 10px;
  text-align: center;
  width: 100%;
}

mele-modal[key=mmodOfficeImport] [key="string_value:progress"]::after {
  content: "";
  position: absolute;
  height: 5px;
  background: var(--blue);
  bottom: -10px;
  left: 0px;
  width: var(--progress);
  transition: all 0.3s linear;
}

mele-modal[key=mmodOfficeImport] [key=log] {
  font-size: var(--font3);
  width: 100%;
  height: 60vh;
  overflow-x: hidden;
  overflow-y: scroll;
  border: 1px solid var(--gray);
  padding: 1em;
  box-sizing: border-box;
}

mele-modal[key=mmodOfficeImport] [key=log]::-webkit-scrollbar {
  width: calc(0.2em + 1px) !important;
}

mele-modal[key=mmodOfficeImport] [key=log] info {
  display: block;
  text-align: center;
  font-family: var(--font_bold);
  font-size: var(--font1);
  color: var(--blue);
}

mele-modal[key=mmodOfficeImport] [key=log] abort {
  display: block;
  text-align: center;
  font-family: var(--font_bold);
  font-size: var(--font1);
  color: var(--red);
}

mele-modal[key=mmodOfficeImport] [key=log] success {
  display: block;
  text-align: center;
  font-family: var(--font_bold);
  font-size: var(--font1);
  color: var(--green);
}

mele-modal[key=mmodOfficeImport] [key=log] header {
  display: block;
  padding-top: 1em;
}

mele-modal[key=mmodOfficeImport] [key=log] ok {
  display: block;
  padding-left: 1em;
  color: var(--green);
}

mele-modal[key=mmodOfficeImport] [key=log] warn {
  display: block;
  padding-left: 1em;
  color: var(--orange);
}

mele-modal[key=mmodOfficeImport] [key=log] err {
  display: block;
  padding-left: 1em;
  color: var(--red);
}

mele-modal[key=mmodOfficeImport] [key=log] sum {
  display: block;
  padding-left: 1em;
  padding-bottom: 1em;
}

[mod=mmodEnroll] > mele-body [view] {
  background: var(--red);
  color: var(--white);
}
[mod=mmodEnroll] > mele-body [view] .mele-item,
[mod=mmodEnroll] > mele-body [view] .mele-item mele-labels {
  color: var(--white);
}
[mod=mmodEnroll] > mele-body [view] mele-header {
  background: linear-gradient(to bottom, var(--red) 10%, #951d27 100%) !important;
}
[mod=mmodEnroll] > mele-body [view] mele-text {
  margin: 32px;
}
[mod=mmodEnroll] > mele-body [view] > mele-wrapper > mele-body-wrapper {
  padding: 50px;
}

[mod=mmodEnroll] > mele-body > mele-image[key=logo] {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 64px;
  height: 64px;
  z-index: 100;
}

[mod=mmodLogin]:not([behavior=phone]) > mele-body {
  justify-content: center !important;
  align-items: center !important;
}
[mod=mmodLogin]:not([behavior=phone]) > mele-body > mele-view {
  flex: initial !important;
  width: initial !important;
  border-radius: 6px;
  box-shadow: 0px 0px 50px 10px var(--bg3_shadow);
}
[mod=mmodLogin]:not([behavior=phone]) > mele-body > mele-view > mele-wrapper > mele-body-wrapper {
  align-items: center;
  padding: 64px;
}

[mod=mmodLogin][behavior=phone] > mele-body > mele-view > mele-wrapper > mele-body-wrapper {
  align-items: center !important;
}

[mod=mmodLogin] > mele-body > mele-view {
  min-width: 320px;
}
[mod=mmodLogin] > mele-body > mele-view mele-text[key=error] {
  color: var(--fginvalid);
  margin-top: 8px;
}

[mod=mmodLogin] > mele-body {
  flex-direction: column;
}
[mod=mmodLogin] > mele-body > mele-image[key=logo] {
  position: absolute;
  top: 0px;
  left: var(--large_margin);
  width: 64px;
  height: 64px;
}
[mod=mmodLogin] > mele-body > div[key=appinfo] {
  position: absolute;
  bottom: 0px;
  right: 0px;
  padding: 4px;
  font-size: var(--font3);
  color: var(--gray);
}

mele-modal[modal=mmodLogin][key=":modal"] {
  backdrop-filter: blur(20px);
}

[mod=mmodOfficeWfDashboard] .vertical-header {
  border-bottom: 1px solid #d5d5d5;
}
[mod=mmodOfficeWfDashboard] .vertical-header > mele-wrapper {
  flex-direction: row;
}
[mod=mmodOfficeWfDashboard] .vertical-header > mele-wrapper > mele-header-wrapper {
  writing-mode: tb-rl;
  transform: rotate(-180deg);
  display: flex;
  align-items: center;
  background: #d5d5d5;
  padding: 7px;
}
[mod=mmodOfficeWfDashboard] .vertical-header > mele-wrapper > mele-body-wrapper {
  flex: 1 !important;
}
[mod=mmodOfficeWfDashboard] .vertical-header > mele-wrapper > mele-body-wrapper > mele-body {
  justify-content: space-evenly;
}
[mod=mmodOfficeWfDashboard] .vertical-header > mele-wrapper > mele-body-wrapper > mele-body > canvas {
  padding: 40px;
}

[mod=mmodOfficeConnections] .mele-table mele-header[key=columns] th {
  justify-content: flex-start;
  padding-left: 4px;
}
[mod=mmodOfficeConnections] .mele-table mele-row:first-of-type td {
  border-top: 2px solid var(--gray);
}
[mod=mmodOfficeConnections] .mele-table mele-row:not([enabled="1"]) td {
  color: var(--gray);
}
[mod=mmodOfficeConnections] .mele-table mele-row[alternate="1"]:not([selected]) {
  background: var(--bg2);
}
[mod=mmodOfficeConnections] .mele-table mele-row:not([alternate="1"]):not([selected]) {
  background: var(--bg1);
}
[mod=mmodOfficeConnections] .mele-table mele-row td {
  height: auto;
  box-sizing: border-box;
  padding: 2px 4px;
  font-family: var(--font_light);
  font-size: var(--font2);
  text-align: left;
}
[mod=mmodOfficeConnections] .mele-table mele-row td online:after {
  content: "●";
  top: -3px;
  position: relative;
  color: var(--green);
  vertical-align: text-bottom;
  font-size: 24px;
  line-height: 10px;
}
[mod=mmodOfficeConnections] .mele-table mele-row td offline:after {
  content: "○";
  top: -3px;
  position: relative;
  color: rgba(153, 153, 153, 0.5);
  vertical-align: text-bottom;
  font-size: 24px;
  line-height: 10px;
}
[mod=mmodOfficeConnections] [key=patrols] .mele-table mele-row td:first-of-type {
  font-family: var(--font_bold);
}

@media print {
  [mod=mmodOfficeConnections] mele-tabs mele-item:not([selected]) {
    display: none;
  }
  [mod=mmodOfficeConnections] mele-tabs mele-footer-wrapper {
    display: none;
  }
  [mod=mmodOfficeConnections] .mele-table mele-header th {
    font-size: 10px;
  }
  [mod=mmodOfficeConnections] .mele-table mele-row:not([enabled="1"]) td {
    color: var(--gray) !important;
  }
  [mod=mmodOfficeConnections] .mele-table mele-row[groupstart="1"] td {
    padding-top: 0px;
  }
  [mod=mmodOfficeConnections] .mele-table mele-row[groupend="1"] td {
    padding-bottom: 0px;
  }
  [mod=mmodOfficeConnections] .mele-table mele-row:not([groupstart="1"]) td:first-of-type {
    color: transparent !important;
  }
  [mod=mmodOfficeConnections] .mele-table mele-row td {
    padding: 0px 4px;
    font-family: var(--font_light);
    font-size: 10px;
  }
  [mod=mmodOfficeConnections] .mele-table mele-row td offline:after {
    color: rgba(153, 153, 153, 0.3) !important;
  }
}
[mod=mmodOfficeAdmin] .mele-group[key=tab_db] .group-body {
  flex-direction: column;
  align-items: center;
  align-content: center;
}
[mod=mmodOfficeAdmin] [key=raw] {
  white-space: pre-wrap;
}

[mod=mmodUnits] mele-input[key=status] mele-value mele-value-content {
  display: flex;
}
[mod=mmodUnits] mele-input[key=status] mele-value mele-value-content span {
  padding: 0px 8px;
  border-radius: 6px;
  background: var(--gray);
  color: var(--white);
}
[mod=mmodUnits] mele-input[key=status][value^=g] mele-value span {
  background: var(--green);
}
[mod=mmodUnits] mele-input[key=status][value^=o] mele-value span {
  background: var(--orange);
}
[mod=mmodUnits] mele-input[key=status][value^=r] mele-value span {
  background: var(--red);
}
[mod=mmodUnits] mele-map > mele-wrapper > mele-body-wrapper {
  height: 350px !important;
}
[mod=mmodUnits] mele-input[key=app_apptype] {
  position: absolute;
  right: 20px;
  width: 60px;
  padding: 2px;
}
[mod=mmodUnits] [view][key=detail] .mele-button[iconleft] mele-icon.left {
  padding-left: 3px;
}
[mod=mmodUnits] .streaming_button {
  background: var(--blue);
  color: var(--white);
}

/* GENERIC STYLING */
[mod=mmodChats] .mele-view[key=log] > mele-wrapper > mele-body-wrapper > mele-body {
  flex-wrap: nowrap;
  flex-direction: column;
}
[mod=mmodChats] .mele-view[key=log] > mele-wrapper > mele-body-wrapper > mele-body [key=send] {
  display: grid;
  grid-template-columns: auto 64px;
  column-gap: 0.5rem;
  width: 100%;
  --input-padding: 0;
  --button-margin: 0;
}
[mod=mmodChats] .mele-view[key=log] > mele-wrapper > mele-body-wrapper > mele-body [key=send] > mele-button {
  width: 64px !important;
  height: 100% !important;
}
[mod=mmodChats] .mele-view[key=log] > mele-wrapper > mele-body-wrapper > mele-body [key=send] > mele-button mele-label {
  writing-mode: tb;
}
[mod=mmodChats] .mele-view[key=log] > mele-wrapper > mele-body-wrapper > mele-body [key=send] > div {
  display: grid;
  grid-template-columns: 64px 1fr;
}
[mod=mmodChats] .mele-view[key=log] > mele-wrapper > mele-body-wrapper > mele-body [key=send] > div > [type=files] {
  --input-border: none;
  --input-min-w: 0;
}
[mod=mmodChats] .mele-view[key=log] > mele-wrapper > mele-body-wrapper > mele-body [key=send] > div > [type=files] mele-uploader {
  height: 100% !important;
}
[mod=mmodChats] .mele-view[key=log] > mele-wrapper > mele-body-wrapper > mele-body [key=send] > div > [type=files] mele-uploader mele-footer, [mod=mmodChats] .mele-view[key=log] > mele-wrapper > mele-body-wrapper > mele-body [key=send] > div > [type=files] mele-uploader mele-footer-wrapper, [mod=mmodChats] .mele-view[key=log] > mele-wrapper > mele-body-wrapper > mele-body [key=send] > div > [type=files] mele-uploader mele-button {
  height: 100% !important;
  margin: 0 !important;
}
[mod=mmodChats] .mele-view[key=log] > mele-wrapper > mele-body-wrapper > mele-body mele-list[key=logs] {
  height: 100%;
}
[mod=mmodChats] .mele-view[key=log] > mele-wrapper > mele-body-wrapper > mele-body mele-list[key=logs] > mele-wrapper > mele-body-wrapper mele-body {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
}
[mod=mmodChats] .mele-view[key=log] > mele-wrapper > mele-body-wrapper > mele-body mele-list[key=logs] > mele-wrapper > mele-body-wrapper mele-body .mele-item {
  flex-direction: column;
  text-align: left;
}
[mod=mmodChats] .mele-view[key=log] > mele-wrapper > mele-body-wrapper > mele-body mele-list[key=logs] > mele-wrapper > mele-body-wrapper mele-body .mele-item.hidden {
  display: none;
}
[mod=mmodChats] .mele-view[key=log] > mele-wrapper > mele-body-wrapper > mele-body mele-list[key=logs] > mele-wrapper > mele-body-wrapper mele-body .mele-item.status {
  grid-column: 4;
  align-items: flex-end;
  min-height: 10px;
  height: 10px;
  opacity: 0.3;
  margin-top: 0px !important;
}
[mod=mmodChats] .mele-view[key=log] > mele-wrapper > mele-body-wrapper > mele-body mele-list[key=logs] > mele-wrapper > mele-body-wrapper mele-body .mele-item.outgoing {
  grid-column: 2/-1;
  align-items: flex-end;
  padding-right: calc( var(--base_height) + 10px);
}
[mod=mmodChats] .mele-view[key=log] > mele-wrapper > mele-body-wrapper > mele-body mele-list[key=logs] > mele-wrapper > mele-body-wrapper mele-body .mele-item.outgoing mele-icon {
  right: 0;
}
[mod=mmodChats] .mele-view[key=log] > mele-wrapper > mele-body-wrapper > mele-body mele-list[key=logs] > mele-wrapper > mele-body-wrapper mele-body .mele-item.outgoing mele-value {
  background: var(--bg3);
}
[mod=mmodChats] .mele-view[key=log] > mele-wrapper > mele-body-wrapper > mele-body mele-list[key=logs] > mele-wrapper > mele-body-wrapper mele-body .mele-item.outgoing mele-value::after {
  right: 8px;
  border-bottom-color: var(--bg3);
}
[mod=mmodChats] .mele-view[key=log] > mele-wrapper > mele-body-wrapper > mele-body mele-list[key=logs] > mele-wrapper > mele-body-wrapper mele-body .mele-item.incoming {
  grid-column: span 3;
  align-items: flex-start;
  padding-left: calc( var(--base_height) + 10px);
}
[mod=mmodChats] .mele-view[key=log] > mele-wrapper > mele-body-wrapper > mele-body mele-list[key=logs] > mele-wrapper > mele-body-wrapper mele-body .mele-item.incoming mele-value::after {
  left: 16px;
  border-bottom-color: var(--bg2);
}
[mod=mmodChats] .mele-view[key=log] > mele-wrapper > mele-body-wrapper > mele-body mele-list[key=logs] > mele-wrapper > mele-body-wrapper mele-body .mele-item.incoming mele-icon {
  left: 0;
}
[mod=mmodChats] .mele-view[key=log] > mele-wrapper > mele-body-wrapper > mele-body mele-list[key=logs] > mele-wrapper > mele-body-wrapper mele-body .mele-item mele-icon {
  position: absolute;
  background: transparent;
}
[mod=mmodChats] .mele-view[key=log] > mele-wrapper > mele-body-wrapper > mele-body mele-list[key=logs] > mele-wrapper > mele-body-wrapper mele-body .mele-item mele-icon > img {
  height: var(--base_height_50);
  width: var(--base_height_50);
}
[mod=mmodChats] .mele-view[key=log] > mele-wrapper > mele-body-wrapper > mele-body mele-list[key=logs] > mele-wrapper > mele-body-wrapper mele-body .mele-item mele-labels {
  order: 10;
  flex-direction: row;
  flex: unset;
  align-items: center;
}
[mod=mmodChats] .mele-view[key=log] > mele-wrapper > mele-body-wrapper > mele-body mele-list[key=logs] > mele-wrapper > mele-body-wrapper mele-body .mele-item mele-labels mele-label, [mod=mmodChats] .mele-view[key=log] > mele-wrapper > mele-body-wrapper > mele-body mele-list[key=logs] > mele-wrapper > mele-body-wrapper mele-body .mele-item mele-labels mele-label2 {
  flex: unset;
  text-transform: uppercase;
  font-size: 12px;
}
[mod=mmodChats] .mele-view[key=log] > mele-wrapper > mele-body-wrapper > mele-body mele-list[key=logs] > mele-wrapper > mele-body-wrapper mele-body .mele-item mele-labels mele-label {
  padding-right: 10px;
}
[mod=mmodChats] .mele-view[key=log] > mele-wrapper > mele-body-wrapper > mele-body mele-list[key=logs] > mele-wrapper > mele-body-wrapper mele-body .mele-item mele-value {
  position: relative;
  margin-top: 8px;
  background: var(--bg2);
  border-radius: 8px;
  padding: 4px 8px;
  order: 20;
  min-width: 18px;
  text-align: center;
}
[mod=mmodChats] .mele-view[key=log] > mele-wrapper > mele-body-wrapper > mele-body mele-list[key=logs] > mele-wrapper > mele-body-wrapper mele-body .mele-item mele-value::after {
  content: " ";
  position: absolute;
  top: 0;
  width: 0;
  height: 0;
  border: 8px solid transparent;
  border-bottom-color: var(--bg2);
  border-top: 0;
  margin-left: -8px;
  margin-top: -7px;
}

[mod=mmodChats][behavior=phone] mele-list[key=logs] > mele-wrapper mele-item mele-label {
  display: none;
}

@media print {
  [mod^=mmodOffice][focused][layout=split] > mele-body {
    flex-direction: column !important;
    align-items: center;
  }
  [mod^=mmodOffice][focused][layout=split] > mele-body > mele-view[key=filter] mele-footer-wrapper {
    display: none;
  }
}
@media print {
  [mod^=mmodOffice][focused][layout=sidesplit] > mele-body > .mele-view:not([key=detail]) {
    display: none !important;
  }
}
[mod=mmodAppBar]:not([roles~=master]) mele-item[key=mmodOfficeAdmin] {
  display: none !important;
}
[mod=mmodAppBar]:not([roles~=master]):not([roles~=admin]):not([roles~=manager]) mele-item[label="office.administration"], [mod=mmodAppBar]:not([roles~=master]):not([roles~=admin]):not([roles~=manager]) mele-item[key=mmodOfficeConnections] {
  display: none !important;
}

* ::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}
* ::-webkit-scrollbar-track {
  background: transparent;
}
* ::-webkit-scrollbar-thumb {
  background: var(--gray);
  border-radius: 0;
}
* ::-webkit-scrollbar-thumb:hover {
  background: var(--gray);
}

body[styleset=new] {
  --spacing: 0px;
  --sidesplit-w: calc( var(--sidebar_width) - 2px);
  --gray-hsl: 0 0% 34%;
  --sidebar_bg: hsl(203, 86%, 27%);
  --sidebar_selected: hsl(203, 86%, 16%);
  --bg_body: rgb(255, 255, 255);
  --bg0: hsl(203, 5%, 95%);
  --bg1: hsl(203, 5%, 100%);
  --bg1_alt: hsl(203, 5%, 97%);
  --bg1_transparent: hsla(203, 5%, 100%, 0.5);
  --bg1_semitransparent: hsla(203, 5%, 100%, 0.85);
  --bg2: hsl(203, 5%, 95%);
  --bg2_transparent: hsla(203, 5%, 95%, 0.5);
  --bg2_semitransparent: hsla(203, 5%, 95%, 0.85);
  --bg3-hsl: 203 5% 90%;
  --bg3: hsl(var(--bg3-hsl));
  --bg3_transparent: hsla(203, 5%, 85%, 0.3);
  --bg3_semitransparent: hsla(203, 5%, 85%, 0.85);
  --bg3_shadow: hsla(203, 5%, 50%, 0.4);
  --fg1: hsl(203, 80%, 5%);
  --fg2-hsl: 203 80% 20%;
  --fg2: hsl(var(--fg2-hsl));
  --fg3: hsl(203, 80%, 50%);
  --blue-hsl: 203 67% 40%;
  --blue: hsl(var(--blue-hsl));
  --lightblue-hsl: 203 67% 50%;
  --lightblue: hsl(var(--lightblue-hsl));
  --darkblue-hsl: 203 67% 15%;
  --darkblue: hsl(var(--darkblue-hsl));
  --header-fg: var(--bg1);
  --header-bg: var(--fg2);
}
body[styleset=new] [key="ACTION:WIPE"] {
  background: var(--red);
  color: var(--white);
}
body[styleset=new] [key="ACTION:WIPE"]::before {
  display: none;
}
body[styleset=new] mele-input[type=geoshape][key=location] > mele-labels {
  display: none;
}
body[styleset=new] .mele-window[behavior=desktop] mele-button, body[styleset=new] .mele-modal[behavior=desktop] mele-button, body[styleset=new] .mele-popup[behavior=desktop] mele-button {
  border-radius: 4px !important;
}
body[styleset=new] .mele-window[behavior=desktop] mele-button::before, body[styleset=new] .mele-modal[behavior=desktop] mele-button::before, body[styleset=new] .mele-popup[behavior=desktop] mele-button::before {
  border-radius: 0px !important;
}
body[styleset=new] .mele-window[behavior=desktop] mele-button[type=action], body[styleset=new] .mele-window[behavior=desktop] mele-button[type=actionbar], body[styleset=new] .mele-window[behavior=desktop] mele-button[type=paging], body[styleset=new] .mele-modal[behavior=desktop] mele-button[type=action], body[styleset=new] .mele-modal[behavior=desktop] mele-button[type=actionbar], body[styleset=new] .mele-modal[behavior=desktop] mele-button[type=paging], body[styleset=new] .mele-popup[behavior=desktop] mele-button[type=action], body[styleset=new] .mele-popup[behavior=desktop] mele-button[type=actionbar], body[styleset=new] .mele-popup[behavior=desktop] mele-button[type=paging] {
  height: calc(var(--base_height) * 1.2);
  padding: 0px 10px;
  margin: 3px 6px;
}
body[styleset=new] .mele-window[behavior=desktop] mele-button[disabled], body[styleset=new] .mele-modal[behavior=desktop] mele-button[disabled], body[styleset=new] .mele-popup[behavior=desktop] mele-button[disabled] {
  opacity: 0.5;
}
body[styleset=new] .mele-window[behavior=desktop] mele-button mele-icon > svg, body[styleset=new] .mele-window[behavior=desktop] mele-button mele-button[type=actionbar] mele-icon > img, body[styleset=new] .mele-modal[behavior=desktop] mele-button mele-icon > svg, body[styleset=new] .mele-modal[behavior=desktop] mele-button mele-button[type=actionbar] mele-icon > img, body[styleset=new] .mele-popup[behavior=desktop] mele-button mele-icon > svg, body[styleset=new] .mele-popup[behavior=desktop] mele-button mele-button[type=actionbar] mele-icon > img {
  height: var(--small_height);
  width: var(--small_height);
}
body[styleset=new] .mele-window[behavior=desktop] {
  background: var(--bg_body);
}
body[styleset=new] .mele-window[behavior=desktop] > mele-body {
  margin: var(--spacing);
}
body[styleset=new] .mele-window[behavior=desktop] .mele-tabs[direction=horizontal] > mele-wrapper > mele-tabs-wrapper > .mele-list:not([show=selected]):not([readonly]):not(.noselect) > mele-wrapper > mele-body-wrapper > mele-body > .mele-item > mele-value::before {
  content: "(";
}
body[styleset=new] .mele-window[behavior=desktop] .mele-tabs[direction=horizontal] > mele-wrapper > mele-tabs-wrapper > .mele-list:not([show=selected]):not([readonly]):not(.noselect) > mele-wrapper > mele-body-wrapper > mele-body > .mele-item > mele-value::after {
  content: ")";
}
body[styleset=new] .mele-window[behavior=desktop][layout=sidesplit] > mele-body {
  height: calc(100% - (var(--spacing) * 2));
  width: calc(100% - (var(--spacing) * 2));
}
body[styleset=new] .mele-window[behavior=desktop] .mele-input[type=image] mele-value-content {
  justify-content: end !important;
  margin: 0 auto;
}
body[styleset=new] .mele-window[behavior=desktop] > mele-button[key=viewback] {
  left: 10px;
  top: 10px;
}
body[styleset=new] .mele-window[behavior=desktop] [role~=narrow] .mele-input[split="1:3"] > mele-value {
  flex: 2 !important;
}
body[styleset=new] .mele-window[behavior=desktop] .mele-view[view]:not([key=appbar]) {
  margin: var(--spacing);
  box-sizing: border-box;
  box-shadow: 0 1px 2px 1px rgba(0, 0, 0, 0.05);
}
body[styleset=new] .mele-window[behavior=desktop] .mele-view[view]:not([key=appbar])[layout][role] {
  background: var(--white) !important;
}
body[styleset=new] .mele-window[behavior=desktop] .mele-view[view]:not([key=appbar]) > mele-wrapper > mele-header-wrapper .mele-button[key=CLOSE] svg *[stroke=fg] {
  stroke: white;
}
body[styleset=new] .mele-window[behavior=desktop] .mele-view[view]:not([key=appbar]) > mele-wrapper > mele-header-wrapper .mele-button[iconleft="sys.close"] svg *[stroke=fg] {
  stroke: white;
}
body[styleset=new] .mele-window[behavior=desktop] .mele-view[view]:not([key=appbar]) > mele-wrapper > mele-header-wrapper > *:not(:empty):not(.empty) {
  background: var(--header-bg);
  color: var(--white);
  border-bottom: 1px solid var(--bg3);
  box-sizing: content-box;
  box-shadow: none;
}
body[styleset=new] .mele-window[behavior=desktop] .mele-view[view]:not([key=appbar]) > mele-wrapper > mele-header-wrapper > *:not(:empty):not(.empty)[key=search] {
  border-top: none;
  background: var(--white);
  padding: var(--spacing) 0;
}
body[styleset=new] .mele-window[behavior=desktop] .mele-view[view]:not([key=appbar]) > mele-wrapper > mele-header-wrapper > *:not(:empty):not(.empty) > mele-header-texts > mele-header-text {
  font-family: var(--font_semibold);
  font-size: var(--font2);
}
body[styleset=new] .mele-window[behavior=desktop] .mele-view[view]:not([key=appbar]) > mele-wrapper > mele-header-wrapper > *:not(:empty):not(.empty) > mele-header-texts > mele-header-text:nth-of-type(2) {
  color: var(--white);
}
body[styleset=new] .mele-window[behavior=desktop] .mele-view[view]:not([key=appbar]) > mele-wrapper > mele-header-wrapper > mele-header > mele-button > mele-icon *[stroke=fg] {
  stroke: var(--white) !important;
}
body[styleset=new] .mele-window[behavior=desktop] .mele-view[view]:not([key=appbar]) > mele-wrapper > mele-header-wrapper > mele-header > mele-button > mele-icon *[fill=fg] {
  fill: var(--white) !important;
}
body[styleset=new] .mele-window[behavior=desktop] .mele-view[view]:not([key=appbar]) > mele-wrapper > mele-header-wrapper > mele-header > mele-button[action=new] > mele-icon {
  background: var(--blue);
}
body[styleset=new] .mele-window[behavior=desktop] .mele-view[view]:not([key=appbar]) > mele-wrapper > mele-header-wrapper > mele-header > mele-button[action=new] > mele-icon *[stroke=fg] {
  stroke: var(--white) !important;
}
body[styleset=new] .mele-window[behavior=desktop] .mele-view[view]:not([key=appbar]) mele-input.mele-item.mele-button.mele-input mele-labels {
  align-items: flex-end;
}
body[styleset=new] .mele-window[behavior=desktop] .mele-view[view]:not([key=appbar]) mele-input.mele-item.mele-button.mele-input mele-labels mele-label {
  text-align: right;
  padding-right: 25px !important;
  font-size: var(--font2);
  color: var(--gray);
}
body[styleset=new] .mele-window[behavior=desktop] .mele-view[view]:not([key=appbar]) mele-input.mele-item.mele-button.mele-input mele-labels mele-label2 {
  text-align: right;
  text-transform: uppercase;
  font-family: var(--font_light);
  padding-right: 25px !important;
  color: var(--gray);
}
body[styleset=new] .mele-window[behavior=desktop] .mele-table[view] {
  height: initial !important;
}
body[styleset=new] .mele-window[behavior=desktop] .mele-table[view] mele-header[key=columns] th {
  font-family: var(--font_semibold) !important;
  text-transform: initial;
  font-size: var(--font2);
}
body[styleset=new] .mele-window[behavior=desktop] .mele-table[view] mele-row td, body[styleset=new] .mele-window[behavior=desktop] .mele-table[view] mele-row-hidden td {
  height: calc(var(--base_height) * 0.7);
  font-size: var(--font2);
}
body[styleset=new] mele-window.mele-window.mele-container[mod=mmodQuickBar][behavior=desktop] > mele-body > div {
  justify-content: space-between;
  box-shadow: 1px 2px 2px 1px rgba(0, 0, 0, 0.05);
  height: 50px;
}
body[styleset=new] mele-window.mele-window.mele-container[mod=mmodQuickBar][behavior=desktop] > mele-body > div .left > [key=theme],
body[styleset=new] mele-window.mele-window.mele-container[mod=mmodQuickBar][behavior=desktop] > mele-body > div .left > [key=behavior],
body[styleset=new] mele-window.mele-window.mele-container[mod=mmodQuickBar][behavior=desktop] > mele-body > div .right > [key=status],
body[styleset=new] mele-window.mele-window.mele-container[mod=mmodQuickBar][behavior=desktop] > mele-body > div .right > [key=callsign],
body[styleset=new] mele-window.mele-window.mele-container[mod=mmodQuickBar][behavior=desktop] > mele-body > div .right > [key=sign_in] {
  display: none;
}
body[styleset=new] mele-window.mele-window.mele-container[mod=mmodQuickBar][behavior=desktop] > mele-body > div [key=language] {
  display: none;
}
body[styleset=new] .mele-window[behavior=desktop][layout=split] [role~=left],
body[styleset=new] .mele-window[behavior=desktop][layout=split] [role~=right] {
  border-radius: 0px;
  border: none !important;
}
body[styleset=new] .mele-window[behavior=desktop][layout=sidesplit] > mele-body > [view][role~=left] {
  bottom: 0;
  height: unset;
}
body[styleset=new] .mele-window[behavior=desktop][layout=sidesplit] > mele-body > [view][role~=bottom] {
  height: 70%;
}
body[styleset=new] .mele-window[behavior=desktop][layout=sidesplit] > mele-body > [view][role~=top],
body[styleset=new] .mele-window[behavior=desktop][layout=sidesplit] > mele-body > [view][role~=bottom] {
  margin-left: var(--sidesplit-w);
}
body[styleset=new] [view][key=filter] > mele-wrapper > mele-body-wrapper > mele-body {
  padding-top: 20px;
}
body[styleset=new] [mod=mmodAppBar][behavior=desktop] > mele-body {
  border-right: none;
  margin: 0;
}
body[styleset=new] [mod=mmodAppBar][behavior=desktop] > mele-body > mele-image[key=logo] {
  height: 50px;
  background: var(--sidebar_bg);
  padding: 8px;
  padding-left: 15px;
}
body[styleset=new] [mod=mmodAppBar][behavior=desktop] > mele-body > mele-image[key=logo] > svg {
  height: 50px;
  display: flex;
}
body[styleset=new] [mod=mmodAppBar][behavior=desktop] > mele-body > mele-image[key=logo] * {
  fill: var(--white);
}
body[styleset=new] [mod=mmodAppBar][behavior=desktop] > mele-body [key=appbar] {
  margin: 0;
  background: var(--sidebar_bg);
}
body[styleset=new] [mod=mmodAppBar][behavior=desktop] > mele-body [key=appbar] > mele-wrapper > mele-body-wrapper > mele-body > * [stroke=fg] {
  stroke: var(--bg3) !important;
  fill: none !important;
}
body[styleset=new] [mod=mmodAppBar][behavior=desktop] > mele-body [key=appbar] > mele-wrapper > mele-body-wrapper > mele-body > * [stroke=bg] {
  stroke: var(--sidebar_bg) !important;
}
body[styleset=new] [mod=mmodAppBar][behavior=desktop] > mele-body [key=appbar] > mele-wrapper > mele-body-wrapper > mele-body > * [fill=fg] {
  fill: WHITE !important;
}
body[styleset=new] [mod=mmodAppBar][behavior=desktop] > mele-body [key=appbar] > mele-wrapper > mele-body-wrapper > mele-body > mele-item:not([key]) {
  border-top: none;
  min-height: 50px;
  pointer-events: none;
}
body[styleset=new] [mod=mmodAppBar][behavior=desktop] > mele-body [key=appbar] > mele-wrapper > mele-body-wrapper > mele-body > mele-item:not([key]):not(:first-of-type) {
  margin-top: 10px !important;
  border-top: 2px solid var(--sidebar_selected);
}
body[styleset=new] [mod=mmodAppBar][behavior=desktop] > mele-body [key=appbar] > mele-wrapper > mele-body-wrapper > mele-body > mele-item:not([key]) > mele-labels {
  padding: 20px;
}
body[styleset=new] [mod=mmodAppBar][behavior=desktop] > mele-body [key=appbar] > mele-wrapper > mele-body-wrapper > mele-body > mele-item:not([key]) > mele-labels > mele-label {
  color: var(--bg3) !important;
  opacity: 0.4;
  font-size: var(--font2);
}
body[styleset=new] [mod=mmodAppBar][behavior=desktop] > mele-body [key=appbar] > mele-wrapper > mele-body-wrapper > mele-body > mele-item[key] {
  flex-direction: row;
  height: 40px;
  min-height: 40px;
}
body[styleset=new] [mod=mmodAppBar][behavior=desktop] > mele-body [key=appbar] > mele-wrapper > mele-body-wrapper > mele-body > mele-item[key] > mele-labels {
  padding-bottom: 0;
}
body[styleset=new] [mod=mmodAppBar][behavior=desktop] > mele-body [key=appbar] > mele-wrapper > mele-body-wrapper > mele-body > mele-item[key] > mele-labels mele-label {
  color: var(--bg3) !important;
  font-family: var(--font_semibold);
  font-size: var(--font2);
  line-height: var(--font2);
}
body[styleset=new] [mod=mmodAppBar][behavior=desktop] > mele-body [key=appbar] > mele-wrapper > mele-body-wrapper > mele-body > mele-item[key] mele-icon {
  height: 28px !important;
  width: 28px !important;
  padding: 0 10px;
}
body[styleset=new] [mod=mmodAppBar][behavior=desktop] > mele-body [key=appbar] > mele-wrapper > mele-body-wrapper > mele-body > *[selected] {
  background: var(--sidebar_selected) !important;
}
body[styleset=new] [mod=mmodAppBar][behavior=desktop] > mele-body [key=appbar] > mele-wrapper > mele-body-wrapper > mele-body > *[selected] [stroke=fg] {
  stroke: var(--white) !important;
}
body[styleset=new] [mod=mmodAppBar][behavior=desktop] > mele-body [key=appbar] > mele-wrapper > mele-body-wrapper > mele-body > *[selected] > * [stroke=bg] {
  stroke: var(--sidebar_selected) !important;
}
body[styleset=new] [mod=mmodAppBar][behavior=desktop] > mele-body [key=appbar] > mele-wrapper > mele-body-wrapper > mele-body > *[selected] > * [fill=fg] {
  fill: WHITE !important;
}
body[styleset=new] [mod=mmodWiki] mele-view[view] {
  max-width: 1024px;
}
body[styleset=new] [mod=mmodWiki] mele-view[view] > mele-wrapper > mele-body-wrapper > mele-body {
  font-size: var(--font2);
  justify-content: flex-start;
  padding: 20px;
}
body[styleset=new] [mod=mmodWiki] mele-view[view] > mele-wrapper > mele-body-wrapper > mele-body h1, body[styleset=new] [mod=mmodWiki] mele-view[view] > mele-wrapper > mele-body-wrapper > mele-body h2, body[styleset=new] [mod=mmodWiki] mele-view[view] > mele-wrapper > mele-body-wrapper > mele-body h3 {
  color: var(--blue);
}
body[styleset=new] [mod=mmodWiki] mele-view[view] > mele-wrapper > mele-body-wrapper > mele-body > * {
  width: 100%;
}
body[styleset=new] [mod=mmodOfficeWiki] [key=core_header] {
  min-height: 40px !important;
}
body[styleset=new] [mod=mmodOfficeWiki] [key=core_header] .mele-button {
  height: 100%;
}
body[styleset=new] [mod=mmodOfficeWiki] [key=core_header] .mele-button mele-icon {
  height: 100%;
}
body[styleset=new] [mod=mmodOfficeWiki] .wf-wiki-list mele-item.mele-button {
  padding-left: 7px;
  margin-left: 3px;
  justify-content: end;
}
body[styleset=new] [mod=mmodOfficeWiki] .wf-wiki-list mele-item.mele-button mele-label, body[styleset=new] [mod=mmodOfficeWiki] .wf-wiki-list mele-item.mele-button mele-label2 {
  white-space: pre;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
  display: inline;
}
body[styleset=new] [mod=mmodOfficeWiki] [key=body] mele-value {
  width: 100%;
}
body[styleset=new] [mod=mmodChats] > mele-body > mele-list[key=detail] > mele-wrapper mele-footer[key=compose] {
  border-top: none;
}
body[styleset=new] [mod=mmodChats] > mele-body > mele-list[key=detail] > mele-wrapper mele-footer[key=offline] {
  border-top: none;
  background: var(--bginvalid);
  color: var(--fginvalid);
}
body[styleset=new] [mod=mmodChats] > mele-body > mele-list[key=detail] > mele-wrapper > mele-body-wrapper > mele-body {
  display: flex;
}
body[styleset=new] [mod=mmodChats] > mele-body > mele-list[key=detail] > mele-wrapper > mele-body-wrapper > mele-body .mele-item {
  display: grid;
  margin: 5px 0;
  max-width: 70%;
  row-gap: 2px;
  column-gap: 6px;
}
body[styleset=new] [mod=mmodChats] > mele-body > mele-list[key=detail] > mele-wrapper > mele-body-wrapper > mele-body .mele-item.outgoing {
  align-self: flex-end;
  grid-template-areas: "message icon" "time icon";
}
body[styleset=new] [mod=mmodChats] > mele-body > mele-list[key=detail] > mele-wrapper > mele-body-wrapper > mele-body .mele-item.outgoing mele-value {
  background: var(--green);
  color: var(--white);
}
body[styleset=new] [mod=mmodChats] > mele-body > mele-list[key=detail] > mele-wrapper > mele-body-wrapper > mele-body .mele-item.outgoing mele-labels {
  align-items: flex-end;
}
body[styleset=new] [mod=mmodChats] > mele-body > mele-list[key=detail] > mele-wrapper > mele-body-wrapper > mele-body .mele-item.incoming {
  align-self: flex-start;
  grid-template-areas: "icon message" "icon time";
}
body[styleset=new] [mod=mmodChats] > mele-body > mele-list[key=detail] > mele-wrapper > mele-body-wrapper > mele-body .mele-item.incoming mele-value {
  background: var(--bg2);
}
body[styleset=new] [mod=mmodChats] > mele-body > mele-list[key=detail] > mele-wrapper > mele-body-wrapper > mele-body .mele-item.incoming mele-labels {
  align-items: flex-start;
}
body[styleset=new] [mod=mmodChats] > mele-body > mele-list[key=detail] > mele-wrapper > mele-body-wrapper > mele-body .mele-item mele-labels {
  grid-area: time;
  align-items: center;
}
body[styleset=new] [mod=mmodChats] > mele-body > mele-list[key=detail] > mele-wrapper > mele-body-wrapper > mele-body .mele-item mele-labels mele-label {
  font-size: var(--font3);
}
body[styleset=new] [mod=mmodChats] > mele-body > mele-list[key=detail] > mele-wrapper > mele-body-wrapper > mele-body .mele-item mele-value {
  grid-area: message;
  text-align: left;
  border-radius: 10px;
  min-height: var(--base_height_50);
  align-items: center;
  display: flex;
  padding: 5px 10px;
  font-size: var(--font2);
  line-height: 1.367rem;
}
body[styleset=new] [mod=mmodChats] > mele-body > mele-list[key=detail] > mele-wrapper > mele-body-wrapper > mele-body .mele-item mele-icon {
  grid-area: icon;
  background: var(--bg3);
  border-radius: 50%;
}
body[styleset=new] [mod=mmodChats] > mele-body > mele-list[key=detail] > mele-wrapper > mele-body-wrapper > mele-body .mele-item mele-icon > img {
  height: var(--base_height);
  width: var(--base_height);
  border-radius: 50%;
}

[mod=mmodAppBar][behavior=desktop] > mele-body [key=appbar] > mele-wrapper {
  flex-direction: column-reverse;
}
[mod=mmodAppBar][behavior=desktop] > mele-body [key=appbar] > mele-wrapper > mele-footer-wrapper {
  display: flex;
  flex-direction: row;
  position: relative;
  background: gray !important;
  padding: 4px 10px;
}
[mod=mmodAppBar][behavior=desktop] > mele-body [key=appbar] > mele-wrapper > mele-footer-wrapper [key=statusbox] {
  background: none !important;
  width: 100%;
  align-items: flex-start;
}
[mod=mmodAppBar][behavior=desktop] > mele-body [key=appbar] > mele-wrapper > mele-footer-wrapper [key=statusbox] [key=status] {
  display: none;
}
[mod=mmodAppBar][behavior=desktop] > mele-body [key=appbar] > mele-wrapper > mele-footer-wrapper [key=statusbox] [key=callsign] {
  text-align: left;
  font-size: var(--font2);
}
[mod=mmodAppBar][behavior=desktop] > mele-body [key=appbar] > mele-wrapper > mele-footer-wrapper [key=statusbox] [key=login] {
  text-align: left;
  font-size: var(--font3);
}
[mod=mmodAppBar][behavior=desktop] > mele-body [key=appbar] > mele-wrapper > mele-footer-wrapper [key=indicators] {
  width: unset;
  display: flex;
}
[mod=mmodAppBar][behavior=desktop] > mele-body [key=appbar] > mele-wrapper > mele-footer-wrapper [key=indicators] > [key=online] {
  padding: 0 4px;
}
[mod=mmodAppBar][behavior=desktop] > mele-body [key=appbar] > mele-wrapper > mele-footer-wrapper [key=indicators] > [key=online] mele-image {
  width: calc(var(--base_height) * 0.9) !important;
  height: calc(var(--base_height) * 0.9) !important;
}
[mod=mmodAppBar][behavior=desktop] > mele-body [key=appbar] > mele-wrapper > mele-footer-wrapper [key=indicators] > [key=online] mele-image svg {
  width: calc(var(--base_height) * 0.9) !important;
  height: calc(var(--base_height) * 0.9) !important;
}
[mod=mmodAppBar][behavior=desktop] > mele-body [key=appbar] > mele-wrapper > mele-footer-wrapper [key=indicators] > *:not([key=online]) {
  display: none;
}
[mod=mmodAppBar][behavior=desktop] > mele-body [key=appbar] > mele-wrapper > mele-footer-wrapper [key=indicators] .input-wrapper {
  width: auto;
}

.input-wrapper {
  --input-padding: 4px;
  --image-clear-display: none;
}
.input-wrapper[label]:not([split]) {
  grid-template-areas: "labels value";
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
